/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Qt = function(n) {
  const e = [];
  let t = 0;
  for (let r = 0; r < n.length; r++) {
    let i = n.charCodeAt(r);
    i < 128 ? e[t++] = i : i < 2048 ? (e[t++] = i >> 6 | 192, e[t++] = i & 63 | 128) : (i & 64512) === 55296 && r + 1 < n.length && (n.charCodeAt(r + 1) & 64512) === 56320 ? (i = 65536 + ((i & 1023) << 10) + (n.charCodeAt(++r) & 1023), e[t++] = i >> 18 | 240, e[t++] = i >> 12 & 63 | 128, e[t++] = i >> 6 & 63 | 128, e[t++] = i & 63 | 128) : (e[t++] = i >> 12 | 224, e[t++] = i >> 6 & 63 | 128, e[t++] = i & 63 | 128);
  }
  return e;
}, Wn = function(n) {
  const e = [];
  let t = 0, r = 0;
  for (; t < n.length; ) {
    const i = n[t++];
    if (i < 128)
      e[r++] = String.fromCharCode(i);
    else if (i > 191 && i < 224) {
      const s = n[t++];
      e[r++] = String.fromCharCode((i & 31) << 6 | s & 63);
    } else if (i > 239 && i < 365) {
      const s = n[t++], o = n[t++], a = n[t++], c = ((i & 7) << 18 | (s & 63) << 12 | (o & 63) << 6 | a & 63) - 65536;
      e[r++] = String.fromCharCode(55296 + (c >> 10)), e[r++] = String.fromCharCode(56320 + (c & 1023));
    } else {
      const s = n[t++], o = n[t++];
      e[r++] = String.fromCharCode((i & 15) << 12 | (s & 63) << 6 | o & 63);
    }
  }
  return e.join("");
}, Xt = {
  /**
   * Maps bytes to characters.
   */
  byteToCharMap_: null,
  /**
   * Maps characters to bytes.
   */
  charToByteMap_: null,
  /**
   * Maps bytes to websafe characters.
   * @private
   */
  byteToCharMapWebSafe_: null,
  /**
   * Maps websafe characters to bytes.
   * @private
   */
  charToByteMapWebSafe_: null,
  /**
   * Our default alphabet, shared between
   * ENCODED_VALS and ENCODED_VALS_WEBSAFE
   */
  ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
  /**
   * Our default alphabet. Value 64 (=) is special; it means "nothing."
   */
  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + "+/=";
  },
  /**
   * Our websafe alphabet.
   */
  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + "-_.";
  },
  /**
   * Whether this browser supports the atob and btoa functions. This extension
   * started at Mozilla but is now implemented by many browsers. We use the
   * ASSUME_* variables to avoid pulling in the full useragent detection library
   * but still allowing the standard per-browser compilations.
   *
   */
  HAS_NATIVE_SUPPORT: typeof atob == "function",
  /**
   * Base64-encode an array of bytes.
   *
   * @param input An array of bytes (numbers with
   *     value in [0, 255]) to encode.
   * @param webSafe Boolean indicating we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeByteArray(n, e) {
    if (!Array.isArray(n))
      throw Error("encodeByteArray takes an array as a parameter");
    this.init_();
    const t = e ? this.byteToCharMapWebSafe_ : this.byteToCharMap_, r = [];
    for (let i = 0; i < n.length; i += 3) {
      const s = n[i], o = i + 1 < n.length, a = o ? n[i + 1] : 0, c = i + 2 < n.length, u = c ? n[i + 2] : 0, y = s >> 2, b = (s & 3) << 4 | a >> 4;
      let A = (a & 15) << 2 | u >> 6, O = u & 63;
      c || (O = 64, o || (A = 64)), r.push(t[y], t[b], t[A], t[O]);
    }
    return r.join("");
  },
  /**
   * Base64-encode a string.
   *
   * @param input A string to encode.
   * @param webSafe If true, we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeString(n, e) {
    return this.HAS_NATIVE_SUPPORT && !e ? btoa(n) : this.encodeByteArray(Qt(n), e);
  },
  /**
   * Base64-decode a string.
   *
   * @param input to decode.
   * @param webSafe True if we should use the
   *     alternative alphabet.
   * @return string representing the decoded value.
   */
  decodeString(n, e) {
    return this.HAS_NATIVE_SUPPORT && !e ? atob(n) : Wn(this.decodeStringToByteArray(n, e));
  },
  /**
   * Base64-decode a string.
   *
   * In base-64 decoding, groups of four characters are converted into three
   * bytes.  If the encoder did not apply padding, the input length may not
   * be a multiple of 4.
   *
   * In this case, the last group will have fewer than 4 characters, and
   * padding will be inferred.  If the group has one or two characters, it decodes
   * to one byte.  If the group has three characters, it decodes to two bytes.
   *
   * @param input Input to decode.
   * @param webSafe True if we should use the web-safe alphabet.
   * @return bytes representing the decoded value.
   */
  decodeStringToByteArray(n, e) {
    this.init_();
    const t = e ? this.charToByteMapWebSafe_ : this.charToByteMap_, r = [];
    for (let i = 0; i < n.length; ) {
      const s = t[n.charAt(i++)], a = i < n.length ? t[n.charAt(i)] : 0;
      ++i;
      const u = i < n.length ? t[n.charAt(i)] : 64;
      ++i;
      const b = i < n.length ? t[n.charAt(i)] : 64;
      if (++i, s == null || a == null || u == null || b == null)
        throw new zn();
      const A = s << 2 | a >> 4;
      if (r.push(A), u !== 64) {
        const O = a << 4 & 240 | u >> 2;
        if (r.push(O), b !== 64) {
          const N = u << 6 & 192 | b;
          r.push(N);
        }
      }
    }
    return r;
  },
  /**
   * Lazy static initialization function. Called before
   * accessing any of the static map variables.
   * @private
   */
  init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};
      for (let n = 0; n < this.ENCODED_VALS.length; n++)
        this.byteToCharMap_[n] = this.ENCODED_VALS.charAt(n), this.charToByteMap_[this.byteToCharMap_[n]] = n, this.byteToCharMapWebSafe_[n] = this.ENCODED_VALS_WEBSAFE.charAt(n), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[n]] = n, n >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(n)] = n, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(n)] = n);
    }
  }
};
class zn extends Error {
  constructor() {
    super(...arguments), this.name = "DecodeBase64StringError";
  }
}
const qn = function(n) {
  const e = Qt(n);
  return Xt.encodeByteArray(e, !0);
}, Zt = function(n) {
  return qn(n).replace(/\./g, "");
}, en = function(n) {
  try {
    return Xt.decodeString(n, !0);
  } catch (e) {
    console.error("base64Decode failed: ", e);
  }
  return null;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Jn() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Gn = () => Jn().__FIREBASE_DEFAULTS__, Kn = () => {
  if (typeof process > "u" || typeof process.env > "u")
    return;
  const n = process.env.__FIREBASE_DEFAULTS__;
  if (n)
    return JSON.parse(n);
}, Yn = () => {
  if (typeof document > "u")
    return;
  let n;
  try {
    n = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
  } catch {
    return;
  }
  const e = n && en(n[1]);
  return e && JSON.parse(e);
}, at = () => {
  try {
    return Gn() || Kn() || Yn();
  } catch (n) {
    console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${n}`);
    return;
  }
}, Qn = (n) => {
  var e, t;
  return (t = (e = at()) === null || e === void 0 ? void 0 : e.emulatorHosts) === null || t === void 0 ? void 0 : t[n];
}, tn = () => {
  var n;
  return (n = at()) === null || n === void 0 ? void 0 : n.config;
}, nn = (n) => {
  var e;
  return (e = at()) === null || e === void 0 ? void 0 : e[`_${n}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Xn {
  constructor() {
    this.reject = () => {
    }, this.resolve = () => {
    }, this.promise = new Promise((e, t) => {
      this.resolve = e, this.reject = t;
    });
  }
  /**
   * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
   * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
   * and returns a node-style callback which will resolve or reject the Deferred's promise.
   */
  wrapCallback(e) {
    return (t, r) => {
      t ? this.reject(t) : this.resolve(r), typeof e == "function" && (this.promise.catch(() => {
      }), e.length === 1 ? e(t) : e(t, r));
    };
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function P() {
  return typeof navigator < "u" && typeof navigator.userAgent == "string" ? navigator.userAgent : "";
}
function Zn() {
  return typeof window < "u" && // @ts-ignore Setting up an broadly applicable index signature for Window
  // just to deal with this case would probably be a bad idea.
  !!(window.cordova || window.phonegap || window.PhoneGap) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(P());
}
function er() {
  const n = typeof chrome == "object" ? chrome.runtime : typeof browser == "object" ? browser.runtime : void 0;
  return typeof n == "object" && n.id !== void 0;
}
function tr() {
  return typeof navigator == "object" && navigator.product === "ReactNative";
}
function nr() {
  const n = P();
  return n.indexOf("MSIE ") >= 0 || n.indexOf("Trident/") >= 0;
}
function rr() {
  try {
    return typeof indexedDB == "object";
  } catch {
    return !1;
  }
}
function ir() {
  return new Promise((n, e) => {
    try {
      let t = !0;
      const r = "validate-browser-context-for-indexeddb-analytics-module", i = self.indexedDB.open(r);
      i.onsuccess = () => {
        i.result.close(), t || self.indexedDB.deleteDatabase(r), n(!0);
      }, i.onupgradeneeded = () => {
        t = !1;
      }, i.onerror = () => {
        var s;
        e(((s = i.error) === null || s === void 0 ? void 0 : s.message) || "");
      };
    } catch (t) {
      e(t);
    }
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const sr = "FirebaseError";
class Z extends Error {
  constructor(e, t, r) {
    super(t), this.code = e, this.customData = r, this.name = sr, Object.setPrototypeOf(this, Z.prototype), Error.captureStackTrace && Error.captureStackTrace(this, be.prototype.create);
  }
}
class be {
  constructor(e, t, r) {
    this.service = e, this.serviceName = t, this.errors = r;
  }
  create(e, ...t) {
    const r = t[0] || {}, i = `${this.service}/${e}`, s = this.errors[e], o = s ? or(s, r) : "Error", a = `${this.serviceName}: ${o} (${i}).`;
    return new Z(i, a, r);
  }
}
function or(n, e) {
  return n.replace(ar, (t, r) => {
    const i = e[r];
    return i != null ? String(i) : `<${r}?>`;
  });
}
const ar = /\{\$([^}]+)}/g;
function cr(n) {
  for (const e in n)
    if (Object.prototype.hasOwnProperty.call(n, e))
      return !1;
  return !0;
}
function ke(n, e) {
  if (n === e)
    return !0;
  const t = Object.keys(n), r = Object.keys(e);
  for (const i of t) {
    if (!r.includes(i))
      return !1;
    const s = n[i], o = e[i];
    if (vt(s) && vt(o)) {
      if (!ke(s, o))
        return !1;
    } else if (s !== o)
      return !1;
  }
  for (const i of r)
    if (!t.includes(i))
      return !1;
  return !0;
}
function vt(n) {
  return n !== null && typeof n == "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ie(n) {
  const e = [];
  for (const [t, r] of Object.entries(n))
    Array.isArray(r) ? r.forEach((i) => {
      e.push(encodeURIComponent(t) + "=" + encodeURIComponent(i));
    }) : e.push(encodeURIComponent(t) + "=" + encodeURIComponent(r));
  return e.length ? "&" + e.join("&") : "";
}
function fe(n) {
  const e = {};
  return n.replace(/^\?/, "").split("&").forEach((r) => {
    if (r) {
      const [i, s] = r.split("=");
      e[decodeURIComponent(i)] = decodeURIComponent(s);
    }
  }), e;
}
function pe(n) {
  const e = n.indexOf("?");
  if (!e)
    return "";
  const t = n.indexOf("#", e);
  return n.substring(e, t > 0 ? t : void 0);
}
function lr(n, e) {
  const t = new dr(n, e);
  return t.subscribe.bind(t);
}
class dr {
  /**
   * @param executor Function which can make calls to a single Observer
   *     as a proxy.
   * @param onNoObservers Callback when count of Observers goes to zero.
   */
  constructor(e, t) {
    this.observers = [], this.unsubscribes = [], this.observerCount = 0, this.task = Promise.resolve(), this.finalized = !1, this.onNoObservers = t, this.task.then(() => {
      e(this);
    }).catch((r) => {
      this.error(r);
    });
  }
  next(e) {
    this.forEachObserver((t) => {
      t.next(e);
    });
  }
  error(e) {
    this.forEachObserver((t) => {
      t.error(e);
    }), this.close(e);
  }
  complete() {
    this.forEachObserver((e) => {
      e.complete();
    }), this.close();
  }
  /**
   * Subscribe function that can be used to add an Observer to the fan-out list.
   *
   * - We require that no event is sent to a subscriber sychronously to their
   *   call to subscribe().
   */
  subscribe(e, t, r) {
    let i;
    if (e === void 0 && t === void 0 && r === void 0)
      throw new Error("Missing Observer.");
    ur(e, [
      "next",
      "error",
      "complete"
    ]) ? i = e : i = {
      next: e,
      error: t,
      complete: r
    }, i.next === void 0 && (i.next = We), i.error === void 0 && (i.error = We), i.complete === void 0 && (i.complete = We);
    const s = this.unsubscribeOne.bind(this, this.observers.length);
    return this.finalized && this.task.then(() => {
      try {
        this.finalError ? i.error(this.finalError) : i.complete();
      } catch {
      }
    }), this.observers.push(i), s;
  }
  // Unsubscribe is synchronous - we guarantee that no events are sent to
  // any unsubscribed Observer.
  unsubscribeOne(e) {
    this.observers === void 0 || this.observers[e] === void 0 || (delete this.observers[e], this.observerCount -= 1, this.observerCount === 0 && this.onNoObservers !== void 0 && this.onNoObservers(this));
  }
  forEachObserver(e) {
    if (!this.finalized)
      for (let t = 0; t < this.observers.length; t++)
        this.sendOne(t, e);
  }
  // Call the Observer via one of it's callback function. We are careful to
  // confirm that the observe has not been unsubscribed since this asynchronous
  // function had been queued.
  sendOne(e, t) {
    this.task.then(() => {
      if (this.observers !== void 0 && this.observers[e] !== void 0)
        try {
          t(this.observers[e]);
        } catch (r) {
          typeof console < "u" && console.error && console.error(r);
        }
    });
  }
  close(e) {
    this.finalized || (this.finalized = !0, e !== void 0 && (this.finalError = e), this.task.then(() => {
      this.observers = void 0, this.onNoObservers = void 0;
    }));
  }
}
function ur(n, e) {
  if (typeof n != "object" || n === null)
    return !1;
  for (const t of e)
    if (t in n && typeof n[t] == "function")
      return !0;
  return !1;
}
function We() {
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function x(n) {
  return n && n._delegate ? n._delegate : n;
}
class de {
  /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */
  constructor(e, t, r) {
    this.name = e, this.instanceFactory = t, this.type = r, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
  }
  setInstantiationMode(e) {
    return this.instantiationMode = e, this;
  }
  setMultipleInstances(e) {
    return this.multipleInstances = e, this;
  }
  setServiceProps(e) {
    return this.serviceProps = e, this;
  }
  setInstanceCreatedCallback(e) {
    return this.onInstanceCreated = e, this;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const te = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class hr {
  constructor(e, t) {
    this.name = e, this.container = t, this.component = null, this.instances = /* @__PURE__ */ new Map(), this.instancesDeferred = /* @__PURE__ */ new Map(), this.instancesOptions = /* @__PURE__ */ new Map(), this.onInitCallbacks = /* @__PURE__ */ new Map();
  }
  /**
   * @param identifier A provider can provide mulitple instances of a service
   * if this.component.multipleInstances is true.
   */
  get(e) {
    const t = this.normalizeInstanceIdentifier(e);
    if (!this.instancesDeferred.has(t)) {
      const r = new Xn();
      if (this.instancesDeferred.set(t, r), this.isInitialized(t) || this.shouldAutoInitialize())
        try {
          const i = this.getOrInitializeService({
            instanceIdentifier: t
          });
          i && r.resolve(i);
        } catch {
        }
    }
    return this.instancesDeferred.get(t).promise;
  }
  getImmediate(e) {
    var t;
    const r = this.normalizeInstanceIdentifier(e == null ? void 0 : e.identifier), i = (t = e == null ? void 0 : e.optional) !== null && t !== void 0 ? t : !1;
    if (this.isInitialized(r) || this.shouldAutoInitialize())
      try {
        return this.getOrInitializeService({
          instanceIdentifier: r
        });
      } catch (s) {
        if (i)
          return null;
        throw s;
      }
    else {
      if (i)
        return null;
      throw Error(`Service ${this.name} is not available`);
    }
  }
  getComponent() {
    return this.component;
  }
  setComponent(e) {
    if (e.name !== this.name)
      throw Error(`Mismatching Component ${e.name} for Provider ${this.name}.`);
    if (this.component)
      throw Error(`Component for ${this.name} has already been provided`);
    if (this.component = e, !!this.shouldAutoInitialize()) {
      if (pr(e))
        try {
          this.getOrInitializeService({ instanceIdentifier: te });
        } catch {
        }
      for (const [t, r] of this.instancesDeferred.entries()) {
        const i = this.normalizeInstanceIdentifier(t);
        try {
          const s = this.getOrInitializeService({
            instanceIdentifier: i
          });
          r.resolve(s);
        } catch {
        }
      }
    }
  }
  clearInstance(e = te) {
    this.instancesDeferred.delete(e), this.instancesOptions.delete(e), this.instances.delete(e);
  }
  // app.delete() will call this method on every provider to delete the services
  // TODO: should we mark the provider as deleted?
  async delete() {
    const e = Array.from(this.instances.values());
    await Promise.all([
      ...e.filter((t) => "INTERNAL" in t).map((t) => t.INTERNAL.delete()),
      ...e.filter((t) => "_delete" in t).map((t) => t._delete())
    ]);
  }
  isComponentSet() {
    return this.component != null;
  }
  isInitialized(e = te) {
    return this.instances.has(e);
  }
  getOptions(e = te) {
    return this.instancesOptions.get(e) || {};
  }
  initialize(e = {}) {
    const { options: t = {} } = e, r = this.normalizeInstanceIdentifier(e.instanceIdentifier);
    if (this.isInitialized(r))
      throw Error(`${this.name}(${r}) has already been initialized`);
    if (!this.isComponentSet())
      throw Error(`Component ${this.name} has not been registered yet`);
    const i = this.getOrInitializeService({
      instanceIdentifier: r,
      options: t
    });
    for (const [s, o] of this.instancesDeferred.entries()) {
      const a = this.normalizeInstanceIdentifier(s);
      r === a && o.resolve(i);
    }
    return i;
  }
  /**
   *
   * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
   * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
   *
   * @param identifier An optional instance identifier
   * @returns a function to unregister the callback
   */
  onInit(e, t) {
    var r;
    const i = this.normalizeInstanceIdentifier(t), s = (r = this.onInitCallbacks.get(i)) !== null && r !== void 0 ? r : /* @__PURE__ */ new Set();
    s.add(e), this.onInitCallbacks.set(i, s);
    const o = this.instances.get(i);
    return o && e(o, i), () => {
      s.delete(e);
    };
  }
  /**
   * Invoke onInit callbacks synchronously
   * @param instance the service instance`
   */
  invokeOnInitCallbacks(e, t) {
    const r = this.onInitCallbacks.get(t);
    if (r)
      for (const i of r)
        try {
          i(e, t);
        } catch {
        }
  }
  getOrInitializeService({ instanceIdentifier: e, options: t = {} }) {
    let r = this.instances.get(e);
    if (!r && this.component && (r = this.component.instanceFactory(this.container, {
      instanceIdentifier: fr(e),
      options: t
    }), this.instances.set(e, r), this.instancesOptions.set(e, t), this.invokeOnInitCallbacks(r, e), this.component.onInstanceCreated))
      try {
        this.component.onInstanceCreated(this.container, e, r);
      } catch {
      }
    return r || null;
  }
  normalizeInstanceIdentifier(e = te) {
    return this.component ? this.component.multipleInstances ? e : te : e;
  }
  shouldAutoInitialize() {
    return !!this.component && this.component.instantiationMode !== "EXPLICIT";
  }
}
function fr(n) {
  return n === te ? void 0 : n;
}
function pr(n) {
  return n.instantiationMode === "EAGER";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class gr {
  constructor(e) {
    this.name = e, this.providers = /* @__PURE__ */ new Map();
  }
  /**
   *
   * @param component Component being added
   * @param overwrite When a component with the same name has already been registered,
   * if overwrite is true: overwrite the existing component with the new component and create a new
   * provider with the new component. It can be useful in tests where you want to use different mocks
   * for different tests.
   * if overwrite is false: throw an exception
   */
  addComponent(e) {
    const t = this.getProvider(e.name);
    if (t.isComponentSet())
      throw new Error(`Component ${e.name} has already been registered with ${this.name}`);
    t.setComponent(e);
  }
  addOrOverwriteComponent(e) {
    this.getProvider(e.name).isComponentSet() && this.providers.delete(e.name), this.addComponent(e);
  }
  /**
   * getProvider provides a type safe interface where it can only be called with a field name
   * present in NameServiceMapping interface.
   *
   * Firebase SDKs providing services should extend NameServiceMapping interface to register
   * themselves.
   */
  getProvider(e) {
    if (this.providers.has(e))
      return this.providers.get(e);
    const t = new hr(e, this);
    return this.providers.set(e, t), t;
  }
  getProviders() {
    return Array.from(this.providers.values());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var T;
(function(n) {
  n[n.DEBUG = 0] = "DEBUG", n[n.VERBOSE = 1] = "VERBOSE", n[n.INFO = 2] = "INFO", n[n.WARN = 3] = "WARN", n[n.ERROR = 4] = "ERROR", n[n.SILENT = 5] = "SILENT";
})(T || (T = {}));
const mr = {
  debug: T.DEBUG,
  verbose: T.VERBOSE,
  info: T.INFO,
  warn: T.WARN,
  error: T.ERROR,
  silent: T.SILENT
}, yr = T.INFO, _r = {
  [T.DEBUG]: "log",
  [T.VERBOSE]: "log",
  [T.INFO]: "info",
  [T.WARN]: "warn",
  [T.ERROR]: "error"
}, vr = (n, e, ...t) => {
  if (e < n.logLevel)
    return;
  const r = (/* @__PURE__ */ new Date()).toISOString(), i = _r[e];
  if (i)
    console[i](`[${r}]  ${n.name}:`, ...t);
  else
    throw new Error(`Attempted to log a message with an invalid logType (value: ${e})`);
};
class rn {
  /**
   * Gives you an instance of a Logger to capture messages according to
   * Firebase's logging scheme.
   *
   * @param name The name that the logs will be associated with
   */
  constructor(e) {
    this.name = e, this._logLevel = yr, this._logHandler = vr, this._userLogHandler = null;
  }
  get logLevel() {
    return this._logLevel;
  }
  set logLevel(e) {
    if (!(e in T))
      throw new TypeError(`Invalid value "${e}" assigned to \`logLevel\``);
    this._logLevel = e;
  }
  // Workaround for setter/getter having to be the same type.
  setLogLevel(e) {
    this._logLevel = typeof e == "string" ? mr[e] : e;
  }
  get logHandler() {
    return this._logHandler;
  }
  set logHandler(e) {
    if (typeof e != "function")
      throw new TypeError("Value assigned to `logHandler` must be a function");
    this._logHandler = e;
  }
  get userLogHandler() {
    return this._userLogHandler;
  }
  set userLogHandler(e) {
    this._userLogHandler = e;
  }
  /**
   * The functions below are all based on the `console` interface
   */
  debug(...e) {
    this._userLogHandler && this._userLogHandler(this, T.DEBUG, ...e), this._logHandler(this, T.DEBUG, ...e);
  }
  log(...e) {
    this._userLogHandler && this._userLogHandler(this, T.VERBOSE, ...e), this._logHandler(this, T.VERBOSE, ...e);
  }
  info(...e) {
    this._userLogHandler && this._userLogHandler(this, T.INFO, ...e), this._logHandler(this, T.INFO, ...e);
  }
  warn(...e) {
    this._userLogHandler && this._userLogHandler(this, T.WARN, ...e), this._logHandler(this, T.WARN, ...e);
  }
  error(...e) {
    this._userLogHandler && this._userLogHandler(this, T.ERROR, ...e), this._logHandler(this, T.ERROR, ...e);
  }
}
const br = (n, e) => e.some((t) => n instanceof t);
let bt, It;
function Ir() {
  return bt || (bt = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function wr() {
  return It || (It = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const sn = /* @__PURE__ */ new WeakMap(), Qe = /* @__PURE__ */ new WeakMap(), on = /* @__PURE__ */ new WeakMap(), ze = /* @__PURE__ */ new WeakMap(), ct = /* @__PURE__ */ new WeakMap();
function Er(n) {
  const e = new Promise((t, r) => {
    const i = () => {
      n.removeEventListener("success", s), n.removeEventListener("error", o);
    }, s = () => {
      t(Y(n.result)), i();
    }, o = () => {
      r(n.error), i();
    };
    n.addEventListener("success", s), n.addEventListener("error", o);
  });
  return e.then((t) => {
    t instanceof IDBCursor && sn.set(t, n);
  }).catch(() => {
  }), ct.set(e, n), e;
}
function Tr(n) {
  if (Qe.has(n))
    return;
  const e = new Promise((t, r) => {
    const i = () => {
      n.removeEventListener("complete", s), n.removeEventListener("error", o), n.removeEventListener("abort", o);
    }, s = () => {
      t(), i();
    }, o = () => {
      r(n.error || new DOMException("AbortError", "AbortError")), i();
    };
    n.addEventListener("complete", s), n.addEventListener("error", o), n.addEventListener("abort", o);
  });
  Qe.set(n, e);
}
let Xe = {
  get(n, e, t) {
    if (n instanceof IDBTransaction) {
      if (e === "done")
        return Qe.get(n);
      if (e === "objectStoreNames")
        return n.objectStoreNames || on.get(n);
      if (e === "store")
        return t.objectStoreNames[1] ? void 0 : t.objectStore(t.objectStoreNames[0]);
    }
    return Y(n[e]);
  },
  set(n, e, t) {
    return n[e] = t, !0;
  },
  has(n, e) {
    return n instanceof IDBTransaction && (e === "done" || e === "store") ? !0 : e in n;
  }
};
function Sr(n) {
  Xe = n(Xe);
}
function Ar(n) {
  return n === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(e, ...t) {
    const r = n.call(qe(this), e, ...t);
    return on.set(r, e.sort ? e.sort() : [e]), Y(r);
  } : wr().includes(n) ? function(...e) {
    return n.apply(qe(this), e), Y(sn.get(this));
  } : function(...e) {
    return Y(n.apply(qe(this), e));
  };
}
function Cr(n) {
  return typeof n == "function" ? Ar(n) : (n instanceof IDBTransaction && Tr(n), br(n, Ir()) ? new Proxy(n, Xe) : n);
}
function Y(n) {
  if (n instanceof IDBRequest)
    return Er(n);
  if (ze.has(n))
    return ze.get(n);
  const e = Cr(n);
  return e !== n && (ze.set(n, e), ct.set(e, n)), e;
}
const qe = (n) => ct.get(n);
function Rr(n, e, { blocked: t, upgrade: r, blocking: i, terminated: s } = {}) {
  const o = indexedDB.open(n, e), a = Y(o);
  return r && o.addEventListener("upgradeneeded", (c) => {
    r(Y(o.result), c.oldVersion, c.newVersion, Y(o.transaction), c);
  }), t && o.addEventListener("blocked", (c) => t(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    c.oldVersion,
    c.newVersion,
    c
  )), a.then((c) => {
    s && c.addEventListener("close", () => s()), i && c.addEventListener("versionchange", (u) => i(u.oldVersion, u.newVersion, u));
  }).catch(() => {
  }), a;
}
const Pr = ["get", "getKey", "getAll", "getAllKeys", "count"], Or = ["put", "add", "delete", "clear"], Je = /* @__PURE__ */ new Map();
function wt(n, e) {
  if (!(n instanceof IDBDatabase && !(e in n) && typeof e == "string"))
    return;
  if (Je.get(e))
    return Je.get(e);
  const t = e.replace(/FromIndex$/, ""), r = e !== t, i = Or.includes(t);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(t in (r ? IDBIndex : IDBObjectStore).prototype) || !(i || Pr.includes(t))
  )
    return;
  const s = async function(o, ...a) {
    const c = this.transaction(o, i ? "readwrite" : "readonly");
    let u = c.store;
    return r && (u = u.index(a.shift())), (await Promise.all([
      u[t](...a),
      i && c.done
    ]))[0];
  };
  return Je.set(e, s), s;
}
Sr((n) => ({
  ...n,
  get: (e, t, r) => wt(e, t) || n.get(e, t, r),
  has: (e, t) => !!wt(e, t) || n.has(e, t)
}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class kr {
  constructor(e) {
    this.container = e;
  }
  // In initial implementation, this will be called by installations on
  // auth token refresh, and installations will send this string.
  getPlatformInfoString() {
    return this.container.getProviders().map((t) => {
      if (Nr(t)) {
        const r = t.getImmediate();
        return `${r.library}/${r.version}`;
      } else
        return null;
    }).filter((t) => t).join(" ");
  }
}
function Nr(n) {
  const e = n.getComponent();
  return (e == null ? void 0 : e.type) === "VERSION";
}
const Ze = "@firebase/app", Et = "0.10.5";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ne = new rn("@firebase/app"), Dr = "@firebase/app-compat", Lr = "@firebase/analytics-compat", $r = "@firebase/analytics", Mr = "@firebase/app-check-compat", Ur = "@firebase/app-check", jr = "@firebase/auth", Fr = "@firebase/auth-compat", Br = "@firebase/database", Vr = "@firebase/database-compat", Hr = "@firebase/functions", xr = "@firebase/functions-compat", Wr = "@firebase/installations", zr = "@firebase/installations-compat", qr = "@firebase/messaging", Jr = "@firebase/messaging-compat", Gr = "@firebase/performance", Kr = "@firebase/performance-compat", Yr = "@firebase/remote-config", Qr = "@firebase/remote-config-compat", Xr = "@firebase/storage", Zr = "@firebase/storage-compat", ei = "@firebase/firestore", ti = "@firebase/vertexai-preview", ni = "@firebase/firestore-compat", ri = "firebase", ii = "10.12.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const et = "[DEFAULT]", si = {
  [Ze]: "fire-core",
  [Dr]: "fire-core-compat",
  [$r]: "fire-analytics",
  [Lr]: "fire-analytics-compat",
  [Ur]: "fire-app-check",
  [Mr]: "fire-app-check-compat",
  [jr]: "fire-auth",
  [Fr]: "fire-auth-compat",
  [Br]: "fire-rtdb",
  [Vr]: "fire-rtdb-compat",
  [Hr]: "fire-fn",
  [xr]: "fire-fn-compat",
  [Wr]: "fire-iid",
  [zr]: "fire-iid-compat",
  [qr]: "fire-fcm",
  [Jr]: "fire-fcm-compat",
  [Gr]: "fire-perf",
  [Kr]: "fire-perf-compat",
  [Yr]: "fire-rc",
  [Qr]: "fire-rc-compat",
  [Xr]: "fire-gcs",
  [Zr]: "fire-gcs-compat",
  [ei]: "fire-fst",
  [ni]: "fire-fst-compat",
  [ti]: "fire-vertex",
  "fire-js": "fire-js",
  [ri]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Ne = /* @__PURE__ */ new Map(), oi = /* @__PURE__ */ new Map(), tt = /* @__PURE__ */ new Map();
function Tt(n, e) {
  try {
    n.container.addComponent(e);
  } catch (t) {
    ne.debug(`Component ${e.name} failed to register with FirebaseApp ${n.name}`, t);
  }
}
function me(n) {
  const e = n.name;
  if (tt.has(e))
    return ne.debug(`There were multiple attempts to register component ${e}.`), !1;
  tt.set(e, n);
  for (const t of Ne.values())
    Tt(t, n);
  for (const t of oi.values())
    Tt(t, n);
  return !0;
}
function an(n, e) {
  const t = n.container.getProvider("heartbeat").getImmediate({ optional: !0 });
  return t && t.triggerHeartbeat(), n.container.getProvider(e);
}
function j(n) {
  return n.settings !== void 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ai = {
  "no-app": "No Firebase App '{$appName}' has been created - call initializeApp() first",
  "bad-app-name": "Illegal App name: '{$appName}'",
  "duplicate-app": "Firebase App named '{$appName}' already exists with different options or config",
  "app-deleted": "Firebase App named '{$appName}' already deleted",
  "server-app-deleted": "Firebase Server App has been deleted",
  "no-options": "Need to provide options, when not being deployed to hosting via source.",
  "invalid-app-argument": "firebase.{$appName}() takes either no argument or a Firebase App instance.",
  "invalid-log-argument": "First argument to `onLog` must be null or a function.",
  "idb-open": "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-get": "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-set": "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-delete": "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
  "finalization-registry-not-supported": "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
  "invalid-server-app-environment": "FirebaseServerApp is not for use in browser environments."
}, Q = new be("app", "Firebase", ai);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ci {
  constructor(e, t, r) {
    this._isDeleted = !1, this._options = Object.assign({}, e), this._config = Object.assign({}, t), this._name = t.name, this._automaticDataCollectionEnabled = t.automaticDataCollectionEnabled, this._container = r, this.container.addComponent(new de(
      "app",
      () => this,
      "PUBLIC"
      /* ComponentType.PUBLIC */
    ));
  }
  get automaticDataCollectionEnabled() {
    return this.checkDestroyed(), this._automaticDataCollectionEnabled;
  }
  set automaticDataCollectionEnabled(e) {
    this.checkDestroyed(), this._automaticDataCollectionEnabled = e;
  }
  get name() {
    return this.checkDestroyed(), this._name;
  }
  get options() {
    return this.checkDestroyed(), this._options;
  }
  get config() {
    return this.checkDestroyed(), this._config;
  }
  get container() {
    return this._container;
  }
  get isDeleted() {
    return this._isDeleted;
  }
  set isDeleted(e) {
    this._isDeleted = e;
  }
  /**
   * This function will throw an Error if the App has already been deleted -
   * use before performing API actions on the App.
   */
  checkDestroyed() {
    if (this.isDeleted)
      throw Q.create("app-deleted", { appName: this._name });
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const we = ii;
function cn(n, e = {}) {
  let t = n;
  typeof e != "object" && (e = { name: e });
  const r = Object.assign({ name: et, automaticDataCollectionEnabled: !1 }, e), i = r.name;
  if (typeof i != "string" || !i)
    throw Q.create("bad-app-name", {
      appName: String(i)
    });
  if (t || (t = tn()), !t)
    throw Q.create(
      "no-options"
      /* AppError.NO_OPTIONS */
    );
  const s = Ne.get(i);
  if (s) {
    if (ke(t, s.options) && ke(r, s.config))
      return s;
    throw Q.create("duplicate-app", { appName: i });
  }
  const o = new gr(i);
  for (const c of tt.values())
    o.addComponent(c);
  const a = new ci(t, r, o);
  return Ne.set(i, a), a;
}
function li(n = et) {
  const e = Ne.get(n);
  if (!e && n === et && tn())
    return cn();
  if (!e)
    throw Q.create("no-app", { appName: n });
  return e;
}
function oe(n, e, t) {
  var r;
  let i = (r = si[n]) !== null && r !== void 0 ? r : n;
  t && (i += `-${t}`);
  const s = i.match(/\s|\//), o = e.match(/\s|\//);
  if (s || o) {
    const a = [
      `Unable to register library "${i}" with version "${e}":`
    ];
    s && a.push(`library name "${i}" contains illegal characters (whitespace or "/")`), s && o && a.push("and"), o && a.push(`version name "${e}" contains illegal characters (whitespace or "/")`), ne.warn(a.join(" "));
    return;
  }
  me(new de(
    `${i}-version`,
    () => ({ library: i, version: e }),
    "VERSION"
    /* ComponentType.VERSION */
  ));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const di = "firebase-heartbeat-database", ui = 1, ye = "firebase-heartbeat-store";
let Ge = null;
function ln() {
  return Ge || (Ge = Rr(di, ui, {
    upgrade: (n, e) => {
      switch (e) {
        case 0:
          try {
            n.createObjectStore(ye);
          } catch (t) {
            console.warn(t);
          }
      }
    }
  }).catch((n) => {
    throw Q.create("idb-open", {
      originalErrorMessage: n.message
    });
  })), Ge;
}
async function hi(n) {
  try {
    const t = (await ln()).transaction(ye), r = await t.objectStore(ye).get(dn(n));
    return await t.done, r;
  } catch (e) {
    if (e instanceof Z)
      ne.warn(e.message);
    else {
      const t = Q.create("idb-get", {
        originalErrorMessage: e == null ? void 0 : e.message
      });
      ne.warn(t.message);
    }
  }
}
async function St(n, e) {
  try {
    const r = (await ln()).transaction(ye, "readwrite");
    await r.objectStore(ye).put(e, dn(n)), await r.done;
  } catch (t) {
    if (t instanceof Z)
      ne.warn(t.message);
    else {
      const r = Q.create("idb-set", {
        originalErrorMessage: t == null ? void 0 : t.message
      });
      ne.warn(r.message);
    }
  }
}
function dn(n) {
  return `${n.name}!${n.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const fi = 1024, pi = 30 * 24 * 60 * 60 * 1e3;
class gi {
  constructor(e) {
    this.container = e, this._heartbeatsCache = null;
    const t = this.container.getProvider("app").getImmediate();
    this._storage = new yi(t), this._heartbeatsCachePromise = this._storage.read().then((r) => (this._heartbeatsCache = r, r));
  }
  /**
   * Called to report a heartbeat. The function will generate
   * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
   * to IndexedDB.
   * Note that we only store one heartbeat per day. So if a heartbeat for today is
   * already logged, subsequent calls to this function in the same day will be ignored.
   */
  async triggerHeartbeat() {
    var e, t;
    const i = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(), s = At();
    if (!(((e = this._heartbeatsCache) === null || e === void 0 ? void 0 : e.heartbeats) == null && (this._heartbeatsCache = await this._heartbeatsCachePromise, ((t = this._heartbeatsCache) === null || t === void 0 ? void 0 : t.heartbeats) == null)) && !(this._heartbeatsCache.lastSentHeartbeatDate === s || this._heartbeatsCache.heartbeats.some((o) => o.date === s)))
      return this._heartbeatsCache.heartbeats.push({ date: s, agent: i }), this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((o) => {
        const a = new Date(o.date).valueOf();
        return Date.now() - a <= pi;
      }), this._storage.overwrite(this._heartbeatsCache);
  }
  /**
   * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
   * It also clears all heartbeats from memory as well as in IndexedDB.
   *
   * NOTE: Consuming product SDKs should not send the header if this method
   * returns an empty string.
   */
  async getHeartbeatsHeader() {
    var e;
    if (this._heartbeatsCache === null && await this._heartbeatsCachePromise, ((e = this._heartbeatsCache) === null || e === void 0 ? void 0 : e.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0)
      return "";
    const t = At(), { heartbeatsToSend: r, unsentEntries: i } = mi(this._heartbeatsCache.heartbeats), s = Zt(JSON.stringify({ version: 2, heartbeats: r }));
    return this._heartbeatsCache.lastSentHeartbeatDate = t, i.length > 0 ? (this._heartbeatsCache.heartbeats = i, await this._storage.overwrite(this._heartbeatsCache)) : (this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache)), s;
  }
}
function At() {
  return (/* @__PURE__ */ new Date()).toISOString().substring(0, 10);
}
function mi(n, e = fi) {
  const t = [];
  let r = n.slice();
  for (const i of n) {
    const s = t.find((o) => o.agent === i.agent);
    if (s) {
      if (s.dates.push(i.date), Ct(t) > e) {
        s.dates.pop();
        break;
      }
    } else if (t.push({
      agent: i.agent,
      dates: [i.date]
    }), Ct(t) > e) {
      t.pop();
      break;
    }
    r = r.slice(1);
  }
  return {
    heartbeatsToSend: t,
    unsentEntries: r
  };
}
class yi {
  constructor(e) {
    this.app = e, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }
  async runIndexedDBEnvironmentCheck() {
    return rr() ? ir().then(() => !0).catch(() => !1) : !1;
  }
  /**
   * Read all heartbeats.
   */
  async read() {
    if (await this._canUseIndexedDBPromise) {
      const t = await hi(this.app);
      return t != null && t.heartbeats ? t : { heartbeats: [] };
    } else
      return { heartbeats: [] };
  }
  // overwrite the storage with the provided heartbeats
  async overwrite(e) {
    var t;
    if (await this._canUseIndexedDBPromise) {
      const i = await this.read();
      return St(this.app, {
        lastSentHeartbeatDate: (t = e.lastSentHeartbeatDate) !== null && t !== void 0 ? t : i.lastSentHeartbeatDate,
        heartbeats: e.heartbeats
      });
    } else
      return;
  }
  // add heartbeats
  async add(e) {
    var t;
    if (await this._canUseIndexedDBPromise) {
      const i = await this.read();
      return St(this.app, {
        lastSentHeartbeatDate: (t = e.lastSentHeartbeatDate) !== null && t !== void 0 ? t : i.lastSentHeartbeatDate,
        heartbeats: [
          ...i.heartbeats,
          ...e.heartbeats
        ]
      });
    } else
      return;
  }
}
function Ct(n) {
  return Zt(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: n })
  ).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _i(n) {
  me(new de(
    "platform-logger",
    (e) => new kr(e),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), me(new de(
    "heartbeat",
    (e) => new gi(e),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), oe(Ze, Et, n), oe(Ze, Et, "esm2017"), oe("fire-js", "");
}
_i("");
var vi = "firebase", bi = "10.12.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
oe(vi, bi, "app");
function lt(n, e) {
  var t = {};
  for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && e.indexOf(r) < 0 && (t[r] = n[r]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(n); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(n, r[i]) && (t[r[i]] = n[r[i]]);
  return t;
}
function un() {
  return {
    "dependent-sdk-initialized-before-auth": "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
  };
}
const Ii = un, hn = new be("auth", "Firebase", un());
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const De = new rn("@firebase/auth");
function wi(n, ...e) {
  De.logLevel <= T.WARN && De.warn(`Auth (${we}): ${n}`, ...e);
}
function Ce(n, ...e) {
  De.logLevel <= T.ERROR && De.error(`Auth (${we}): ${n}`, ...e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function L(n, ...e) {
  throw dt(n, ...e);
}
function $(n, ...e) {
  return dt(n, ...e);
}
function fn(n, e, t) {
  const r = Object.assign(Object.assign({}, Ii()), { [e]: t });
  return new be("auth", "Firebase", r).create(e, {
    appName: n.name
  });
}
function X(n) {
  return fn(n, "operation-not-supported-in-this-environment", "Operations that alter the current user are not supported in conjunction with FirebaseServerApp");
}
function dt(n, ...e) {
  if (typeof n != "string") {
    const t = e[0], r = [...e.slice(1)];
    return r[0] && (r[0].appName = n.name), n._errorFactory.create(t, ...r);
  }
  return hn.create(n, ...e);
}
function v(n, e, ...t) {
  if (!n)
    throw dt(e, ...t);
}
function F(n) {
  const e = "INTERNAL ASSERTION FAILED: " + n;
  throw Ce(e), new Error(e);
}
function H(n, e) {
  n || F(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function nt() {
  var n;
  return typeof self < "u" && ((n = self.location) === null || n === void 0 ? void 0 : n.href) || "";
}
function Ei() {
  return Rt() === "http:" || Rt() === "https:";
}
function Rt() {
  var n;
  return typeof self < "u" && ((n = self.location) === null || n === void 0 ? void 0 : n.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ti() {
  return typeof navigator < "u" && navigator && "onLine" in navigator && typeof navigator.onLine == "boolean" && // Apply only for traditional web apps and Chrome extensions.
  // This is especially true for Cordova apps which have unreliable
  // navigator.onLine behavior unless cordova-plugin-network-information is
  // installed which overwrites the native navigator.onLine value and
  // defines navigator.connection.
  (Ei() || er() || "connection" in navigator) ? navigator.onLine : !0;
}
function Si() {
  if (typeof navigator > "u")
    return null;
  const n = navigator;
  return (
    // Most reliable, but only supported in Chrome/Firefox.
    n.languages && n.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    n.language || // Couldn't determine language.
    null
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ee {
  constructor(e, t) {
    this.shortDelay = e, this.longDelay = t, H(t > e, "Short delay should be less than long delay!"), this.isMobile = Zn() || tr();
  }
  get() {
    return Ti() ? this.isMobile ? this.longDelay : this.shortDelay : Math.min(5e3, this.shortDelay);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ut(n, e) {
  H(n.emulator, "Emulator should always be set here");
  const { url: t } = n.emulator;
  return e ? `${t}${e.startsWith("/") ? e.slice(1) : e}` : t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class pn {
  static initialize(e, t, r) {
    this.fetchImpl = e, t && (this.headersImpl = t), r && (this.responseImpl = r);
  }
  static fetch() {
    if (this.fetchImpl)
      return this.fetchImpl;
    if (typeof self < "u" && "fetch" in self)
      return self.fetch;
    if (typeof globalThis < "u" && globalThis.fetch)
      return globalThis.fetch;
    if (typeof fetch < "u")
      return fetch;
    F("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
  static headers() {
    if (this.headersImpl)
      return this.headersImpl;
    if (typeof self < "u" && "Headers" in self)
      return self.Headers;
    if (typeof globalThis < "u" && globalThis.Headers)
      return globalThis.Headers;
    if (typeof Headers < "u")
      return Headers;
    F("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
  static response() {
    if (this.responseImpl)
      return this.responseImpl;
    if (typeof self < "u" && "Response" in self)
      return self.Response;
    if (typeof globalThis < "u" && globalThis.Response)
      return globalThis.Response;
    if (typeof Response < "u")
      return Response;
    F("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Ai = {
  // Custom token errors.
  CREDENTIAL_MISMATCH: "custom-token-mismatch",
  // This can only happen if the SDK sends a bad request.
  MISSING_CUSTOM_TOKEN: "internal-error",
  // Create Auth URI errors.
  INVALID_IDENTIFIER: "invalid-email",
  // This can only happen if the SDK sends a bad request.
  MISSING_CONTINUE_URI: "internal-error",
  // Sign in with email and password errors (some apply to sign up too).
  INVALID_PASSWORD: "wrong-password",
  // This can only happen if the SDK sends a bad request.
  MISSING_PASSWORD: "missing-password",
  // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
  // invalid.
  INVALID_LOGIN_CREDENTIALS: "invalid-credential",
  // Sign up with email and password errors.
  EMAIL_EXISTS: "email-already-in-use",
  PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
  // Verify assertion for sign in with credential errors:
  INVALID_IDP_RESPONSE: "invalid-credential",
  INVALID_PENDING_TOKEN: "invalid-credential",
  FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
  // This can only happen if the SDK sends a bad request.
  MISSING_REQ_TYPE: "internal-error",
  // Send Password reset email errors:
  EMAIL_NOT_FOUND: "user-not-found",
  RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
  EXPIRED_OOB_CODE: "expired-action-code",
  INVALID_OOB_CODE: "invalid-action-code",
  // This can only happen if the SDK sends a bad request.
  MISSING_OOB_CODE: "internal-error",
  // Operations that require ID token in request:
  CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
  INVALID_ID_TOKEN: "invalid-user-token",
  TOKEN_EXPIRED: "user-token-expired",
  USER_NOT_FOUND: "user-token-expired",
  // Other errors.
  TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
  PASSWORD_DOES_NOT_MEET_REQUIREMENTS: "password-does-not-meet-requirements",
  // Phone Auth related errors.
  INVALID_CODE: "invalid-verification-code",
  INVALID_SESSION_INFO: "invalid-verification-id",
  INVALID_TEMPORARY_PROOF: "invalid-credential",
  MISSING_SESSION_INFO: "missing-verification-id",
  SESSION_EXPIRED: "code-expired",
  // Other action code errors when additional settings passed.
  // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
  // This is OK as this error will be caught by client side validation.
  MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
  UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
  // getProjectConfig errors when clientId is passed.
  INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
  // User actions (sign-up or deletion) disabled errors.
  ADMIN_ONLY_OPERATION: "admin-restricted-operation",
  // Multi factor related errors.
  INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
  MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
  MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
  MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
  SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
  SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
  // Blocking functions related errors.
  BLOCKING_FUNCTION_ERROR_RESPONSE: "internal-error",
  // Recaptcha related errors.
  RECAPTCHA_NOT_ENABLED: "recaptcha-not-enabled",
  MISSING_RECAPTCHA_TOKEN: "missing-recaptcha-token",
  INVALID_RECAPTCHA_TOKEN: "invalid-recaptcha-token",
  INVALID_RECAPTCHA_ACTION: "invalid-recaptcha-action",
  MISSING_CLIENT_TYPE: "missing-client-type",
  MISSING_RECAPTCHA_VERSION: "missing-recaptcha-version",
  INVALID_RECAPTCHA_VERSION: "invalid-recaptcha-version",
  INVALID_REQ_TYPE: "invalid-req-type"
  /* AuthErrorCode.INVALID_REQ_TYPE */
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Ci = new Ee(3e4, 6e4);
function ee(n, e) {
  return n.tenantId && !e.tenantId ? Object.assign(Object.assign({}, e), { tenantId: n.tenantId }) : e;
}
async function W(n, e, t, r, i = {}) {
  return gn(n, i, async () => {
    let s = {}, o = {};
    r && (e === "GET" ? o = r : s = {
      body: JSON.stringify(r)
    });
    const a = Ie(Object.assign({ key: n.config.apiKey }, o)).slice(1), c = await n._getAdditionalHeaders();
    return c[
      "Content-Type"
      /* HttpHeader.CONTENT_TYPE */
    ] = "application/json", n.languageCode && (c[
      "X-Firebase-Locale"
      /* HttpHeader.X_FIREBASE_LOCALE */
    ] = n.languageCode), pn.fetch()(mn(n, n.config.apiHost, t, a), Object.assign({
      method: e,
      headers: c,
      referrerPolicy: "no-referrer"
    }, s));
  });
}
async function gn(n, e, t) {
  n._canInitEmulator = !1;
  const r = Object.assign(Object.assign({}, Ai), e);
  try {
    const i = new Pi(n), s = await Promise.race([
      t(),
      i.promise
    ]);
    i.clearNetworkTimeout();
    const o = await s.json();
    if ("needConfirmation" in o)
      throw Ae(n, "account-exists-with-different-credential", o);
    if (s.ok && !("errorMessage" in o))
      return o;
    {
      const a = s.ok ? o.errorMessage : o.error.message, [c, u] = a.split(" : ");
      if (c === "FEDERATED_USER_ID_ALREADY_LINKED")
        throw Ae(n, "credential-already-in-use", o);
      if (c === "EMAIL_EXISTS")
        throw Ae(n, "email-already-in-use", o);
      if (c === "USER_DISABLED")
        throw Ae(n, "user-disabled", o);
      const y = r[c] || c.toLowerCase().replace(/[_\s]+/g, "-");
      if (u)
        throw fn(n, y, u);
      L(n, y);
    }
  } catch (i) {
    if (i instanceof Z)
      throw i;
    L(n, "network-request-failed", { message: String(i) });
  }
}
async function Fe(n, e, t, r, i = {}) {
  const s = await W(n, e, t, r, i);
  return "mfaPendingCredential" in s && L(n, "multi-factor-auth-required", {
    _serverResponse: s
  }), s;
}
function mn(n, e, t, r) {
  const i = `${e}${t}?${r}`;
  return n.config.emulator ? ut(n.config, i) : `${n.config.apiScheme}://${i}`;
}
function Ri(n) {
  switch (n) {
    case "ENFORCE":
      return "ENFORCE";
    case "AUDIT":
      return "AUDIT";
    case "OFF":
      return "OFF";
    default:
      return "ENFORCEMENT_STATE_UNSPECIFIED";
  }
}
class Pi {
  constructor(e) {
    this.auth = e, this.timer = null, this.promise = new Promise((t, r) => {
      this.timer = setTimeout(() => r($(
        this.auth,
        "network-request-failed"
        /* AuthErrorCode.NETWORK_REQUEST_FAILED */
      )), Ci.get());
    });
  }
  clearNetworkTimeout() {
    clearTimeout(this.timer);
  }
}
function Ae(n, e, t) {
  const r = {
    appName: n.name
  };
  t.email && (r.email = t.email), t.phoneNumber && (r.phoneNumber = t.phoneNumber);
  const i = $(n, e, r);
  return i.customData._tokenResponse = t, i;
}
function Pt(n) {
  return n !== void 0 && n.enterprise !== void 0;
}
class Oi {
  constructor(e) {
    if (this.siteKey = "", this.recaptchaEnforcementState = [], e.recaptchaKey === void 0)
      throw new Error("recaptchaKey undefined");
    this.siteKey = e.recaptchaKey.split("/")[3], this.recaptchaEnforcementState = e.recaptchaEnforcementState;
  }
  /**
   * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
   *
   * @param providerStr - The provider whose enforcement state is to be returned.
   * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
   */
  getProviderEnforcementState(e) {
    if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0)
      return null;
    for (const t of this.recaptchaEnforcementState)
      if (t.provider && t.provider === e)
        return Ri(t.enforcementState);
    return null;
  }
  /**
   * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
   *
   * @param providerStr - The provider whose enablement state is to be returned.
   * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
   */
  isProviderEnabled(e) {
    return this.getProviderEnforcementState(e) === "ENFORCE" || this.getProviderEnforcementState(e) === "AUDIT";
  }
}
async function ki(n, e) {
  return W(n, "GET", "/v2/recaptchaConfig", ee(n, e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Ni(n, e) {
  return W(n, "POST", "/v1/accounts:delete", e);
}
async function yn(n, e) {
  return W(n, "POST", "/v1/accounts:lookup", e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ge(n) {
  if (n)
    try {
      const e = new Date(Number(n));
      if (!isNaN(e.getTime()))
        return e.toUTCString();
    } catch {
    }
}
async function Di(n, e = !1) {
  const t = x(n), r = await t.getIdToken(e), i = ht(r);
  v(
    i && i.exp && i.auth_time && i.iat,
    t.auth,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  const s = typeof i.firebase == "object" ? i.firebase : void 0, o = s == null ? void 0 : s.sign_in_provider;
  return {
    claims: i,
    token: r,
    authTime: ge(Ke(i.auth_time)),
    issuedAtTime: ge(Ke(i.iat)),
    expirationTime: ge(Ke(i.exp)),
    signInProvider: o || null,
    signInSecondFactor: (s == null ? void 0 : s.sign_in_second_factor) || null
  };
}
function Ke(n) {
  return Number(n) * 1e3;
}
function ht(n) {
  const [e, t, r] = n.split(".");
  if (e === void 0 || t === void 0 || r === void 0)
    return Ce("JWT malformed, contained fewer than 3 sections"), null;
  try {
    const i = en(t);
    return i ? JSON.parse(i) : (Ce("Failed to decode base64 JWT payload"), null);
  } catch (i) {
    return Ce("Caught error parsing JWT payload as JSON", i == null ? void 0 : i.toString()), null;
  }
}
function Ot(n) {
  const e = ht(n);
  return v(
    e,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), v(
    typeof e.exp < "u",
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), v(
    typeof e.iat < "u",
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Number(e.exp) - Number(e.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _e(n, e, t = !1) {
  if (t)
    return e;
  try {
    return await e;
  } catch (r) {
    throw r instanceof Z && Li(r) && n.auth.currentUser === n && await n.auth.signOut(), r;
  }
}
function Li({ code: n }) {
  return n === "auth/user-disabled" || n === "auth/user-token-expired";
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class $i {
  constructor(e) {
    this.user = e, this.isRunning = !1, this.timerId = null, this.errorBackoff = 3e4;
  }
  _start() {
    this.isRunning || (this.isRunning = !0, this.schedule());
  }
  _stop() {
    this.isRunning && (this.isRunning = !1, this.timerId !== null && clearTimeout(this.timerId));
  }
  getInterval(e) {
    var t;
    if (e) {
      const r = this.errorBackoff;
      return this.errorBackoff = Math.min(
        this.errorBackoff * 2,
        96e4
        /* Duration.RETRY_BACKOFF_MAX */
      ), r;
    } else {
      this.errorBackoff = 3e4;
      const i = ((t = this.user.stsTokenManager.expirationTime) !== null && t !== void 0 ? t : 0) - Date.now() - 3e5;
      return Math.max(0, i);
    }
  }
  schedule(e = !1) {
    if (!this.isRunning)
      return;
    const t = this.getInterval(e);
    this.timerId = setTimeout(async () => {
      await this.iteration();
    }, t);
  }
  async iteration() {
    try {
      await this.user.getIdToken(!0);
    } catch (e) {
      (e == null ? void 0 : e.code) === "auth/network-request-failed" && this.schedule(
        /* wasError */
        !0
      );
      return;
    }
    this.schedule();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class rt {
  constructor(e, t) {
    this.createdAt = e, this.lastLoginAt = t, this._initializeTime();
  }
  _initializeTime() {
    this.lastSignInTime = ge(this.lastLoginAt), this.creationTime = ge(this.createdAt);
  }
  _copy(e) {
    this.createdAt = e.createdAt, this.lastLoginAt = e.lastLoginAt, this._initializeTime();
  }
  toJSON() {
    return {
      createdAt: this.createdAt,
      lastLoginAt: this.lastLoginAt
    };
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Le(n) {
  var e;
  const t = n.auth, r = await n.getIdToken(), i = await _e(n, yn(t, { idToken: r }));
  v(
    i == null ? void 0 : i.users.length,
    t,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  const s = i.users[0];
  n._notifyReloadListener(s);
  const o = !((e = s.providerUserInfo) === null || e === void 0) && e.length ? _n(s.providerUserInfo) : [], a = Ui(n.providerData, o), c = n.isAnonymous, u = !(n.email && s.passwordHash) && !(a != null && a.length), y = c ? u : !1, b = {
    uid: s.localId,
    displayName: s.displayName || null,
    photoURL: s.photoUrl || null,
    email: s.email || null,
    emailVerified: s.emailVerified || !1,
    phoneNumber: s.phoneNumber || null,
    tenantId: s.tenantId || null,
    providerData: a,
    metadata: new rt(s.createdAt, s.lastLoginAt),
    isAnonymous: y
  };
  Object.assign(n, b);
}
async function Mi(n) {
  const e = x(n);
  await Le(e), await e.auth._persistUserIfCurrent(e), e.auth._notifyListenersIfCurrent(e);
}
function Ui(n, e) {
  return [...n.filter((r) => !e.some((i) => i.providerId === r.providerId)), ...e];
}
function _n(n) {
  return n.map((e) => {
    var { providerId: t } = e, r = lt(e, ["providerId"]);
    return {
      providerId: t,
      uid: r.rawId || "",
      displayName: r.displayName || null,
      email: r.email || null,
      phoneNumber: r.phoneNumber || null,
      photoURL: r.photoUrl || null
    };
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function ji(n, e) {
  const t = await gn(n, {}, async () => {
    const r = Ie({
      grant_type: "refresh_token",
      refresh_token: e
    }).slice(1), { tokenApiHost: i, apiKey: s } = n.config, o = mn(n, i, "/v1/token", `key=${s}`), a = await n._getAdditionalHeaders();
    return a[
      "Content-Type"
      /* HttpHeader.CONTENT_TYPE */
    ] = "application/x-www-form-urlencoded", pn.fetch()(o, {
      method: "POST",
      headers: a,
      body: r
    });
  });
  return {
    accessToken: t.access_token,
    expiresIn: t.expires_in,
    refreshToken: t.refresh_token
  };
}
async function Fi(n, e) {
  return W(n, "POST", "/v2/accounts:revokeToken", ee(n, e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ae {
  constructor() {
    this.refreshToken = null, this.accessToken = null, this.expirationTime = null;
  }
  get isExpired() {
    return !this.expirationTime || Date.now() > this.expirationTime - 3e4;
  }
  updateFromServerResponse(e) {
    v(
      e.idToken,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), v(
      typeof e.idToken < "u",
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), v(
      typeof e.refreshToken < "u",
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const t = "expiresIn" in e && typeof e.expiresIn < "u" ? Number(e.expiresIn) : Ot(e.idToken);
    this.updateTokensAndExpiration(e.idToken, e.refreshToken, t);
  }
  updateFromIdToken(e) {
    v(
      e.length !== 0,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const t = Ot(e);
    this.updateTokensAndExpiration(e, null, t);
  }
  async getToken(e, t = !1) {
    return !t && this.accessToken && !this.isExpired ? this.accessToken : (v(
      this.refreshToken,
      e,
      "user-token-expired"
      /* AuthErrorCode.TOKEN_EXPIRED */
    ), this.refreshToken ? (await this.refresh(e, this.refreshToken), this.accessToken) : null);
  }
  clearRefreshToken() {
    this.refreshToken = null;
  }
  async refresh(e, t) {
    const { accessToken: r, refreshToken: i, expiresIn: s } = await ji(e, t);
    this.updateTokensAndExpiration(r, i, Number(s));
  }
  updateTokensAndExpiration(e, t, r) {
    this.refreshToken = t || null, this.accessToken = e || null, this.expirationTime = Date.now() + r * 1e3;
  }
  static fromJSON(e, t) {
    const { refreshToken: r, accessToken: i, expirationTime: s } = t, o = new ae();
    return r && (v(typeof r == "string", "internal-error", {
      appName: e
    }), o.refreshToken = r), i && (v(typeof i == "string", "internal-error", {
      appName: e
    }), o.accessToken = i), s && (v(typeof s == "number", "internal-error", {
      appName: e
    }), o.expirationTime = s), o;
  }
  toJSON() {
    return {
      refreshToken: this.refreshToken,
      accessToken: this.accessToken,
      expirationTime: this.expirationTime
    };
  }
  _assign(e) {
    this.accessToken = e.accessToken, this.refreshToken = e.refreshToken, this.expirationTime = e.expirationTime;
  }
  _clone() {
    return Object.assign(new ae(), this.toJSON());
  }
  _performRefresh() {
    return F("not implemented");
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function z(n, e) {
  v(typeof n == "string" || typeof n > "u", "internal-error", { appName: e });
}
class B {
  constructor(e) {
    var { uid: t, auth: r, stsTokenManager: i } = e, s = lt(e, ["uid", "auth", "stsTokenManager"]);
    this.providerId = "firebase", this.proactiveRefresh = new $i(this), this.reloadUserInfo = null, this.reloadListener = null, this.uid = t, this.auth = r, this.stsTokenManager = i, this.accessToken = i.accessToken, this.displayName = s.displayName || null, this.email = s.email || null, this.emailVerified = s.emailVerified || !1, this.phoneNumber = s.phoneNumber || null, this.photoURL = s.photoURL || null, this.isAnonymous = s.isAnonymous || !1, this.tenantId = s.tenantId || null, this.providerData = s.providerData ? [...s.providerData] : [], this.metadata = new rt(s.createdAt || void 0, s.lastLoginAt || void 0);
  }
  async getIdToken(e) {
    const t = await _e(this, this.stsTokenManager.getToken(this.auth, e));
    return v(
      t,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.accessToken !== t && (this.accessToken = t, await this.auth._persistUserIfCurrent(this), this.auth._notifyListenersIfCurrent(this)), t;
  }
  getIdTokenResult(e) {
    return Di(this, e);
  }
  reload() {
    return Mi(this);
  }
  _assign(e) {
    this !== e && (v(
      this.uid === e.uid,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.displayName = e.displayName, this.photoURL = e.photoURL, this.email = e.email, this.emailVerified = e.emailVerified, this.phoneNumber = e.phoneNumber, this.isAnonymous = e.isAnonymous, this.tenantId = e.tenantId, this.providerData = e.providerData.map((t) => Object.assign({}, t)), this.metadata._copy(e.metadata), this.stsTokenManager._assign(e.stsTokenManager));
  }
  _clone(e) {
    const t = new B(Object.assign(Object.assign({}, this), { auth: e, stsTokenManager: this.stsTokenManager._clone() }));
    return t.metadata._copy(this.metadata), t;
  }
  _onReload(e) {
    v(
      !this.reloadListener,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.reloadListener = e, this.reloadUserInfo && (this._notifyReloadListener(this.reloadUserInfo), this.reloadUserInfo = null);
  }
  _notifyReloadListener(e) {
    this.reloadListener ? this.reloadListener(e) : this.reloadUserInfo = e;
  }
  _startProactiveRefresh() {
    this.proactiveRefresh._start();
  }
  _stopProactiveRefresh() {
    this.proactiveRefresh._stop();
  }
  async _updateTokensIfNecessary(e, t = !1) {
    let r = !1;
    e.idToken && e.idToken !== this.stsTokenManager.accessToken && (this.stsTokenManager.updateFromServerResponse(e), r = !0), t && await Le(this), await this.auth._persistUserIfCurrent(this), r && this.auth._notifyListenersIfCurrent(this);
  }
  async delete() {
    if (j(this.auth.app))
      return Promise.reject(X(this.auth));
    const e = await this.getIdToken();
    return await _e(this, Ni(this.auth, { idToken: e })), this.stsTokenManager.clearRefreshToken(), this.auth.signOut();
  }
  toJSON() {
    return Object.assign(Object.assign({
      uid: this.uid,
      email: this.email || void 0,
      emailVerified: this.emailVerified,
      displayName: this.displayName || void 0,
      isAnonymous: this.isAnonymous,
      photoURL: this.photoURL || void 0,
      phoneNumber: this.phoneNumber || void 0,
      tenantId: this.tenantId || void 0,
      providerData: this.providerData.map((e) => Object.assign({}, e)),
      stsTokenManager: this.stsTokenManager.toJSON(),
      // Redirect event ID must be maintained in case there is a pending
      // redirect event.
      _redirectEventId: this._redirectEventId
    }, this.metadata.toJSON()), {
      // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
      apiKey: this.auth.config.apiKey,
      appName: this.auth.name
    });
  }
  get refreshToken() {
    return this.stsTokenManager.refreshToken || "";
  }
  static _fromJSON(e, t) {
    var r, i, s, o, a, c, u, y;
    const b = (r = t.displayName) !== null && r !== void 0 ? r : void 0, A = (i = t.email) !== null && i !== void 0 ? i : void 0, O = (s = t.phoneNumber) !== null && s !== void 0 ? s : void 0, N = (o = t.photoURL) !== null && o !== void 0 ? o : void 0, _ = (a = t.tenantId) !== null && a !== void 0 ? a : void 0, I = (c = t._redirectEventId) !== null && c !== void 0 ? c : void 0, k = (u = t.createdAt) !== null && u !== void 0 ? u : void 0, C = (y = t.lastLoginAt) !== null && y !== void 0 ? y : void 0, { uid: U, emailVerified: D, isAnonymous: l, providerData: m, stsTokenManager: d } = t;
    v(
      U && d,
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const w = ae.fromJSON(this.name, d);
    v(
      typeof U == "string",
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), z(b, e.name), z(A, e.name), v(
      typeof D == "boolean",
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), v(
      typeof l == "boolean",
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), z(O, e.name), z(N, e.name), z(_, e.name), z(I, e.name), z(k, e.name), z(C, e.name);
    const E = new B({
      uid: U,
      auth: e,
      email: A,
      emailVerified: D,
      displayName: b,
      isAnonymous: l,
      photoURL: N,
      phoneNumber: O,
      tenantId: _,
      stsTokenManager: w,
      createdAt: k,
      lastLoginAt: C
    });
    return m && Array.isArray(m) && (E.providerData = m.map((S) => Object.assign({}, S))), I && (E._redirectEventId = I), E;
  }
  /**
   * Initialize a User from an idToken server response
   * @param auth
   * @param idTokenResponse
   */
  static async _fromIdTokenResponse(e, t, r = !1) {
    const i = new ae();
    i.updateFromServerResponse(t);
    const s = new B({
      uid: t.localId,
      auth: e,
      stsTokenManager: i,
      isAnonymous: r
    });
    return await Le(s), s;
  }
  /**
   * Initialize a User from an idToken server response
   * @param auth
   * @param idTokenResponse
   */
  static async _fromGetAccountInfoResponse(e, t, r) {
    const i = t.users[0];
    v(
      i.localId !== void 0,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const s = i.providerUserInfo !== void 0 ? _n(i.providerUserInfo) : [], o = !(i.email && i.passwordHash) && !(s != null && s.length), a = new ae();
    a.updateFromIdToken(r);
    const c = new B({
      uid: i.localId,
      auth: e,
      stsTokenManager: a,
      isAnonymous: o
    }), u = {
      uid: i.localId,
      displayName: i.displayName || null,
      photoURL: i.photoUrl || null,
      email: i.email || null,
      emailVerified: i.emailVerified || !1,
      phoneNumber: i.phoneNumber || null,
      tenantId: i.tenantId || null,
      providerData: s,
      metadata: new rt(i.createdAt, i.lastLoginAt),
      isAnonymous: !(i.email && i.passwordHash) && !(s != null && s.length)
    };
    return Object.assign(c, u), c;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const kt = /* @__PURE__ */ new Map();
function V(n) {
  H(n instanceof Function, "Expected a class definition");
  let e = kt.get(n);
  return e ? (H(e instanceof n, "Instance stored in cache mismatched with class"), e) : (e = new n(), kt.set(n, e), e);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class vn {
  constructor() {
    this.type = "NONE", this.storage = {};
  }
  async _isAvailable() {
    return !0;
  }
  async _set(e, t) {
    this.storage[e] = t;
  }
  async _get(e) {
    const t = this.storage[e];
    return t === void 0 ? null : t;
  }
  async _remove(e) {
    delete this.storage[e];
  }
  _addListener(e, t) {
  }
  _removeListener(e, t) {
  }
}
vn.type = "NONE";
const Nt = vn;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Re(n, e, t) {
  return `firebase:${n}:${e}:${t}`;
}
class ce {
  constructor(e, t, r) {
    this.persistence = e, this.auth = t, this.userKey = r;
    const { config: i, name: s } = this.auth;
    this.fullUserKey = Re(this.userKey, i.apiKey, s), this.fullPersistenceKey = Re("persistence", i.apiKey, s), this.boundEventHandler = t._onStorageEvent.bind(t), this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
  }
  setCurrentUser(e) {
    return this.persistence._set(this.fullUserKey, e.toJSON());
  }
  async getCurrentUser() {
    const e = await this.persistence._get(this.fullUserKey);
    return e ? B._fromJSON(this.auth, e) : null;
  }
  removeCurrentUser() {
    return this.persistence._remove(this.fullUserKey);
  }
  savePersistenceForRedirect() {
    return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
  }
  async setPersistence(e) {
    if (this.persistence === e)
      return;
    const t = await this.getCurrentUser();
    if (await this.removeCurrentUser(), this.persistence = e, t)
      return this.setCurrentUser(t);
  }
  delete() {
    this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
  }
  static async create(e, t, r = "authUser") {
    if (!t.length)
      return new ce(V(Nt), e, r);
    const i = (await Promise.all(t.map(async (u) => {
      if (await u._isAvailable())
        return u;
    }))).filter((u) => u);
    let s = i[0] || V(Nt);
    const o = Re(r, e.config.apiKey, e.name);
    let a = null;
    for (const u of t)
      try {
        const y = await u._get(o);
        if (y) {
          const b = B._fromJSON(e, y);
          u !== s && (a = b), s = u;
          break;
        }
      } catch {
      }
    const c = i.filter((u) => u._shouldAllowMigration);
    return !s._shouldAllowMigration || !c.length ? new ce(s, e, r) : (s = c[0], a && await s._set(o, a.toJSON()), await Promise.all(t.map(async (u) => {
      if (u !== s)
        try {
          await u._remove(o);
        } catch {
        }
    })), new ce(s, e, r));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Dt(n) {
  const e = n.toLowerCase();
  if (e.includes("opera/") || e.includes("opr/") || e.includes("opios/"))
    return "Opera";
  if (wn(e))
    return "IEMobile";
  if (e.includes("msie") || e.includes("trident/"))
    return "IE";
  if (e.includes("edge/"))
    return "Edge";
  if (bn(e))
    return "Firefox";
  if (e.includes("silk/"))
    return "Silk";
  if (Tn(e))
    return "Blackberry";
  if (Sn(e))
    return "Webos";
  if (ft(e))
    return "Safari";
  if ((e.includes("chrome/") || In(e)) && !e.includes("edge/"))
    return "Chrome";
  if (En(e))
    return "Android";
  {
    const t = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/, r = n.match(t);
    if ((r == null ? void 0 : r.length) === 2)
      return r[1];
  }
  return "Other";
}
function bn(n = P()) {
  return /firefox\//i.test(n);
}
function ft(n = P()) {
  const e = n.toLowerCase();
  return e.includes("safari/") && !e.includes("chrome/") && !e.includes("crios/") && !e.includes("android");
}
function In(n = P()) {
  return /crios\//i.test(n);
}
function wn(n = P()) {
  return /iemobile/i.test(n);
}
function En(n = P()) {
  return /android/i.test(n);
}
function Tn(n = P()) {
  return /blackberry/i.test(n);
}
function Sn(n = P()) {
  return /webos/i.test(n);
}
function Be(n = P()) {
  return /iphone|ipad|ipod/i.test(n) || /macintosh/i.test(n) && /mobile/i.test(n);
}
function Bi(n = P()) {
  var e;
  return Be(n) && !!(!((e = window.navigator) === null || e === void 0) && e.standalone);
}
function Vi() {
  return nr() && document.documentMode === 10;
}
function An(n = P()) {
  return Be(n) || En(n) || Sn(n) || Tn(n) || /windows phone/i.test(n) || wn(n);
}
function Hi() {
  try {
    return !!(window && window !== window.top);
  } catch {
    return !1;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Cn(n, e = []) {
  let t;
  switch (n) {
    case "Browser":
      t = Dt(P());
      break;
    case "Worker":
      t = `${Dt(P())}-${n}`;
      break;
    default:
      t = n;
  }
  const r = e.length ? e.join(",") : "FirebaseCore-web";
  return `${t}/JsCore/${we}/${r}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class xi {
  constructor(e) {
    this.auth = e, this.queue = [];
  }
  pushCallback(e, t) {
    const r = (s) => new Promise((o, a) => {
      try {
        const c = e(s);
        o(c);
      } catch (c) {
        a(c);
      }
    });
    r.onAbort = t, this.queue.push(r);
    const i = this.queue.length - 1;
    return () => {
      this.queue[i] = () => Promise.resolve();
    };
  }
  async runMiddleware(e) {
    if (this.auth.currentUser === e)
      return;
    const t = [];
    try {
      for (const r of this.queue)
        await r(e), r.onAbort && t.push(r.onAbort);
    } catch (r) {
      t.reverse();
      for (const i of t)
        try {
          i();
        } catch {
        }
      throw this.auth._errorFactory.create("login-blocked", {
        originalMessage: r == null ? void 0 : r.message
      });
    }
  }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Wi(n, e = {}) {
  return W(n, "GET", "/v2/passwordPolicy", ee(n, e));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const zi = 6;
class qi {
  constructor(e) {
    var t, r, i, s;
    const o = e.customStrengthOptions;
    this.customStrengthOptions = {}, this.customStrengthOptions.minPasswordLength = (t = o.minPasswordLength) !== null && t !== void 0 ? t : zi, o.maxPasswordLength && (this.customStrengthOptions.maxPasswordLength = o.maxPasswordLength), o.containsLowercaseCharacter !== void 0 && (this.customStrengthOptions.containsLowercaseLetter = o.containsLowercaseCharacter), o.containsUppercaseCharacter !== void 0 && (this.customStrengthOptions.containsUppercaseLetter = o.containsUppercaseCharacter), o.containsNumericCharacter !== void 0 && (this.customStrengthOptions.containsNumericCharacter = o.containsNumericCharacter), o.containsNonAlphanumericCharacter !== void 0 && (this.customStrengthOptions.containsNonAlphanumericCharacter = o.containsNonAlphanumericCharacter), this.enforcementState = e.enforcementState, this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED" && (this.enforcementState = "OFF"), this.allowedNonAlphanumericCharacters = (i = (r = e.allowedNonAlphanumericCharacters) === null || r === void 0 ? void 0 : r.join("")) !== null && i !== void 0 ? i : "", this.forceUpgradeOnSignin = (s = e.forceUpgradeOnSignin) !== null && s !== void 0 ? s : !1, this.schemaVersion = e.schemaVersion;
  }
  validatePassword(e) {
    var t, r, i, s, o, a;
    const c = {
      isValid: !0,
      passwordPolicy: this
    };
    return this.validatePasswordLengthOptions(e, c), this.validatePasswordCharacterOptions(e, c), c.isValid && (c.isValid = (t = c.meetsMinPasswordLength) !== null && t !== void 0 ? t : !0), c.isValid && (c.isValid = (r = c.meetsMaxPasswordLength) !== null && r !== void 0 ? r : !0), c.isValid && (c.isValid = (i = c.containsLowercaseLetter) !== null && i !== void 0 ? i : !0), c.isValid && (c.isValid = (s = c.containsUppercaseLetter) !== null && s !== void 0 ? s : !0), c.isValid && (c.isValid = (o = c.containsNumericCharacter) !== null && o !== void 0 ? o : !0), c.isValid && (c.isValid = (a = c.containsNonAlphanumericCharacter) !== null && a !== void 0 ? a : !0), c;
  }
  /**
   * Validates that the password meets the length options for the policy.
   *
   * @param password Password to validate.
   * @param status Validation status.
   */
  validatePasswordLengthOptions(e, t) {
    const r = this.customStrengthOptions.minPasswordLength, i = this.customStrengthOptions.maxPasswordLength;
    r && (t.meetsMinPasswordLength = e.length >= r), i && (t.meetsMaxPasswordLength = e.length <= i);
  }
  /**
   * Validates that the password meets the character options for the policy.
   *
   * @param password Password to validate.
   * @param status Validation status.
   */
  validatePasswordCharacterOptions(e, t) {
    this.updatePasswordCharacterOptionsStatuses(
      t,
      /* containsLowercaseCharacter= */
      !1,
      /* containsUppercaseCharacter= */
      !1,
      /* containsNumericCharacter= */
      !1,
      /* containsNonAlphanumericCharacter= */
      !1
    );
    let r;
    for (let i = 0; i < e.length; i++)
      r = e.charAt(i), this.updatePasswordCharacterOptionsStatuses(
        t,
        /* containsLowercaseCharacter= */
        r >= "a" && r <= "z",
        /* containsUppercaseCharacter= */
        r >= "A" && r <= "Z",
        /* containsNumericCharacter= */
        r >= "0" && r <= "9",
        /* containsNonAlphanumericCharacter= */
        this.allowedNonAlphanumericCharacters.includes(r)
      );
  }
  /**
   * Updates the running validation status with the statuses for the character options.
   * Expected to be called each time a character is processed to update each option status
   * based on the current character.
   *
   * @param status Validation status.
   * @param containsLowercaseCharacter Whether the character is a lowercase letter.
   * @param containsUppercaseCharacter Whether the character is an uppercase letter.
   * @param containsNumericCharacter Whether the character is a numeric character.
   * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
   */
  updatePasswordCharacterOptionsStatuses(e, t, r, i, s) {
    this.customStrengthOptions.containsLowercaseLetter && (e.containsLowercaseLetter || (e.containsLowercaseLetter = t)), this.customStrengthOptions.containsUppercaseLetter && (e.containsUppercaseLetter || (e.containsUppercaseLetter = r)), this.customStrengthOptions.containsNumericCharacter && (e.containsNumericCharacter || (e.containsNumericCharacter = i)), this.customStrengthOptions.containsNonAlphanumericCharacter && (e.containsNonAlphanumericCharacter || (e.containsNonAlphanumericCharacter = s));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ji {
  constructor(e, t, r, i) {
    this.app = e, this.heartbeatServiceProvider = t, this.appCheckServiceProvider = r, this.config = i, this.currentUser = null, this.emulatorConfig = null, this.operations = Promise.resolve(), this.authStateSubscription = new Lt(this), this.idTokenSubscription = new Lt(this), this.beforeStateQueue = new xi(this), this.redirectUser = null, this.isProactiveRefreshEnabled = !1, this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1, this._canInitEmulator = !0, this._isInitialized = !1, this._deleted = !1, this._initializationPromise = null, this._popupRedirectResolver = null, this._errorFactory = hn, this._agentRecaptchaConfig = null, this._tenantRecaptchaConfigs = {}, this._projectPasswordPolicy = null, this._tenantPasswordPolicies = {}, this.lastNotifiedUid = void 0, this.languageCode = null, this.tenantId = null, this.settings = { appVerificationDisabledForTesting: !1 }, this.frameworks = [], this.name = e.name, this.clientVersion = i.sdkClientVersion;
  }
  _initializeWithPersistence(e, t) {
    return t && (this._popupRedirectResolver = V(t)), this._initializationPromise = this.queue(async () => {
      var r, i;
      if (!this._deleted && (this.persistenceManager = await ce.create(this, e), !this._deleted)) {
        if (!((r = this._popupRedirectResolver) === null || r === void 0) && r._shouldInitProactively)
          try {
            await this._popupRedirectResolver._initialize(this);
          } catch {
          }
        await this.initializeCurrentUser(t), this.lastNotifiedUid = ((i = this.currentUser) === null || i === void 0 ? void 0 : i.uid) || null, !this._deleted && (this._isInitialized = !0);
      }
    }), this._initializationPromise;
  }
  /**
   * If the persistence is changed in another window, the user manager will let us know
   */
  async _onStorageEvent() {
    if (this._deleted)
      return;
    const e = await this.assertedPersistence.getCurrentUser();
    if (!(!this.currentUser && !e)) {
      if (this.currentUser && e && this.currentUser.uid === e.uid) {
        this._currentUser._assign(e), await this.currentUser.getIdToken();
        return;
      }
      await this._updateCurrentUser(
        e,
        /* skipBeforeStateCallbacks */
        !0
      );
    }
  }
  async initializeCurrentUserFromIdToken(e) {
    try {
      const t = await yn(this, { idToken: e }), r = await B._fromGetAccountInfoResponse(this, t, e);
      await this.directlySetCurrentUser(r);
    } catch (t) {
      console.warn("FirebaseServerApp could not login user with provided authIdToken: ", t), await this.directlySetCurrentUser(null);
    }
  }
  async initializeCurrentUser(e) {
    var t;
    if (j(this.app)) {
      const o = this.app.settings.authIdToken;
      return o ? new Promise((a) => {
        setTimeout(() => this.initializeCurrentUserFromIdToken(o).then(a, a));
      }) : this.directlySetCurrentUser(null);
    }
    const r = await this.assertedPersistence.getCurrentUser();
    let i = r, s = !1;
    if (e && this.config.authDomain) {
      await this.getOrInitRedirectPersistenceManager();
      const o = (t = this.redirectUser) === null || t === void 0 ? void 0 : t._redirectEventId, a = i == null ? void 0 : i._redirectEventId, c = await this.tryRedirectSignIn(e);
      (!o || o === a) && (c != null && c.user) && (i = c.user, s = !0);
    }
    if (!i)
      return this.directlySetCurrentUser(null);
    if (!i._redirectEventId) {
      if (s)
        try {
          await this.beforeStateQueue.runMiddleware(i);
        } catch (o) {
          i = r, this._popupRedirectResolver._overrideRedirectResult(this, () => Promise.reject(o));
        }
      return i ? this.reloadAndSetCurrentUserOrClear(i) : this.directlySetCurrentUser(null);
    }
    return v(
      this._popupRedirectResolver,
      this,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), await this.getOrInitRedirectPersistenceManager(), this.redirectUser && this.redirectUser._redirectEventId === i._redirectEventId ? this.directlySetCurrentUser(i) : this.reloadAndSetCurrentUserOrClear(i);
  }
  async tryRedirectSignIn(e) {
    let t = null;
    try {
      t = await this._popupRedirectResolver._completeRedirectFn(this, e, !0);
    } catch {
      await this._setRedirectUser(null);
    }
    return t;
  }
  async reloadAndSetCurrentUserOrClear(e) {
    try {
      await Le(e);
    } catch (t) {
      if ((t == null ? void 0 : t.code) !== "auth/network-request-failed")
        return this.directlySetCurrentUser(null);
    }
    return this.directlySetCurrentUser(e);
  }
  useDeviceLanguage() {
    this.languageCode = Si();
  }
  async _delete() {
    this._deleted = !0;
  }
  async updateCurrentUser(e) {
    if (j(this.app))
      return Promise.reject(X(this));
    const t = e ? x(e) : null;
    return t && v(
      t.auth.config.apiKey === this.config.apiKey,
      this,
      "invalid-user-token"
      /* AuthErrorCode.INVALID_AUTH */
    ), this._updateCurrentUser(t && t._clone(this));
  }
  async _updateCurrentUser(e, t = !1) {
    if (!this._deleted)
      return e && v(
        this.tenantId === e.tenantId,
        this,
        "tenant-id-mismatch"
        /* AuthErrorCode.TENANT_ID_MISMATCH */
      ), t || await this.beforeStateQueue.runMiddleware(e), this.queue(async () => {
        await this.directlySetCurrentUser(e), this.notifyAuthListeners();
      });
  }
  async signOut() {
    return j(this.app) ? Promise.reject(X(this)) : (await this.beforeStateQueue.runMiddleware(null), (this.redirectPersistenceManager || this._popupRedirectResolver) && await this._setRedirectUser(null), this._updateCurrentUser(
      null,
      /* skipBeforeStateCallbacks */
      !0
    ));
  }
  setPersistence(e) {
    return j(this.app) ? Promise.reject(X(this)) : this.queue(async () => {
      await this.assertedPersistence.setPersistence(V(e));
    });
  }
  _getRecaptchaConfig() {
    return this.tenantId == null ? this._agentRecaptchaConfig : this._tenantRecaptchaConfigs[this.tenantId];
  }
  async validatePassword(e) {
    this._getPasswordPolicyInternal() || await this._updatePasswordPolicy();
    const t = this._getPasswordPolicyInternal();
    return t.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION ? Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version", {})) : t.validatePassword(e);
  }
  _getPasswordPolicyInternal() {
    return this.tenantId === null ? this._projectPasswordPolicy : this._tenantPasswordPolicies[this.tenantId];
  }
  async _updatePasswordPolicy() {
    const e = await Wi(this), t = new qi(e);
    this.tenantId === null ? this._projectPasswordPolicy = t : this._tenantPasswordPolicies[this.tenantId] = t;
  }
  _getPersistence() {
    return this.assertedPersistence.persistence.type;
  }
  _updateErrorMap(e) {
    this._errorFactory = new be("auth", "Firebase", e());
  }
  onAuthStateChanged(e, t, r) {
    return this.registerStateListener(this.authStateSubscription, e, t, r);
  }
  beforeAuthStateChanged(e, t) {
    return this.beforeStateQueue.pushCallback(e, t);
  }
  onIdTokenChanged(e, t, r) {
    return this.registerStateListener(this.idTokenSubscription, e, t, r);
  }
  authStateReady() {
    return new Promise((e, t) => {
      if (this.currentUser)
        e();
      else {
        const r = this.onAuthStateChanged(() => {
          r(), e();
        }, t);
      }
    });
  }
  /**
   * Revokes the given access token. Currently only supports Apple OAuth access tokens.
   */
  async revokeAccessToken(e) {
    if (this.currentUser) {
      const t = await this.currentUser.getIdToken(), r = {
        providerId: "apple.com",
        tokenType: "ACCESS_TOKEN",
        token: e,
        idToken: t
      };
      this.tenantId != null && (r.tenantId = this.tenantId), await Fi(this, r);
    }
  }
  toJSON() {
    var e;
    return {
      apiKey: this.config.apiKey,
      authDomain: this.config.authDomain,
      appName: this.name,
      currentUser: (e = this._currentUser) === null || e === void 0 ? void 0 : e.toJSON()
    };
  }
  async _setRedirectUser(e, t) {
    const r = await this.getOrInitRedirectPersistenceManager(t);
    return e === null ? r.removeCurrentUser() : r.setCurrentUser(e);
  }
  async getOrInitRedirectPersistenceManager(e) {
    if (!this.redirectPersistenceManager) {
      const t = e && V(e) || this._popupRedirectResolver;
      v(
        t,
        this,
        "argument-error"
        /* AuthErrorCode.ARGUMENT_ERROR */
      ), this.redirectPersistenceManager = await ce.create(
        this,
        [V(t._redirectPersistence)],
        "redirectUser"
        /* KeyName.REDIRECT_USER */
      ), this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
    }
    return this.redirectPersistenceManager;
  }
  async _redirectUserForId(e) {
    var t, r;
    return this._isInitialized && await this.queue(async () => {
    }), ((t = this._currentUser) === null || t === void 0 ? void 0 : t._redirectEventId) === e ? this._currentUser : ((r = this.redirectUser) === null || r === void 0 ? void 0 : r._redirectEventId) === e ? this.redirectUser : null;
  }
  async _persistUserIfCurrent(e) {
    if (e === this.currentUser)
      return this.queue(async () => this.directlySetCurrentUser(e));
  }
  /** Notifies listeners only if the user is current */
  _notifyListenersIfCurrent(e) {
    e === this.currentUser && this.notifyAuthListeners();
  }
  _key() {
    return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
  }
  _startProactiveRefresh() {
    this.isProactiveRefreshEnabled = !0, this.currentUser && this._currentUser._startProactiveRefresh();
  }
  _stopProactiveRefresh() {
    this.isProactiveRefreshEnabled = !1, this.currentUser && this._currentUser._stopProactiveRefresh();
  }
  /** Returns the current user cast as the internal type */
  get _currentUser() {
    return this.currentUser;
  }
  notifyAuthListeners() {
    var e, t;
    if (!this._isInitialized)
      return;
    this.idTokenSubscription.next(this.currentUser);
    const r = (t = (e = this.currentUser) === null || e === void 0 ? void 0 : e.uid) !== null && t !== void 0 ? t : null;
    this.lastNotifiedUid !== r && (this.lastNotifiedUid = r, this.authStateSubscription.next(this.currentUser));
  }
  registerStateListener(e, t, r, i) {
    if (this._deleted)
      return () => {
      };
    const s = typeof t == "function" ? t : t.next.bind(t);
    let o = !1;
    const a = this._isInitialized ? Promise.resolve() : this._initializationPromise;
    if (v(
      a,
      this,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), a.then(() => {
      o || s(this.currentUser);
    }), typeof t == "function") {
      const c = e.addObserver(t, r, i);
      return () => {
        o = !0, c();
      };
    } else {
      const c = e.addObserver(t);
      return () => {
        o = !0, c();
      };
    }
  }
  /**
   * Unprotected (from race conditions) method to set the current user. This
   * should only be called from within a queued callback. This is necessary
   * because the queue shouldn't rely on another queued callback.
   */
  async directlySetCurrentUser(e) {
    this.currentUser && this.currentUser !== e && this._currentUser._stopProactiveRefresh(), e && this.isProactiveRefreshEnabled && e._startProactiveRefresh(), this.currentUser = e, e ? await this.assertedPersistence.setCurrentUser(e) : await this.assertedPersistence.removeCurrentUser();
  }
  queue(e) {
    return this.operations = this.operations.then(e, e), this.operations;
  }
  get assertedPersistence() {
    return v(
      this.persistenceManager,
      this,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.persistenceManager;
  }
  _logFramework(e) {
    !e || this.frameworks.includes(e) || (this.frameworks.push(e), this.frameworks.sort(), this.clientVersion = Cn(this.config.clientPlatform, this._getFrameworks()));
  }
  _getFrameworks() {
    return this.frameworks;
  }
  async _getAdditionalHeaders() {
    var e;
    const t = {
      "X-Client-Version": this.clientVersion
    };
    this.app.options.appId && (t[
      "X-Firebase-gmpid"
      /* HttpHeader.X_FIREBASE_GMPID */
    ] = this.app.options.appId);
    const r = await ((e = this.heartbeatServiceProvider.getImmediate({
      optional: !0
    })) === null || e === void 0 ? void 0 : e.getHeartbeatsHeader());
    r && (t[
      "X-Firebase-Client"
      /* HttpHeader.X_FIREBASE_CLIENT */
    ] = r);
    const i = await this._getAppCheckToken();
    return i && (t[
      "X-Firebase-AppCheck"
      /* HttpHeader.X_FIREBASE_APP_CHECK */
    ] = i), t;
  }
  async _getAppCheckToken() {
    var e;
    const t = await ((e = this.appCheckServiceProvider.getImmediate({ optional: !0 })) === null || e === void 0 ? void 0 : e.getToken());
    return t != null && t.error && wi(`Error while retrieving App Check token: ${t.error}`), t == null ? void 0 : t.token;
  }
}
function ie(n) {
  return x(n);
}
class Lt {
  constructor(e) {
    this.auth = e, this.observer = null, this.addObserver = lr((t) => this.observer = t);
  }
  get next() {
    return v(
      this.observer,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.observer.next.bind(this.observer);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let Ve = {
  async loadJS() {
    throw new Error("Unable to load external scripts");
  },
  recaptchaV2Script: "",
  recaptchaEnterpriseScript: "",
  gapiScript: ""
};
function Gi(n) {
  Ve = n;
}
function Rn(n) {
  return Ve.loadJS(n);
}
function Ki() {
  return Ve.recaptchaEnterpriseScript;
}
function Yi() {
  return Ve.gapiScript;
}
function Qi(n) {
  return `__${n}${Math.floor(Math.random() * 1e6)}`;
}
const Xi = "recaptcha-enterprise", Zi = "NO_RECAPTCHA";
class es {
  /**
   *
   * @param authExtern - The corresponding Firebase {@link Auth} instance.
   *
   */
  constructor(e) {
    this.type = Xi, this.auth = ie(e);
  }
  /**
   * Executes the verification process.
   *
   * @returns A Promise for a token that can be used to assert the validity of a request.
   */
  async verify(e = "verify", t = !1) {
    async function r(s) {
      if (!t) {
        if (s.tenantId == null && s._agentRecaptchaConfig != null)
          return s._agentRecaptchaConfig.siteKey;
        if (s.tenantId != null && s._tenantRecaptchaConfigs[s.tenantId] !== void 0)
          return s._tenantRecaptchaConfigs[s.tenantId].siteKey;
      }
      return new Promise(async (o, a) => {
        ki(s, {
          clientType: "CLIENT_TYPE_WEB",
          version: "RECAPTCHA_ENTERPRISE"
          /* RecaptchaVersion.ENTERPRISE */
        }).then((c) => {
          if (c.recaptchaKey === void 0)
            a(new Error("recaptcha Enterprise site key undefined"));
          else {
            const u = new Oi(c);
            return s.tenantId == null ? s._agentRecaptchaConfig = u : s._tenantRecaptchaConfigs[s.tenantId] = u, o(u.siteKey);
          }
        }).catch((c) => {
          a(c);
        });
      });
    }
    function i(s, o, a) {
      const c = window.grecaptcha;
      Pt(c) ? c.enterprise.ready(() => {
        c.enterprise.execute(s, { action: e }).then((u) => {
          o(u);
        }).catch(() => {
          o(Zi);
        });
      }) : a(Error("No reCAPTCHA enterprise script loaded."));
    }
    return new Promise((s, o) => {
      r(this.auth).then((a) => {
        if (!t && Pt(window.grecaptcha))
          i(a, s, o);
        else {
          if (typeof window > "u") {
            o(new Error("RecaptchaVerifier is only supported in browser"));
            return;
          }
          let c = Ki();
          c.length !== 0 && (c += a), Rn(c).then(() => {
            i(a, s, o);
          }).catch((u) => {
            o(u);
          });
        }
      }).catch((a) => {
        o(a);
      });
    });
  }
}
async function $t(n, e, t, r = !1) {
  const i = new es(n);
  let s;
  try {
    s = await i.verify(t);
  } catch {
    s = await i.verify(t, !0);
  }
  const o = Object.assign({}, e);
  return r ? Object.assign(o, { captchaResp: s }) : Object.assign(o, { captchaResponse: s }), Object.assign(o, {
    clientType: "CLIENT_TYPE_WEB"
    /* RecaptchaClientType.WEB */
  }), Object.assign(o, {
    recaptchaVersion: "RECAPTCHA_ENTERPRISE"
    /* RecaptchaVersion.ENTERPRISE */
  }), o;
}
async function it(n, e, t, r) {
  var i;
  if (!((i = n._getRecaptchaConfig()) === null || i === void 0) && i.isProviderEnabled(
    "EMAIL_PASSWORD_PROVIDER"
    /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */
  )) {
    const s = await $t(
      n,
      e,
      t,
      t === "getOobCode"
      /* RecaptchaActionName.GET_OOB_CODE */
    );
    return r(n, s);
  } else
    return r(n, e).catch(async (s) => {
      if (s.code === "auth/missing-recaptcha-token") {
        console.log(`${t} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
        const o = await $t(
          n,
          e,
          t,
          t === "getOobCode"
          /* RecaptchaActionName.GET_OOB_CODE */
        );
        return r(n, o);
      } else
        return Promise.reject(s);
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ts(n, e) {
  const t = an(n, "auth");
  if (t.isInitialized()) {
    const i = t.getImmediate(), s = t.getOptions();
    if (ke(s, e ?? {}))
      return i;
    L(
      i,
      "already-initialized"
      /* AuthErrorCode.ALREADY_INITIALIZED */
    );
  }
  return t.initialize({ options: e });
}
function ns(n, e) {
  const t = (e == null ? void 0 : e.persistence) || [], r = (Array.isArray(t) ? t : [t]).map(V);
  e != null && e.errorMap && n._updateErrorMap(e.errorMap), n._initializeWithPersistence(r, e == null ? void 0 : e.popupRedirectResolver);
}
function rs(n, e, t) {
  const r = ie(n);
  v(
    r._canInitEmulator,
    r,
    "emulator-config-failed"
    /* AuthErrorCode.EMULATOR_CONFIG_FAILED */
  ), v(
    /^https?:\/\//.test(e),
    r,
    "invalid-emulator-scheme"
    /* AuthErrorCode.INVALID_EMULATOR_SCHEME */
  );
  const i = !1, s = Pn(e), { host: o, port: a } = is(e), c = a === null ? "" : `:${a}`;
  r.config.emulator = { url: `${s}//${o}${c}/` }, r.settings.appVerificationDisabledForTesting = !0, r.emulatorConfig = Object.freeze({
    host: o,
    port: a,
    protocol: s.replace(":", ""),
    options: Object.freeze({ disableWarnings: i })
  }), ss();
}
function Pn(n) {
  const e = n.indexOf(":");
  return e < 0 ? "" : n.substr(0, e + 1);
}
function is(n) {
  const e = Pn(n), t = /(\/\/)?([^?#/]+)/.exec(n.substr(e.length));
  if (!t)
    return { host: "", port: null };
  const r = t[2].split("@").pop() || "", i = /^(\[[^\]]+\])(:|$)/.exec(r);
  if (i) {
    const s = i[1];
    return { host: s, port: Mt(r.substr(s.length + 1)) };
  } else {
    const [s, o] = r.split(":");
    return { host: s, port: Mt(o) };
  }
}
function Mt(n) {
  if (!n)
    return null;
  const e = Number(n);
  return isNaN(e) ? null : e;
}
function ss() {
  function n() {
    const e = document.createElement("p"), t = e.style;
    e.innerText = "Running in emulator mode. Do not use with production credentials.", t.position = "fixed", t.width = "100%", t.backgroundColor = "#ffffff", t.border = ".1em solid #000000", t.color = "#b50000", t.bottom = "0px", t.left = "0px", t.margin = "0px", t.zIndex = "10000", t.textAlign = "center", e.classList.add("firebase-emulator-warning"), document.body.appendChild(e);
  }
  typeof console < "u" && typeof console.info == "function" && console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials."), typeof window < "u" && typeof document < "u" && (document.readyState === "loading" ? window.addEventListener("DOMContentLoaded", n) : n());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class pt {
  /** @internal */
  constructor(e, t) {
    this.providerId = e, this.signInMethod = t;
  }
  /**
   * Returns a JSON-serializable representation of this object.
   *
   * @returns a JSON-serializable representation of this object.
   */
  toJSON() {
    return F("not implemented");
  }
  /** @internal */
  _getIdTokenResponse(e) {
    return F("not implemented");
  }
  /** @internal */
  _linkToIdToken(e, t) {
    return F("not implemented");
  }
  /** @internal */
  _getReauthenticationResolver(e) {
    return F("not implemented");
  }
}
async function os(n, e) {
  return W(n, "POST", "/v1/accounts:signUp", e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function as(n, e) {
  return Fe(n, "POST", "/v1/accounts:signInWithPassword", ee(n, e));
}
async function cs(n, e) {
  return W(n, "POST", "/v1/accounts:sendOobCode", ee(n, e));
}
async function ls(n, e) {
  return cs(n, e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function ds(n, e) {
  return Fe(n, "POST", "/v1/accounts:signInWithEmailLink", ee(n, e));
}
async function us(n, e) {
  return Fe(n, "POST", "/v1/accounts:signInWithEmailLink", ee(n, e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ve extends pt {
  /** @internal */
  constructor(e, t, r, i = null) {
    super("password", r), this._email = e, this._password = t, this._tenantId = i;
  }
  /** @internal */
  static _fromEmailAndPassword(e, t) {
    return new ve(
      e,
      t,
      "password"
      /* SignInMethod.EMAIL_PASSWORD */
    );
  }
  /** @internal */
  static _fromEmailAndCode(e, t, r = null) {
    return new ve(e, t, "emailLink", r);
  }
  /** {@inheritdoc AuthCredential.toJSON} */
  toJSON() {
    return {
      email: this._email,
      password: this._password,
      signInMethod: this.signInMethod,
      tenantId: this._tenantId
    };
  }
  /**
   * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
   *
   * @param json - Either `object` or the stringified representation of the object. When string is
   * provided, `JSON.parse` would be called first.
   *
   * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
   */
  static fromJSON(e) {
    const t = typeof e == "string" ? JSON.parse(e) : e;
    if (t != null && t.email && (t != null && t.password)) {
      if (t.signInMethod === "password")
        return this._fromEmailAndPassword(t.email, t.password);
      if (t.signInMethod === "emailLink")
        return this._fromEmailAndCode(t.email, t.password, t.tenantId);
    }
    return null;
  }
  /** @internal */
  async _getIdTokenResponse(e) {
    switch (this.signInMethod) {
      case "password":
        const t = {
          returnSecureToken: !0,
          email: this._email,
          password: this._password,
          clientType: "CLIENT_TYPE_WEB"
          /* RecaptchaClientType.WEB */
        };
        return it(e, t, "signInWithPassword", as);
      case "emailLink":
        return ds(e, {
          email: this._email,
          oobCode: this._password
        });
      default:
        L(
          e,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  /** @internal */
  async _linkToIdToken(e, t) {
    switch (this.signInMethod) {
      case "password":
        const r = {
          idToken: t,
          returnSecureToken: !0,
          email: this._email,
          password: this._password,
          clientType: "CLIENT_TYPE_WEB"
          /* RecaptchaClientType.WEB */
        };
        return it(e, r, "signUpPassword", os);
      case "emailLink":
        return us(e, {
          idToken: t,
          email: this._email,
          oobCode: this._password
        });
      default:
        L(
          e,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  /** @internal */
  _getReauthenticationResolver(e) {
    return this._getIdTokenResponse(e);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function le(n, e) {
  return Fe(n, "POST", "/v1/accounts:signInWithIdp", ee(n, e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const hs = "http://localhost";
class re extends pt {
  constructor() {
    super(...arguments), this.pendingToken = null;
  }
  /** @internal */
  static _fromParams(e) {
    const t = new re(e.providerId, e.signInMethod);
    return e.idToken || e.accessToken ? (e.idToken && (t.idToken = e.idToken), e.accessToken && (t.accessToken = e.accessToken), e.nonce && !e.pendingToken && (t.nonce = e.nonce), e.pendingToken && (t.pendingToken = e.pendingToken)) : e.oauthToken && e.oauthTokenSecret ? (t.accessToken = e.oauthToken, t.secret = e.oauthTokenSecret) : L(
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), t;
  }
  /** {@inheritdoc AuthCredential.toJSON}  */
  toJSON() {
    return {
      idToken: this.idToken,
      accessToken: this.accessToken,
      secret: this.secret,
      nonce: this.nonce,
      pendingToken: this.pendingToken,
      providerId: this.providerId,
      signInMethod: this.signInMethod
    };
  }
  /**
   * Static method to deserialize a JSON representation of an object into an
   * {@link  AuthCredential}.
   *
   * @param json - Input can be either Object or the stringified representation of the object.
   * When string is provided, JSON.parse would be called first.
   *
   * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
   */
  static fromJSON(e) {
    const t = typeof e == "string" ? JSON.parse(e) : e, { providerId: r, signInMethod: i } = t, s = lt(t, ["providerId", "signInMethod"]);
    if (!r || !i)
      return null;
    const o = new re(r, i);
    return o.idToken = s.idToken || void 0, o.accessToken = s.accessToken || void 0, o.secret = s.secret, o.nonce = s.nonce, o.pendingToken = s.pendingToken || null, o;
  }
  /** @internal */
  _getIdTokenResponse(e) {
    const t = this.buildRequest();
    return le(e, t);
  }
  /** @internal */
  _linkToIdToken(e, t) {
    const r = this.buildRequest();
    return r.idToken = t, le(e, r);
  }
  /** @internal */
  _getReauthenticationResolver(e) {
    const t = this.buildRequest();
    return t.autoCreate = !1, le(e, t);
  }
  buildRequest() {
    const e = {
      requestUri: hs,
      returnSecureToken: !0
    };
    if (this.pendingToken)
      e.pendingToken = this.pendingToken;
    else {
      const t = {};
      this.idToken && (t.id_token = this.idToken), this.accessToken && (t.access_token = this.accessToken), this.secret && (t.oauth_token_secret = this.secret), t.providerId = this.providerId, this.nonce && !this.pendingToken && (t.nonce = this.nonce), e.postBody = Ie(t);
    }
    return e;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function fs(n) {
  switch (n) {
    case "recoverEmail":
      return "RECOVER_EMAIL";
    case "resetPassword":
      return "PASSWORD_RESET";
    case "signIn":
      return "EMAIL_SIGNIN";
    case "verifyEmail":
      return "VERIFY_EMAIL";
    case "verifyAndChangeEmail":
      return "VERIFY_AND_CHANGE_EMAIL";
    case "revertSecondFactorAddition":
      return "REVERT_SECOND_FACTOR_ADDITION";
    default:
      return null;
  }
}
function ps(n) {
  const e = fe(pe(n)).link, t = e ? fe(pe(e)).deep_link_id : null, r = fe(pe(n)).deep_link_id;
  return (r ? fe(pe(r)).link : null) || r || t || e || n;
}
class gt {
  /**
   * @param actionLink - The link from which to extract the URL.
   * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
   *
   * @internal
   */
  constructor(e) {
    var t, r, i, s, o, a;
    const c = fe(pe(e)), u = (t = c.apiKey) !== null && t !== void 0 ? t : null, y = (r = c.oobCode) !== null && r !== void 0 ? r : null, b = fs((i = c.mode) !== null && i !== void 0 ? i : null);
    v(
      u && y && b,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), this.apiKey = u, this.operation = b, this.code = y, this.continueUrl = (s = c.continueUrl) !== null && s !== void 0 ? s : null, this.languageCode = (o = c.languageCode) !== null && o !== void 0 ? o : null, this.tenantId = (a = c.tenantId) !== null && a !== void 0 ? a : null;
  }
  /**
   * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
   * otherwise returns null.
   *
   * @param link  - The email action link string.
   * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
   *
   * @public
   */
  static parseLink(e) {
    const t = ps(e);
    try {
      return new gt(t);
    } catch {
      return null;
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class he {
  constructor() {
    this.providerId = he.PROVIDER_ID;
  }
  /**
   * Initialize an {@link AuthCredential} using an email and password.
   *
   * @example
   * ```javascript
   * const authCredential = EmailAuthProvider.credential(email, password);
   * const userCredential = await signInWithCredential(auth, authCredential);
   * ```
   *
   * @example
   * ```javascript
   * const userCredential = await signInWithEmailAndPassword(auth, email, password);
   * ```
   *
   * @param email - Email address.
   * @param password - User account password.
   * @returns The auth provider credential.
   */
  static credential(e, t) {
    return ve._fromEmailAndPassword(e, t);
  }
  /**
   * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
   * email link operation.
   *
   * @example
   * ```javascript
   * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
   * const userCredential = await signInWithCredential(auth, authCredential);
   * ```
   *
   * @example
   * ```javascript
   * await sendSignInLinkToEmail(auth, email);
   * // Obtain emailLink from user.
   * const userCredential = await signInWithEmailLink(auth, email, emailLink);
   * ```
   *
   * @param auth - The {@link Auth} instance used to verify the link.
   * @param email - Email address.
   * @param emailLink - Sign-in email link.
   * @returns - The auth provider credential.
   */
  static credentialWithLink(e, t) {
    const r = gt.parseLink(t);
    return v(
      r,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), ve._fromEmailAndCode(e, r.code, r.tenantId);
  }
}
he.PROVIDER_ID = "password";
he.EMAIL_PASSWORD_SIGN_IN_METHOD = "password";
he.EMAIL_LINK_SIGN_IN_METHOD = "emailLink";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class On {
  /**
   * Constructor for generic OAuth providers.
   *
   * @param providerId - Provider for which credentials should be generated.
   */
  constructor(e) {
    this.providerId = e, this.defaultLanguageCode = null, this.customParameters = {};
  }
  /**
   * Set the language gode.
   *
   * @param languageCode - language code
   */
  setDefaultLanguage(e) {
    this.defaultLanguageCode = e;
  }
  /**
   * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
   * operations.
   *
   * @remarks
   * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
   * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
   *
   * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
   */
  setCustomParameters(e) {
    return this.customParameters = e, this;
  }
  /**
   * Retrieve the current list of {@link CustomParameters}.
   */
  getCustomParameters() {
    return this.customParameters;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Te extends On {
  constructor() {
    super(...arguments), this.scopes = [];
  }
  /**
   * Add an OAuth scope to the credential.
   *
   * @param scope - Provider OAuth scope to add.
   */
  addScope(e) {
    return this.scopes.includes(e) || this.scopes.push(e), this;
  }
  /**
   * Retrieve the current list of OAuth scopes.
   */
  getScopes() {
    return [...this.scopes];
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class q extends Te {
  constructor() {
    super(
      "facebook.com"
      /* ProviderId.FACEBOOK */
    );
  }
  /**
   * Creates a credential for Facebook.
   *
   * @example
   * ```javascript
   * // `event` from the Facebook auth.authResponseChange callback.
   * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param accessToken - Facebook access token.
   */
  static credential(e) {
    return re._fromParams({
      providerId: q.PROVIDER_ID,
      signInMethod: q.FACEBOOK_SIGN_IN_METHOD,
      accessToken: e
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(e) {
    return q.credentialFromTaggedObject(e);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(e) {
    return q.credentialFromTaggedObject(e.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: e }) {
    if (!e || !("oauthAccessToken" in e) || !e.oauthAccessToken)
      return null;
    try {
      return q.credential(e.oauthAccessToken);
    } catch {
      return null;
    }
  }
}
q.FACEBOOK_SIGN_IN_METHOD = "facebook.com";
q.PROVIDER_ID = "facebook.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class J extends Te {
  constructor() {
    super(
      "google.com"
      /* ProviderId.GOOGLE */
    ), this.addScope("profile");
  }
  /**
   * Creates a credential for Google. At least one of ID token and access token is required.
   *
   * @example
   * ```javascript
   * // \`googleUser\` from the onsuccess Google Sign In callback.
   * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param idToken - Google ID token.
   * @param accessToken - Google access token.
   */
  static credential(e, t) {
    return re._fromParams({
      providerId: J.PROVIDER_ID,
      signInMethod: J.GOOGLE_SIGN_IN_METHOD,
      idToken: e,
      accessToken: t
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(e) {
    return J.credentialFromTaggedObject(e);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(e) {
    return J.credentialFromTaggedObject(e.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: e }) {
    if (!e)
      return null;
    const { oauthIdToken: t, oauthAccessToken: r } = e;
    if (!t && !r)
      return null;
    try {
      return J.credential(t, r);
    } catch {
      return null;
    }
  }
}
J.GOOGLE_SIGN_IN_METHOD = "google.com";
J.PROVIDER_ID = "google.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class G extends Te {
  constructor() {
    super(
      "github.com"
      /* ProviderId.GITHUB */
    );
  }
  /**
   * Creates a credential for Github.
   *
   * @param accessToken - Github access token.
   */
  static credential(e) {
    return re._fromParams({
      providerId: G.PROVIDER_ID,
      signInMethod: G.GITHUB_SIGN_IN_METHOD,
      accessToken: e
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(e) {
    return G.credentialFromTaggedObject(e);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(e) {
    return G.credentialFromTaggedObject(e.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: e }) {
    if (!e || !("oauthAccessToken" in e) || !e.oauthAccessToken)
      return null;
    try {
      return G.credential(e.oauthAccessToken);
    } catch {
      return null;
    }
  }
}
G.GITHUB_SIGN_IN_METHOD = "github.com";
G.PROVIDER_ID = "github.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class K extends Te {
  constructor() {
    super(
      "twitter.com"
      /* ProviderId.TWITTER */
    );
  }
  /**
   * Creates a credential for Twitter.
   *
   * @param token - Twitter access token.
   * @param secret - Twitter secret.
   */
  static credential(e, t) {
    return re._fromParams({
      providerId: K.PROVIDER_ID,
      signInMethod: K.TWITTER_SIGN_IN_METHOD,
      oauthToken: e,
      oauthTokenSecret: t
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(e) {
    return K.credentialFromTaggedObject(e);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(e) {
    return K.credentialFromTaggedObject(e.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: e }) {
    if (!e)
      return null;
    const { oauthAccessToken: t, oauthTokenSecret: r } = e;
    if (!t || !r)
      return null;
    try {
      return K.credential(t, r);
    } catch {
      return null;
    }
  }
}
K.TWITTER_SIGN_IN_METHOD = "twitter.com";
K.PROVIDER_ID = "twitter.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ue {
  constructor(e) {
    this.user = e.user, this.providerId = e.providerId, this._tokenResponse = e._tokenResponse, this.operationType = e.operationType;
  }
  static async _fromIdTokenResponse(e, t, r, i = !1) {
    const s = await B._fromIdTokenResponse(e, r, i), o = Ut(r);
    return new ue({
      user: s,
      providerId: o,
      _tokenResponse: r,
      operationType: t
    });
  }
  static async _forOperation(e, t, r) {
    await e._updateTokensIfNecessary(
      r,
      /* reload */
      !0
    );
    const i = Ut(r);
    return new ue({
      user: e,
      providerId: i,
      _tokenResponse: r,
      operationType: t
    });
  }
}
function Ut(n) {
  return n.providerId ? n.providerId : "phoneNumber" in n ? "phone" : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class $e extends Z {
  constructor(e, t, r, i) {
    var s;
    super(t.code, t.message), this.operationType = r, this.user = i, Object.setPrototypeOf(this, $e.prototype), this.customData = {
      appName: e.name,
      tenantId: (s = e.tenantId) !== null && s !== void 0 ? s : void 0,
      _serverResponse: t.customData._serverResponse,
      operationType: r
    };
  }
  static _fromErrorAndOperation(e, t, r, i) {
    return new $e(e, t, r, i);
  }
}
function kn(n, e, t, r) {
  return (e === "reauthenticate" ? t._getReauthenticationResolver(n) : t._getIdTokenResponse(n)).catch((s) => {
    throw s.code === "auth/multi-factor-auth-required" ? $e._fromErrorAndOperation(n, s, e, r) : s;
  });
}
async function gs(n, e, t = !1) {
  const r = await _e(n, e._linkToIdToken(n.auth, await n.getIdToken()), t);
  return ue._forOperation(n, "link", r);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function ms(n, e, t = !1) {
  const { auth: r } = n;
  if (j(r.app))
    return Promise.reject(X(r));
  const i = "reauthenticate";
  try {
    const s = await _e(n, kn(r, i, e, n), t);
    v(
      s.idToken,
      r,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const o = ht(s.idToken);
    v(
      o,
      r,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const { sub: a } = o;
    return v(
      n.uid === a,
      r,
      "user-mismatch"
      /* AuthErrorCode.USER_MISMATCH */
    ), ue._forOperation(n, i, s);
  } catch (s) {
    throw (s == null ? void 0 : s.code) === "auth/user-not-found" && L(
      r,
      "user-mismatch"
      /* AuthErrorCode.USER_MISMATCH */
    ), s;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Nn(n, e, t = !1) {
  if (j(n.app))
    return Promise.reject(X(n));
  const r = "signIn", i = await kn(n, r, e), s = await ue._fromIdTokenResponse(n, r, i);
  return t || await n._updateCurrentUser(s.user), s;
}
async function ys(n, e) {
  return Nn(ie(n), e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _s(n) {
  const e = ie(n);
  e._getPasswordPolicyInternal() && await e._updatePasswordPolicy();
}
async function vs(n, e, t) {
  const r = ie(n);
  await it(r, {
    requestType: "PASSWORD_RESET",
    email: e,
    clientType: "CLIENT_TYPE_WEB"
    /* RecaptchaClientType.WEB */
  }, "getOobCode", ls);
}
function bs(n, e, t) {
  return j(n.app) ? Promise.reject(X(n)) : ys(x(n), he.credential(e, t)).catch(async (r) => {
    throw r.code === "auth/password-does-not-meet-requirements" && _s(n), r;
  });
}
function Is(n, e, t, r) {
  return x(n).onIdTokenChanged(e, t, r);
}
function ws(n, e, t) {
  return x(n).beforeAuthStateChanged(e, t);
}
function Es(n, e, t, r) {
  return x(n).onAuthStateChanged(e, t, r);
}
function Ts(n) {
  return x(n).signOut();
}
const Me = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Dn {
  constructor(e, t) {
    this.storageRetriever = e, this.type = t;
  }
  _isAvailable() {
    try {
      return this.storage ? (this.storage.setItem(Me, "1"), this.storage.removeItem(Me), Promise.resolve(!0)) : Promise.resolve(!1);
    } catch {
      return Promise.resolve(!1);
    }
  }
  _set(e, t) {
    return this.storage.setItem(e, JSON.stringify(t)), Promise.resolve();
  }
  _get(e) {
    const t = this.storage.getItem(e);
    return Promise.resolve(t ? JSON.parse(t) : null);
  }
  _remove(e) {
    return this.storage.removeItem(e), Promise.resolve();
  }
  get storage() {
    return this.storageRetriever();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ss() {
  const n = P();
  return ft(n) || Be(n);
}
const As = 1e3, Cs = 10;
class Ln extends Dn {
  constructor() {
    super(
      () => window.localStorage,
      "LOCAL"
      /* PersistenceType.LOCAL */
    ), this.boundEventHandler = (e, t) => this.onStorageEvent(e, t), this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.safariLocalStorageNotSynced = Ss() && Hi(), this.fallbackToPolling = An(), this._shouldAllowMigration = !0;
  }
  forAllChangedKeys(e) {
    for (const t of Object.keys(this.listeners)) {
      const r = this.storage.getItem(t), i = this.localCache[t];
      r !== i && e(t, i, r);
    }
  }
  onStorageEvent(e, t = !1) {
    if (!e.key) {
      this.forAllChangedKeys((o, a, c) => {
        this.notifyListeners(o, c);
      });
      return;
    }
    const r = e.key;
    if (t ? this.detachListener() : this.stopPolling(), this.safariLocalStorageNotSynced) {
      const o = this.storage.getItem(r);
      if (e.newValue !== o)
        e.newValue !== null ? this.storage.setItem(r, e.newValue) : this.storage.removeItem(r);
      else if (this.localCache[r] === e.newValue && !t)
        return;
    }
    const i = () => {
      const o = this.storage.getItem(r);
      !t && this.localCache[r] === o || this.notifyListeners(r, o);
    }, s = this.storage.getItem(r);
    Vi() && s !== e.newValue && e.newValue !== e.oldValue ? setTimeout(i, Cs) : i();
  }
  notifyListeners(e, t) {
    this.localCache[e] = t;
    const r = this.listeners[e];
    if (r)
      for (const i of Array.from(r))
        i(t && JSON.parse(t));
  }
  startPolling() {
    this.stopPolling(), this.pollTimer = setInterval(() => {
      this.forAllChangedKeys((e, t, r) => {
        this.onStorageEvent(
          new StorageEvent("storage", {
            key: e,
            oldValue: t,
            newValue: r
          }),
          /* poll */
          !0
        );
      });
    }, As);
  }
  stopPolling() {
    this.pollTimer && (clearInterval(this.pollTimer), this.pollTimer = null);
  }
  attachListener() {
    window.addEventListener("storage", this.boundEventHandler);
  }
  detachListener() {
    window.removeEventListener("storage", this.boundEventHandler);
  }
  _addListener(e, t) {
    Object.keys(this.listeners).length === 0 && (this.fallbackToPolling ? this.startPolling() : this.attachListener()), this.listeners[e] || (this.listeners[e] = /* @__PURE__ */ new Set(), this.localCache[e] = this.storage.getItem(e)), this.listeners[e].add(t);
  }
  _removeListener(e, t) {
    this.listeners[e] && (this.listeners[e].delete(t), this.listeners[e].size === 0 && delete this.listeners[e]), Object.keys(this.listeners).length === 0 && (this.detachListener(), this.stopPolling());
  }
  // Update local cache on base operations:
  async _set(e, t) {
    await super._set(e, t), this.localCache[e] = JSON.stringify(t);
  }
  async _get(e) {
    const t = await super._get(e);
    return this.localCache[e] = JSON.stringify(t), t;
  }
  async _remove(e) {
    await super._remove(e), delete this.localCache[e];
  }
}
Ln.type = "LOCAL";
const Rs = Ln;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class $n extends Dn {
  constructor() {
    super(
      () => window.sessionStorage,
      "SESSION"
      /* PersistenceType.SESSION */
    );
  }
  _addListener(e, t) {
  }
  _removeListener(e, t) {
  }
}
$n.type = "SESSION";
const Mn = $n;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ps(n) {
  return Promise.all(n.map(async (e) => {
    try {
      return {
        fulfilled: !0,
        value: await e
      };
    } catch (t) {
      return {
        fulfilled: !1,
        reason: t
      };
    }
  }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class He {
  constructor(e) {
    this.eventTarget = e, this.handlersMap = {}, this.boundEventHandler = this.handleEvent.bind(this);
  }
  /**
   * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
   *
   * @param eventTarget - An event target (such as window or self) through which the underlying
   * messages will be received.
   */
  static _getInstance(e) {
    const t = this.receivers.find((i) => i.isListeningto(e));
    if (t)
      return t;
    const r = new He(e);
    return this.receivers.push(r), r;
  }
  isListeningto(e) {
    return this.eventTarget === e;
  }
  /**
   * Fans out a MessageEvent to the appropriate listeners.
   *
   * @remarks
   * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
   * finished processing.
   *
   * @param event - The MessageEvent.
   *
   */
  async handleEvent(e) {
    const t = e, { eventId: r, eventType: i, data: s } = t.data, o = this.handlersMap[i];
    if (!(o != null && o.size))
      return;
    t.ports[0].postMessage({
      status: "ack",
      eventId: r,
      eventType: i
    });
    const a = Array.from(o).map(async (u) => u(t.origin, s)), c = await Ps(a);
    t.ports[0].postMessage({
      status: "done",
      eventId: r,
      eventType: i,
      response: c
    });
  }
  /**
   * Subscribe an event handler for a particular event.
   *
   * @param eventType - Event name to subscribe to.
   * @param eventHandler - The event handler which should receive the events.
   *
   */
  _subscribe(e, t) {
    Object.keys(this.handlersMap).length === 0 && this.eventTarget.addEventListener("message", this.boundEventHandler), this.handlersMap[e] || (this.handlersMap[e] = /* @__PURE__ */ new Set()), this.handlersMap[e].add(t);
  }
  /**
   * Unsubscribe an event handler from a particular event.
   *
   * @param eventType - Event name to unsubscribe from.
   * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
   *
   */
  _unsubscribe(e, t) {
    this.handlersMap[e] && t && this.handlersMap[e].delete(t), (!t || this.handlersMap[e].size === 0) && delete this.handlersMap[e], Object.keys(this.handlersMap).length === 0 && this.eventTarget.removeEventListener("message", this.boundEventHandler);
  }
}
He.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function mt(n = "", e = 10) {
  let t = "";
  for (let r = 0; r < e; r++)
    t += Math.floor(Math.random() * 10);
  return n + t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Os {
  constructor(e) {
    this.target = e, this.handlers = /* @__PURE__ */ new Set();
  }
  /**
   * Unsubscribe the handler and remove it from our tracking Set.
   *
   * @param handler - The handler to unsubscribe.
   */
  removeMessageHandler(e) {
    e.messageChannel && (e.messageChannel.port1.removeEventListener("message", e.onMessage), e.messageChannel.port1.close()), this.handlers.delete(e);
  }
  /**
   * Send a message to the Receiver located at {@link target}.
   *
   * @remarks
   * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
   * receiver has had a chance to fully process the event.
   *
   * @param eventType - Type of event to send.
   * @param data - The payload of the event.
   * @param timeout - Timeout for waiting on an ACK from the receiver.
   *
   * @returns An array of settled promises from all the handlers that were listening on the receiver.
   */
  async _send(e, t, r = 50) {
    const i = typeof MessageChannel < "u" ? new MessageChannel() : null;
    if (!i)
      throw new Error(
        "connection_unavailable"
        /* _MessageError.CONNECTION_UNAVAILABLE */
      );
    let s, o;
    return new Promise((a, c) => {
      const u = mt("", 20);
      i.port1.start();
      const y = setTimeout(() => {
        c(new Error(
          "unsupported_event"
          /* _MessageError.UNSUPPORTED_EVENT */
        ));
      }, r);
      o = {
        messageChannel: i,
        onMessage(b) {
          const A = b;
          if (A.data.eventId === u)
            switch (A.data.status) {
              case "ack":
                clearTimeout(y), s = setTimeout(
                  () => {
                    c(new Error(
                      "timeout"
                      /* _MessageError.TIMEOUT */
                    ));
                  },
                  3e3
                  /* _TimeoutDuration.COMPLETION */
                );
                break;
              case "done":
                clearTimeout(s), a(A.data.response);
                break;
              default:
                clearTimeout(y), clearTimeout(s), c(new Error(
                  "invalid_response"
                  /* _MessageError.INVALID_RESPONSE */
                ));
                break;
            }
        }
      }, this.handlers.add(o), i.port1.addEventListener("message", o.onMessage), this.target.postMessage({
        eventType: e,
        eventId: u,
        data: t
      }, [i.port2]);
    }).finally(() => {
      o && this.removeMessageHandler(o);
    });
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function M() {
  return window;
}
function ks(n) {
  M().location.href = n;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Un() {
  return typeof M().WorkerGlobalScope < "u" && typeof M().importScripts == "function";
}
async function Ns() {
  if (!(navigator != null && navigator.serviceWorker))
    return null;
  try {
    return (await navigator.serviceWorker.ready).active;
  } catch {
    return null;
  }
}
function Ds() {
  var n;
  return ((n = navigator == null ? void 0 : navigator.serviceWorker) === null || n === void 0 ? void 0 : n.controller) || null;
}
function Ls() {
  return Un() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const jn = "firebaseLocalStorageDb", $s = 1, Ue = "firebaseLocalStorage", Fn = "fbase_key";
class Se {
  constructor(e) {
    this.request = e;
  }
  toPromise() {
    return new Promise((e, t) => {
      this.request.addEventListener("success", () => {
        e(this.request.result);
      }), this.request.addEventListener("error", () => {
        t(this.request.error);
      });
    });
  }
}
function xe(n, e) {
  return n.transaction([Ue], e ? "readwrite" : "readonly").objectStore(Ue);
}
function Ms() {
  const n = indexedDB.deleteDatabase(jn);
  return new Se(n).toPromise();
}
function st() {
  const n = indexedDB.open(jn, $s);
  return new Promise((e, t) => {
    n.addEventListener("error", () => {
      t(n.error);
    }), n.addEventListener("upgradeneeded", () => {
      const r = n.result;
      try {
        r.createObjectStore(Ue, { keyPath: Fn });
      } catch (i) {
        t(i);
      }
    }), n.addEventListener("success", async () => {
      const r = n.result;
      r.objectStoreNames.contains(Ue) ? e(r) : (r.close(), await Ms(), e(await st()));
    });
  });
}
async function jt(n, e, t) {
  const r = xe(n, !0).put({
    [Fn]: e,
    value: t
  });
  return new Se(r).toPromise();
}
async function Us(n, e) {
  const t = xe(n, !1).get(e), r = await new Se(t).toPromise();
  return r === void 0 ? null : r.value;
}
function Ft(n, e) {
  const t = xe(n, !0).delete(e);
  return new Se(t).toPromise();
}
const js = 800, Fs = 3;
class Bn {
  constructor() {
    this.type = "LOCAL", this._shouldAllowMigration = !0, this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.pendingWrites = 0, this.receiver = null, this.sender = null, this.serviceWorkerReceiverAvailable = !1, this.activeServiceWorker = null, this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(() => {
    }, () => {
    });
  }
  async _openDb() {
    return this.db ? this.db : (this.db = await st(), this.db);
  }
  async _withRetries(e) {
    let t = 0;
    for (; ; )
      try {
        const r = await this._openDb();
        return await e(r);
      } catch (r) {
        if (t++ > Fs)
          throw r;
        this.db && (this.db.close(), this.db = void 0);
      }
  }
  /**
   * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
   * postMessage interface to send these events to the worker ourselves.
   */
  async initializeServiceWorkerMessaging() {
    return Un() ? this.initializeReceiver() : this.initializeSender();
  }
  /**
   * As the worker we should listen to events from the main window.
   */
  async initializeReceiver() {
    this.receiver = He._getInstance(Ls()), this.receiver._subscribe("keyChanged", async (e, t) => ({
      keyProcessed: (await this._poll()).includes(t.key)
    })), this.receiver._subscribe("ping", async (e, t) => [
      "keyChanged"
      /* _EventType.KEY_CHANGED */
    ]);
  }
  /**
   * As the main window, we should let the worker know when keys change (set and remove).
   *
   * @remarks
   * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
   * may not resolve.
   */
  async initializeSender() {
    var e, t;
    if (this.activeServiceWorker = await Ns(), !this.activeServiceWorker)
      return;
    this.sender = new Os(this.activeServiceWorker);
    const r = await this.sender._send(
      "ping",
      {},
      800
      /* _TimeoutDuration.LONG_ACK */
    );
    r && !((e = r[0]) === null || e === void 0) && e.fulfilled && !((t = r[0]) === null || t === void 0) && t.value.includes(
      "keyChanged"
      /* _EventType.KEY_CHANGED */
    ) && (this.serviceWorkerReceiverAvailable = !0);
  }
  /**
   * Let the worker know about a changed key, the exact key doesn't technically matter since the
   * worker will just trigger a full sync anyway.
   *
   * @remarks
   * For now, we only support one service worker per page.
   *
   * @param key - Storage key which changed.
   */
  async notifyServiceWorker(e) {
    if (!(!this.sender || !this.activeServiceWorker || Ds() !== this.activeServiceWorker))
      try {
        await this.sender._send(
          "keyChanged",
          { key: e },
          // Use long timeout if receiver has previously responded to a ping from us.
          this.serviceWorkerReceiverAvailable ? 800 : 50
          /* _TimeoutDuration.ACK */
        );
      } catch {
      }
  }
  async _isAvailable() {
    try {
      if (!indexedDB)
        return !1;
      const e = await st();
      return await jt(e, Me, "1"), await Ft(e, Me), !0;
    } catch {
    }
    return !1;
  }
  async _withPendingWrite(e) {
    this.pendingWrites++;
    try {
      await e();
    } finally {
      this.pendingWrites--;
    }
  }
  async _set(e, t) {
    return this._withPendingWrite(async () => (await this._withRetries((r) => jt(r, e, t)), this.localCache[e] = t, this.notifyServiceWorker(e)));
  }
  async _get(e) {
    const t = await this._withRetries((r) => Us(r, e));
    return this.localCache[e] = t, t;
  }
  async _remove(e) {
    return this._withPendingWrite(async () => (await this._withRetries((t) => Ft(t, e)), delete this.localCache[e], this.notifyServiceWorker(e)));
  }
  async _poll() {
    const e = await this._withRetries((i) => {
      const s = xe(i, !1).getAll();
      return new Se(s).toPromise();
    });
    if (!e)
      return [];
    if (this.pendingWrites !== 0)
      return [];
    const t = [], r = /* @__PURE__ */ new Set();
    if (e.length !== 0)
      for (const { fbase_key: i, value: s } of e)
        r.add(i), JSON.stringify(this.localCache[i]) !== JSON.stringify(s) && (this.notifyListeners(i, s), t.push(i));
    for (const i of Object.keys(this.localCache))
      this.localCache[i] && !r.has(i) && (this.notifyListeners(i, null), t.push(i));
    return t;
  }
  notifyListeners(e, t) {
    this.localCache[e] = t;
    const r = this.listeners[e];
    if (r)
      for (const i of Array.from(r))
        i(t);
  }
  startPolling() {
    this.stopPolling(), this.pollTimer = setInterval(async () => this._poll(), js);
  }
  stopPolling() {
    this.pollTimer && (clearInterval(this.pollTimer), this.pollTimer = null);
  }
  _addListener(e, t) {
    Object.keys(this.listeners).length === 0 && this.startPolling(), this.listeners[e] || (this.listeners[e] = /* @__PURE__ */ new Set(), this._get(e)), this.listeners[e].add(t);
  }
  _removeListener(e, t) {
    this.listeners[e] && (this.listeners[e].delete(t), this.listeners[e].size === 0 && delete this.listeners[e]), Object.keys(this.listeners).length === 0 && this.stopPolling();
  }
}
Bn.type = "LOCAL";
const Bs = Bn;
new Ee(3e4, 6e4);
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Vs(n, e) {
  return e ? V(e) : (v(
    n._popupRedirectResolver,
    n,
    "argument-error"
    /* AuthErrorCode.ARGUMENT_ERROR */
  ), n._popupRedirectResolver);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class yt extends pt {
  constructor(e) {
    super(
      "custom",
      "custom"
      /* ProviderId.CUSTOM */
    ), this.params = e;
  }
  _getIdTokenResponse(e) {
    return le(e, this._buildIdpRequest());
  }
  _linkToIdToken(e, t) {
    return le(e, this._buildIdpRequest(t));
  }
  _getReauthenticationResolver(e) {
    return le(e, this._buildIdpRequest());
  }
  _buildIdpRequest(e) {
    const t = {
      requestUri: this.params.requestUri,
      sessionId: this.params.sessionId,
      postBody: this.params.postBody,
      tenantId: this.params.tenantId,
      pendingToken: this.params.pendingToken,
      returnSecureToken: !0,
      returnIdpCredential: !0
    };
    return e && (t.idToken = e), t;
  }
}
function Hs(n) {
  return Nn(n.auth, new yt(n), n.bypassAuthState);
}
function xs(n) {
  const { auth: e, user: t } = n;
  return v(
    t,
    e,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), ms(t, new yt(n), n.bypassAuthState);
}
async function Ws(n) {
  const { auth: e, user: t } = n;
  return v(
    t,
    e,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), gs(t, new yt(n), n.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Vn {
  constructor(e, t, r, i, s = !1) {
    this.auth = e, this.resolver = r, this.user = i, this.bypassAuthState = s, this.pendingPromise = null, this.eventManager = null, this.filter = Array.isArray(t) ? t : [t];
  }
  execute() {
    return new Promise(async (e, t) => {
      this.pendingPromise = { resolve: e, reject: t };
      try {
        this.eventManager = await this.resolver._initialize(this.auth), await this.onExecution(), this.eventManager.registerConsumer(this);
      } catch (r) {
        this.reject(r);
      }
    });
  }
  async onAuthEvent(e) {
    const { urlResponse: t, sessionId: r, postBody: i, tenantId: s, error: o, type: a } = e;
    if (o) {
      this.reject(o);
      return;
    }
    const c = {
      auth: this.auth,
      requestUri: t,
      sessionId: r,
      tenantId: s || void 0,
      postBody: i || void 0,
      user: this.user,
      bypassAuthState: this.bypassAuthState
    };
    try {
      this.resolve(await this.getIdpTask(a)(c));
    } catch (u) {
      this.reject(u);
    }
  }
  onError(e) {
    this.reject(e);
  }
  getIdpTask(e) {
    switch (e) {
      case "signInViaPopup":
      case "signInViaRedirect":
        return Hs;
      case "linkViaPopup":
      case "linkViaRedirect":
        return Ws;
      case "reauthViaPopup":
      case "reauthViaRedirect":
        return xs;
      default:
        L(
          this.auth,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  resolve(e) {
    H(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.resolve(e), this.unregisterAndCleanUp();
  }
  reject(e) {
    H(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.reject(e), this.unregisterAndCleanUp();
  }
  unregisterAndCleanUp() {
    this.eventManager && this.eventManager.unregisterConsumer(this), this.pendingPromise = null, this.cleanUp();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const zs = new Ee(2e3, 1e4);
class se extends Vn {
  constructor(e, t, r, i, s) {
    super(e, t, i, s), this.provider = r, this.authWindow = null, this.pollId = null, se.currentPopupAction && se.currentPopupAction.cancel(), se.currentPopupAction = this;
  }
  async executeNotNull() {
    const e = await this.execute();
    return v(
      e,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), e;
  }
  async onExecution() {
    H(this.filter.length === 1, "Popup operations only handle one event");
    const e = mt();
    this.authWindow = await this.resolver._openPopup(
      this.auth,
      this.provider,
      this.filter[0],
      // There's always one, see constructor
      e
    ), this.authWindow.associatedEvent = e, this.resolver._originValidation(this.auth).catch((t) => {
      this.reject(t);
    }), this.resolver._isIframeWebStorageSupported(this.auth, (t) => {
      t || this.reject($(
        this.auth,
        "web-storage-unsupported"
        /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */
      ));
    }), this.pollUserCancellation();
  }
  get eventId() {
    var e;
    return ((e = this.authWindow) === null || e === void 0 ? void 0 : e.associatedEvent) || null;
  }
  cancel() {
    this.reject($(
      this.auth,
      "cancelled-popup-request"
      /* AuthErrorCode.EXPIRED_POPUP_REQUEST */
    ));
  }
  cleanUp() {
    this.authWindow && this.authWindow.close(), this.pollId && window.clearTimeout(this.pollId), this.authWindow = null, this.pollId = null, se.currentPopupAction = null;
  }
  pollUserCancellation() {
    const e = () => {
      var t, r;
      if (!((r = (t = this.authWindow) === null || t === void 0 ? void 0 : t.window) === null || r === void 0) && r.closed) {
        this.pollId = window.setTimeout(
          () => {
            this.pollId = null, this.reject($(
              this.auth,
              "popup-closed-by-user"
              /* AuthErrorCode.POPUP_CLOSED_BY_USER */
            ));
          },
          8e3
          /* _Timeout.AUTH_EVENT */
        );
        return;
      }
      this.pollId = window.setTimeout(e, zs.get());
    };
    e();
  }
}
se.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const qs = "pendingRedirect", Pe = /* @__PURE__ */ new Map();
class Js extends Vn {
  constructor(e, t, r = !1) {
    super(e, [
      "signInViaRedirect",
      "linkViaRedirect",
      "reauthViaRedirect",
      "unknown"
      /* AuthEventType.UNKNOWN */
    ], t, void 0, r), this.eventId = null;
  }
  /**
   * Override the execute function; if we already have a redirect result, then
   * just return it.
   */
  async execute() {
    let e = Pe.get(this.auth._key());
    if (!e) {
      try {
        const r = await Gs(this.resolver, this.auth) ? await super.execute() : null;
        e = () => Promise.resolve(r);
      } catch (t) {
        e = () => Promise.reject(t);
      }
      Pe.set(this.auth._key(), e);
    }
    return this.bypassAuthState || Pe.set(this.auth._key(), () => Promise.resolve(null)), e();
  }
  async onAuthEvent(e) {
    if (e.type === "signInViaRedirect")
      return super.onAuthEvent(e);
    if (e.type === "unknown") {
      this.resolve(null);
      return;
    }
    if (e.eventId) {
      const t = await this.auth._redirectUserForId(e.eventId);
      if (t)
        return this.user = t, super.onAuthEvent(e);
      this.resolve(null);
    }
  }
  async onExecution() {
  }
  cleanUp() {
  }
}
async function Gs(n, e) {
  const t = Qs(e), r = Ys(n);
  if (!await r._isAvailable())
    return !1;
  const i = await r._get(t) === "true";
  return await r._remove(t), i;
}
function Ks(n, e) {
  Pe.set(n._key(), e);
}
function Ys(n) {
  return V(n._redirectPersistence);
}
function Qs(n) {
  return Re(qs, n.config.apiKey, n.name);
}
async function Xs(n, e, t = !1) {
  if (j(n.app))
    return Promise.reject(X(n));
  const r = ie(n), i = Vs(r, e), o = await new Js(r, i, t).execute();
  return o && !t && (delete o.user._redirectEventId, await r._persistUserIfCurrent(o.user), await r._setRedirectUser(null, e)), o;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Zs = 10 * 60 * 1e3;
class eo {
  constructor(e) {
    this.auth = e, this.cachedEventUids = /* @__PURE__ */ new Set(), this.consumers = /* @__PURE__ */ new Set(), this.queuedRedirectEvent = null, this.hasHandledPotentialRedirect = !1, this.lastProcessedEventTime = Date.now();
  }
  registerConsumer(e) {
    this.consumers.add(e), this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, e) && (this.sendToConsumer(this.queuedRedirectEvent, e), this.saveEventToCache(this.queuedRedirectEvent), this.queuedRedirectEvent = null);
  }
  unregisterConsumer(e) {
    this.consumers.delete(e);
  }
  onEvent(e) {
    if (this.hasEventBeenHandled(e))
      return !1;
    let t = !1;
    return this.consumers.forEach((r) => {
      this.isEventForConsumer(e, r) && (t = !0, this.sendToConsumer(e, r), this.saveEventToCache(e));
    }), this.hasHandledPotentialRedirect || !to(e) || (this.hasHandledPotentialRedirect = !0, t || (this.queuedRedirectEvent = e, t = !0)), t;
  }
  sendToConsumer(e, t) {
    var r;
    if (e.error && !Hn(e)) {
      const i = ((r = e.error.code) === null || r === void 0 ? void 0 : r.split("auth/")[1]) || "internal-error";
      t.onError($(this.auth, i));
    } else
      t.onAuthEvent(e);
  }
  isEventForConsumer(e, t) {
    const r = t.eventId === null || !!e.eventId && e.eventId === t.eventId;
    return t.filter.includes(e.type) && r;
  }
  hasEventBeenHandled(e) {
    return Date.now() - this.lastProcessedEventTime >= Zs && this.cachedEventUids.clear(), this.cachedEventUids.has(Bt(e));
  }
  saveEventToCache(e) {
    this.cachedEventUids.add(Bt(e)), this.lastProcessedEventTime = Date.now();
  }
}
function Bt(n) {
  return [n.type, n.eventId, n.sessionId, n.tenantId].filter((e) => e).join("-");
}
function Hn({ type: n, error: e }) {
  return n === "unknown" && (e == null ? void 0 : e.code) === "auth/no-auth-event";
}
function to(n) {
  switch (n.type) {
    case "signInViaRedirect":
    case "linkViaRedirect":
    case "reauthViaRedirect":
      return !0;
    case "unknown":
      return Hn(n);
    default:
      return !1;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function no(n, e = {}) {
  return W(n, "GET", "/v1/projects", e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ro = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, io = /^https?/;
async function so(n) {
  if (n.config.emulator)
    return;
  const { authorizedDomains: e } = await no(n);
  for (const t of e)
    try {
      if (oo(t))
        return;
    } catch {
    }
  L(
    n,
    "unauthorized-domain"
    /* AuthErrorCode.INVALID_ORIGIN */
  );
}
function oo(n) {
  const e = nt(), { protocol: t, hostname: r } = new URL(e);
  if (n.startsWith("chrome-extension://")) {
    const o = new URL(n);
    return o.hostname === "" && r === "" ? t === "chrome-extension:" && n.replace("chrome-extension://", "") === e.replace("chrome-extension://", "") : t === "chrome-extension:" && o.hostname === r;
  }
  if (!io.test(t))
    return !1;
  if (ro.test(n))
    return r === n;
  const i = n.replace(/\./g, "\\.");
  return new RegExp("^(.+\\." + i + "|" + i + ")$", "i").test(r);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ao = new Ee(3e4, 6e4);
function Vt() {
  const n = M().___jsl;
  if (n != null && n.H) {
    for (const e of Object.keys(n.H))
      if (n.H[e].r = n.H[e].r || [], n.H[e].L = n.H[e].L || [], n.H[e].r = [...n.H[e].L], n.CP)
        for (let t = 0; t < n.CP.length; t++)
          n.CP[t] = null;
  }
}
function co(n) {
  return new Promise((e, t) => {
    var r, i, s;
    function o() {
      Vt(), gapi.load("gapi.iframes", {
        callback: () => {
          e(gapi.iframes.getContext());
        },
        ontimeout: () => {
          Vt(), t($(
            n,
            "network-request-failed"
            /* AuthErrorCode.NETWORK_REQUEST_FAILED */
          ));
        },
        timeout: ao.get()
      });
    }
    if (!((i = (r = M().gapi) === null || r === void 0 ? void 0 : r.iframes) === null || i === void 0) && i.Iframe)
      e(gapi.iframes.getContext());
    else if (!((s = M().gapi) === null || s === void 0) && s.load)
      o();
    else {
      const a = Qi("iframefcb");
      return M()[a] = () => {
        gapi.load ? o() : t($(
          n,
          "network-request-failed"
          /* AuthErrorCode.NETWORK_REQUEST_FAILED */
        ));
      }, Rn(`${Yi()}?onload=${a}`).catch((c) => t(c));
    }
  }).catch((e) => {
    throw Oe = null, e;
  });
}
let Oe = null;
function lo(n) {
  return Oe = Oe || co(n), Oe;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const uo = new Ee(5e3, 15e3), ho = "__/auth/iframe", fo = "emulator/auth/iframe", po = {
  style: {
    position: "absolute",
    top: "-100px",
    width: "1px",
    height: "1px"
  },
  "aria-hidden": "true",
  tabindex: "-1"
}, go = /* @__PURE__ */ new Map([
  ["identitytoolkit.googleapis.com", "p"],
  ["staging-identitytoolkit.sandbox.googleapis.com", "s"],
  ["test-identitytoolkit.sandbox.googleapis.com", "t"]
  // test
]);
function mo(n) {
  const e = n.config;
  v(
    e.authDomain,
    n,
    "auth-domain-config-required"
    /* AuthErrorCode.MISSING_AUTH_DOMAIN */
  );
  const t = e.emulator ? ut(e, fo) : `https://${n.config.authDomain}/${ho}`, r = {
    apiKey: e.apiKey,
    appName: n.name,
    v: we
  }, i = go.get(n.config.apiHost);
  i && (r.eid = i);
  const s = n._getFrameworks();
  return s.length && (r.fw = s.join(",")), `${t}?${Ie(r).slice(1)}`;
}
async function yo(n) {
  const e = await lo(n), t = M().gapi;
  return v(
    t,
    n,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), e.open({
    where: document.body,
    url: mo(n),
    messageHandlersFilter: t.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
    attributes: po,
    dontclear: !0
  }, (r) => new Promise(async (i, s) => {
    await r.restyle({
      // Prevent iframe from closing on mouse out.
      setHideOnLeave: !1
    });
    const o = $(
      n,
      "network-request-failed"
      /* AuthErrorCode.NETWORK_REQUEST_FAILED */
    ), a = M().setTimeout(() => {
      s(o);
    }, uo.get());
    function c() {
      M().clearTimeout(a), i(r);
    }
    r.ping(c).then(c, () => {
      s(o);
    });
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _o = {
  location: "yes",
  resizable: "yes",
  statusbar: "yes",
  toolbar: "no"
}, vo = 500, bo = 600, Io = "_blank", wo = "http://localhost";
class Ht {
  constructor(e) {
    this.window = e, this.associatedEvent = null;
  }
  close() {
    if (this.window)
      try {
        this.window.close();
      } catch {
      }
  }
}
function Eo(n, e, t, r = vo, i = bo) {
  const s = Math.max((window.screen.availHeight - i) / 2, 0).toString(), o = Math.max((window.screen.availWidth - r) / 2, 0).toString();
  let a = "";
  const c = Object.assign(Object.assign({}, _o), {
    width: r.toString(),
    height: i.toString(),
    top: s,
    left: o
  }), u = P().toLowerCase();
  t && (a = In(u) ? Io : t), bn(u) && (e = e || wo, c.scrollbars = "yes");
  const y = Object.entries(c).reduce((A, [O, N]) => `${A}${O}=${N},`, "");
  if (Bi(u) && a !== "_self")
    return To(e || "", a), new Ht(null);
  const b = window.open(e || "", a, y);
  v(
    b,
    n,
    "popup-blocked"
    /* AuthErrorCode.POPUP_BLOCKED */
  );
  try {
    b.focus();
  } catch {
  }
  return new Ht(b);
}
function To(n, e) {
  const t = document.createElement("a");
  t.href = n, t.target = e;
  const r = document.createEvent("MouseEvent");
  r.initMouseEvent("click", !0, !0, window, 1, 0, 0, 0, 0, !1, !1, !1, !1, 1, null), t.dispatchEvent(r);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const So = "__/auth/handler", Ao = "emulator/auth/handler", Co = encodeURIComponent("fac");
async function xt(n, e, t, r, i, s) {
  v(
    n.config.authDomain,
    n,
    "auth-domain-config-required"
    /* AuthErrorCode.MISSING_AUTH_DOMAIN */
  ), v(
    n.config.apiKey,
    n,
    "invalid-api-key"
    /* AuthErrorCode.INVALID_API_KEY */
  );
  const o = {
    apiKey: n.config.apiKey,
    appName: n.name,
    authType: t,
    redirectUrl: r,
    v: we,
    eventId: i
  };
  if (e instanceof On) {
    e.setDefaultLanguage(n.languageCode), o.providerId = e.providerId || "", cr(e.getCustomParameters()) || (o.customParameters = JSON.stringify(e.getCustomParameters()));
    for (const [y, b] of Object.entries({}))
      o[y] = b;
  }
  if (e instanceof Te) {
    const y = e.getScopes().filter((b) => b !== "");
    y.length > 0 && (o.scopes = y.join(","));
  }
  n.tenantId && (o.tid = n.tenantId);
  const a = o;
  for (const y of Object.keys(a))
    a[y] === void 0 && delete a[y];
  const c = await n._getAppCheckToken(), u = c ? `#${Co}=${encodeURIComponent(c)}` : "";
  return `${Ro(n)}?${Ie(a).slice(1)}${u}`;
}
function Ro({ config: n }) {
  return n.emulator ? ut(n, Ao) : `https://${n.authDomain}/${So}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Ye = "webStorageSupport";
class Po {
  constructor() {
    this.eventManagers = {}, this.iframes = {}, this.originValidationPromises = {}, this._redirectPersistence = Mn, this._completeRedirectFn = Xs, this._overrideRedirectResult = Ks;
  }
  // Wrapping in async even though we don't await anywhere in order
  // to make sure errors are raised as promise rejections
  async _openPopup(e, t, r, i) {
    var s;
    H((s = this.eventManagers[e._key()]) === null || s === void 0 ? void 0 : s.manager, "_initialize() not called before _openPopup()");
    const o = await xt(e, t, r, nt(), i);
    return Eo(e, o, mt());
  }
  async _openRedirect(e, t, r, i) {
    await this._originValidation(e);
    const s = await xt(e, t, r, nt(), i);
    return ks(s), new Promise(() => {
    });
  }
  _initialize(e) {
    const t = e._key();
    if (this.eventManagers[t]) {
      const { manager: i, promise: s } = this.eventManagers[t];
      return i ? Promise.resolve(i) : (H(s, "If manager is not set, promise should be"), s);
    }
    const r = this.initAndGetManager(e);
    return this.eventManagers[t] = { promise: r }, r.catch(() => {
      delete this.eventManagers[t];
    }), r;
  }
  async initAndGetManager(e) {
    const t = await yo(e), r = new eo(e);
    return t.register("authEvent", (i) => (v(
      i == null ? void 0 : i.authEvent,
      e,
      "invalid-auth-event"
      /* AuthErrorCode.INVALID_AUTH_EVENT */
    ), {
      status: r.onEvent(i.authEvent) ? "ACK" : "ERROR"
      /* GapiOutcome.ERROR */
    }), gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER), this.eventManagers[e._key()] = { manager: r }, this.iframes[e._key()] = t, r;
  }
  _isIframeWebStorageSupported(e, t) {
    this.iframes[e._key()].send(Ye, { type: Ye }, (i) => {
      var s;
      const o = (s = i == null ? void 0 : i[0]) === null || s === void 0 ? void 0 : s[Ye];
      o !== void 0 && t(!!o), L(
        e,
        "internal-error"
        /* AuthErrorCode.INTERNAL_ERROR */
      );
    }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
  }
  _originValidation(e) {
    const t = e._key();
    return this.originValidationPromises[t] || (this.originValidationPromises[t] = so(e)), this.originValidationPromises[t];
  }
  get _shouldInitProactively() {
    return An() || ft() || Be();
  }
}
const Oo = Po;
var Wt = "@firebase/auth", zt = "1.7.4";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ko {
  constructor(e) {
    this.auth = e, this.internalListeners = /* @__PURE__ */ new Map();
  }
  getUid() {
    var e;
    return this.assertAuthConfigured(), ((e = this.auth.currentUser) === null || e === void 0 ? void 0 : e.uid) || null;
  }
  async getToken(e) {
    return this.assertAuthConfigured(), await this.auth._initializationPromise, this.auth.currentUser ? { accessToken: await this.auth.currentUser.getIdToken(e) } : null;
  }
  addAuthTokenListener(e) {
    if (this.assertAuthConfigured(), this.internalListeners.has(e))
      return;
    const t = this.auth.onIdTokenChanged((r) => {
      e((r == null ? void 0 : r.stsTokenManager.accessToken) || null);
    });
    this.internalListeners.set(e, t), this.updateProactiveRefresh();
  }
  removeAuthTokenListener(e) {
    this.assertAuthConfigured();
    const t = this.internalListeners.get(e);
    t && (this.internalListeners.delete(e), t(), this.updateProactiveRefresh());
  }
  assertAuthConfigured() {
    v(
      this.auth._initializationPromise,
      "dependent-sdk-initialized-before-auth"
      /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */
    );
  }
  updateProactiveRefresh() {
    this.internalListeners.size > 0 ? this.auth._startProactiveRefresh() : this.auth._stopProactiveRefresh();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function No(n) {
  switch (n) {
    case "Node":
      return "node";
    case "ReactNative":
      return "rn";
    case "Worker":
      return "webworker";
    case "Cordova":
      return "cordova";
    case "WebExtension":
      return "web-extension";
    default:
      return;
  }
}
function Do(n) {
  me(new de(
    "auth",
    (e, { options: t }) => {
      const r = e.getProvider("app").getImmediate(), i = e.getProvider("heartbeat"), s = e.getProvider("app-check-internal"), { apiKey: o, authDomain: a } = r.options;
      v(o && !o.includes(":"), "invalid-api-key", { appName: r.name });
      const c = {
        apiKey: o,
        authDomain: a,
        clientPlatform: n,
        apiHost: "identitytoolkit.googleapis.com",
        tokenApiHost: "securetoken.googleapis.com",
        apiScheme: "https",
        sdkClientVersion: Cn(n)
      }, u = new Ji(r, i, s, c);
      return ns(u, t), u;
    },
    "PUBLIC"
    /* ComponentType.PUBLIC */
  ).setInstantiationMode(
    "EXPLICIT"
    /* InstantiationMode.EXPLICIT */
  ).setInstanceCreatedCallback((e, t, r) => {
    e.getProvider(
      "auth-internal"
      /* _ComponentName.AUTH_INTERNAL */
    ).initialize();
  })), me(new de(
    "auth-internal",
    (e) => {
      const t = ie(e.getProvider(
        "auth"
        /* _ComponentName.AUTH */
      ).getImmediate());
      return ((r) => new ko(r))(t);
    },
    "PRIVATE"
    /* ComponentType.PRIVATE */
  ).setInstantiationMode(
    "EXPLICIT"
    /* InstantiationMode.EXPLICIT */
  )), oe(Wt, zt, No(n)), oe(Wt, zt, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Lo = 5 * 60, $o = nn("authIdTokenMaxAge") || Lo;
let qt = null;
const Mo = (n) => async (e) => {
  const t = e && await e.getIdTokenResult(), r = t && ((/* @__PURE__ */ new Date()).getTime() - Date.parse(t.issuedAtTime)) / 1e3;
  if (r && r > $o)
    return;
  const i = t == null ? void 0 : t.token;
  qt !== i && (qt = i, await fetch(n, {
    method: i ? "POST" : "DELETE",
    headers: i ? {
      Authorization: `Bearer ${i}`
    } : {}
  }));
};
function Uo(n = li()) {
  const e = an(n, "auth");
  if (e.isInitialized())
    return e.getImmediate();
  const t = ts(n, {
    popupRedirectResolver: Oo,
    persistence: [
      Bs,
      Rs,
      Mn
    ]
  }), r = nn("authTokenSyncURL");
  if (r && typeof isSecureContext == "boolean" && isSecureContext) {
    const s = new URL(r, location.origin);
    if (location.origin === s.origin) {
      const o = Mo(s.toString());
      ws(t, o, () => o(t.currentUser)), Is(t, (a) => o(a));
    }
  }
  const i = Qn("auth");
  return i && rs(t, `http://${i}`), t;
}
function jo() {
  var n, e;
  return (e = (n = document.getElementsByTagName("head")) === null || n === void 0 ? void 0 : n[0]) !== null && e !== void 0 ? e : document;
}
Gi({
  loadJS(n) {
    return new Promise((e, t) => {
      const r = document.createElement("script");
      r.setAttribute("src", n), r.onload = e, r.onerror = (i) => {
        const s = $(
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
        s.customData = i, t(s);
      }, r.type = "text/javascript", r.charset = "UTF-8", jo().appendChild(r);
    });
  },
  gapiScript: "https://apis.google.com/js/api.js",
  recaptchaV2Script: "https://www.google.com/recaptcha/api.js",
  recaptchaEnterpriseScript: "https://www.google.com/recaptcha/enterprise.js?render="
});
Do(
  "Browser"
  /* ClientPlatform.BROWSER */
);
var Fo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Bo(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var xn = { exports: {} };
(function(n) {
  (function(e) {
    function t(l, m) {
      var d = (l & 65535) + (m & 65535), w = (l >> 16) + (m >> 16) + (d >> 16);
      return w << 16 | d & 65535;
    }
    function r(l, m) {
      return l << m | l >>> 32 - m;
    }
    function i(l, m, d, w, E, S) {
      return t(r(t(t(m, l), t(w, S)), E), d);
    }
    function s(l, m, d, w, E, S, R) {
      return i(m & d | ~m & w, l, m, E, S, R);
    }
    function o(l, m, d, w, E, S, R) {
      return i(m & w | d & ~w, l, m, E, S, R);
    }
    function a(l, m, d, w, E, S, R) {
      return i(m ^ d ^ w, l, m, E, S, R);
    }
    function c(l, m, d, w, E, S, R) {
      return i(d ^ (m | ~w), l, m, E, S, R);
    }
    function u(l, m) {
      l[m >> 5] |= 128 << m % 32, l[(m + 64 >>> 9 << 4) + 14] = m;
      var d, w, E, S, R, h = 1732584193, f = -271733879, p = -1732584194, g = 271733878;
      for (d = 0; d < l.length; d += 16)
        w = h, E = f, S = p, R = g, h = s(h, f, p, g, l[d], 7, -680876936), g = s(g, h, f, p, l[d + 1], 12, -389564586), p = s(p, g, h, f, l[d + 2], 17, 606105819), f = s(f, p, g, h, l[d + 3], 22, -1044525330), h = s(h, f, p, g, l[d + 4], 7, -176418897), g = s(g, h, f, p, l[d + 5], 12, 1200080426), p = s(p, g, h, f, l[d + 6], 17, -1473231341), f = s(f, p, g, h, l[d + 7], 22, -45705983), h = s(h, f, p, g, l[d + 8], 7, 1770035416), g = s(g, h, f, p, l[d + 9], 12, -1958414417), p = s(p, g, h, f, l[d + 10], 17, -42063), f = s(f, p, g, h, l[d + 11], 22, -1990404162), h = s(h, f, p, g, l[d + 12], 7, 1804603682), g = s(g, h, f, p, l[d + 13], 12, -40341101), p = s(p, g, h, f, l[d + 14], 17, -1502002290), f = s(f, p, g, h, l[d + 15], 22, 1236535329), h = o(h, f, p, g, l[d + 1], 5, -165796510), g = o(g, h, f, p, l[d + 6], 9, -1069501632), p = o(p, g, h, f, l[d + 11], 14, 643717713), f = o(f, p, g, h, l[d], 20, -373897302), h = o(h, f, p, g, l[d + 5], 5, -701558691), g = o(g, h, f, p, l[d + 10], 9, 38016083), p = o(p, g, h, f, l[d + 15], 14, -660478335), f = o(f, p, g, h, l[d + 4], 20, -405537848), h = o(h, f, p, g, l[d + 9], 5, 568446438), g = o(g, h, f, p, l[d + 14], 9, -1019803690), p = o(p, g, h, f, l[d + 3], 14, -187363961), f = o(f, p, g, h, l[d + 8], 20, 1163531501), h = o(h, f, p, g, l[d + 13], 5, -1444681467), g = o(g, h, f, p, l[d + 2], 9, -51403784), p = o(p, g, h, f, l[d + 7], 14, 1735328473), f = o(f, p, g, h, l[d + 12], 20, -1926607734), h = a(h, f, p, g, l[d + 5], 4, -378558), g = a(g, h, f, p, l[d + 8], 11, -2022574463), p = a(p, g, h, f, l[d + 11], 16, 1839030562), f = a(f, p, g, h, l[d + 14], 23, -35309556), h = a(h, f, p, g, l[d + 1], 4, -1530992060), g = a(g, h, f, p, l[d + 4], 11, 1272893353), p = a(p, g, h, f, l[d + 7], 16, -155497632), f = a(f, p, g, h, l[d + 10], 23, -1094730640), h = a(h, f, p, g, l[d + 13], 4, 681279174), g = a(g, h, f, p, l[d], 11, -358537222), p = a(p, g, h, f, l[d + 3], 16, -722521979), f = a(f, p, g, h, l[d + 6], 23, 76029189), h = a(h, f, p, g, l[d + 9], 4, -640364487), g = a(g, h, f, p, l[d + 12], 11, -421815835), p = a(p, g, h, f, l[d + 15], 16, 530742520), f = a(f, p, g, h, l[d + 2], 23, -995338651), h = c(h, f, p, g, l[d], 6, -198630844), g = c(g, h, f, p, l[d + 7], 10, 1126891415), p = c(p, g, h, f, l[d + 14], 15, -1416354905), f = c(f, p, g, h, l[d + 5], 21, -57434055), h = c(h, f, p, g, l[d + 12], 6, 1700485571), g = c(g, h, f, p, l[d + 3], 10, -1894986606), p = c(p, g, h, f, l[d + 10], 15, -1051523), f = c(f, p, g, h, l[d + 1], 21, -2054922799), h = c(h, f, p, g, l[d + 8], 6, 1873313359), g = c(g, h, f, p, l[d + 15], 10, -30611744), p = c(p, g, h, f, l[d + 6], 15, -1560198380), f = c(f, p, g, h, l[d + 13], 21, 1309151649), h = c(h, f, p, g, l[d + 4], 6, -145523070), g = c(g, h, f, p, l[d + 11], 10, -1120210379), p = c(p, g, h, f, l[d + 2], 15, 718787259), f = c(f, p, g, h, l[d + 9], 21, -343485551), h = t(h, w), f = t(f, E), p = t(p, S), g = t(g, R);
      return [h, f, p, g];
    }
    function y(l) {
      var m, d = "", w = l.length * 32;
      for (m = 0; m < w; m += 8)
        d += String.fromCharCode(l[m >> 5] >>> m % 32 & 255);
      return d;
    }
    function b(l) {
      var m, d = [];
      for (d[(l.length >> 2) - 1] = void 0, m = 0; m < d.length; m += 1)
        d[m] = 0;
      var w = l.length * 8;
      for (m = 0; m < w; m += 8)
        d[m >> 5] |= (l.charCodeAt(m / 8) & 255) << m % 32;
      return d;
    }
    function A(l) {
      return y(u(b(l), l.length * 8));
    }
    function O(l, m) {
      var d, w = b(l), E = [], S = [], R;
      for (E[15] = S[15] = void 0, w.length > 16 && (w = u(w, l.length * 8)), d = 0; d < 16; d += 1)
        E[d] = w[d] ^ 909522486, S[d] = w[d] ^ 1549556828;
      return R = u(E.concat(b(m)), 512 + m.length * 8), y(u(S.concat(R), 640));
    }
    function N(l) {
      var m = "0123456789abcdef", d = "", w, E;
      for (E = 0; E < l.length; E += 1)
        w = l.charCodeAt(E), d += m.charAt(w >>> 4 & 15) + m.charAt(w & 15);
      return d;
    }
    function _(l) {
      return unescape(encodeURIComponent(l));
    }
    function I(l) {
      return A(_(l));
    }
    function k(l) {
      return N(I(l));
    }
    function C(l, m) {
      return O(_(l), _(m));
    }
    function U(l, m) {
      return N(C(l, m));
    }
    function D(l, m, d) {
      return m ? d ? C(m, l) : U(m, l) : d ? I(l) : k(l);
    }
    n.exports ? n.exports = D : e.md5 = D;
  })(Fo);
})(xn);
var Vo = xn.exports;
const Ho = /* @__PURE__ */ Bo(Vo), _t = (n, e) => async (t, r = {}) => {
  const i = e ? await e.getIdToken() : null, s = await fetch(`${n}${t}`, {
    mode: "cors",
    ...r,
    headers: {
      ...i && { authorization: `Bearer ${i}` },
      ...r.body && { "content-type": "application/json" },
      ...r.headers
    },
    ...r.body && { body: JSON.stringify(r.body) }
  }), o = await s.json();
  if (s.status > 202)
    throw Object.assign(new Error((o == null ? void 0 : o.message) || `HTTP Error ${s.status}`), {
      status: s.status,
      code: o == null ? void 0 : o.code,
      body: o
    });
  return o;
}, xo = (n) => {
  const e = n.properties || {}, t = n.inputProps || Object.keys(e), r = (i, s) => {
    const o = e[i] || {};
    if ([null, void 0].includes(s))
      return o.isRequired ? { id: "value-missing-validation-error" } : void 0;
    if (o.enum)
      return o.isScalar ? o.enum.includes(s) ? void 0 : {
        id: "enum-validation-error",
        values: { enum: o.enum, value: s }
      } : !s || !(s != null && s.length) || !s.filter((u) => !o.enum.includes(u)).length ? void 0 : {
        id: "enum-validation-error",
        values: { enum: o.enum, value: s }
      };
    switch (o.type) {
      case "integer":
        if (o.isScalar && (typeof s != "number" || Number.isNaN(s)))
          return { id: "invalid-number-validation-error" };
        break;
      case "date":
        break;
      case "boolean":
        break;
      case "json":
      case "string":
      default:
        if (o.isRequired && !s)
          return { id: "value-missing-validation-error" };
        break;
    }
  };
  return {
    validate: (i) => t.reduce(
      (s, o) => {
        const a = r(o, i[o]);
        return a ? { ...s, [o]: a } : s;
      },
      {}
    ),
    validateAttr: r
  };
}, Wo = (n = {}) => Object.keys(n).length ? `?q=${JSON.stringify(n)}` : "", zo = (n) => [...n].reduce(
  (e, t) => t === t.toUpperCase() ? `${e}-${t.toLowerCase()}` : `${e}${t}`,
  ""
), qo = (n) => `${n[0].toLowerCase()}${n.slice(1)}`, Jo = (n) => {
  const e = zo(n);
  return (t, r) => `/${e}${t ? `/${encodeURIComponent(t)}` : ""}${Wo(r)}`;
}, Jt = (n, e) => {
  const t = Array.isArray(e.inputProps);
  return Object.keys(n).reduce(
    (r, i) => {
      if (t && !e.inputProps.includes(i))
        return r;
      const { isRef: s, isScalar: o, isRequired: a } = e.properties[i] || {};
      return s && o && !a && n[i] === null ? r : {
        ...r,
        [i]: n[i]
      };
    },
    {}
  );
}, Go = ({ primaryKey: n, properties: e, ...t }) => ({
  primaryKey: n || "id",
  properties: Object.keys(e || {}).reduce(
    (r, i) => {
      var b, A;
      const s = e[i] || {}, { type: o, isScalar: a, isRequired: c, isRef: u = !1 } = typeof s.type == "string" ? s.type === "array" ? s.enum ? { type: "string", isScalar: !1, isRequired: !1 } : (b = s.items) != null && b.$ref ? { type: s.items.$ref.split("/").pop(), isScalar: !1, isRequired: !1, isRef: !0 } : { type: (A = s.items) == null ? void 0 : A.type, isScalar: !1, isRequired: !1 } : { type: s.format === "date-time" ? "date" : s.type, isScalar: !0, isRequired: !0 } : Array.isArray(s.type) ? s.type.length === 2 ? { type: s.format === "date-time" ? "date" : s.type[0], isScalar: !0, isRequired: !1 } : { type: "json", isScalar: !0, isRequired: s.type.includes("null") } : s.$ref ? { type: s.$ref.split("/").pop(), isScalar: !0, isRequired: !0, isRef: !0 } : { type: s.anyOf[0].$ref.split("/").pop(), isScalar: !0, isRequired: !1, isRef: !0 }, y = s.inputType || (o === "integer" ? "number" : o);
      return {
        ...r,
        [i]: {
          ...e[i],
          type: o,
          isScalar: a,
          isRequired: typeof s.isRequired == "boolean" ? s.isRequired : c,
          isRef: u,
          inputType: y
        }
      };
    },
    {}
  ),
  ...t
}), Ko = (n, e, t, r = {}, i = {}) => {
  const s = Go(r), { primaryKey: o, properties: a } = s, c = xo(s), u = Jo(t), y = (..._) => _t(n, e.authUser)(..._), b = ({ data: _, ...I }) => y(u(null, I), {
    method: "POST",
    body: Jt(_, s)
  }), A = ({ data: _, ...I }) => {
    const { where: k, ...C } = I;
    return y(u(k[o], C), {
      method: "PUT",
      body: Jt(_, s)
    });
  }, O = (_) => {
    if (!_)
      return _;
    const I = Object.keys(_).reduce(
      (k, C) => {
        var E;
        const U = a[C] || {}, { type: D, isScalar: l, isRef: m, format: d, items: w } = U;
        if (m) {
          const S = qo(D);
          return l ? {
            ...k,
            [C]: i[S].parse(_[C])
          } : {
            ...k,
            [C]: typeof ((E = i[S]) == null ? void 0 : E.parse) == "function" ? _[C].map((R) => i[S].parse(R)) : _[C]
          };
        }
        return {
          ...k,
          [C]: D === "date" && _[C] ? new Date(_[C]) : _[C]
        };
      },
      {}
    );
    return typeof s.parse == "function" ? s.parse(I) : I;
  }, N = Object.keys(a || {}).reduce(
    (_, I) => a[I].isRef && a[I].isScalar && a[I].isRequired ? Object.assign(_, {
      all: _.all.concat(I),
      oneToOne: _.oneToOne.concat(I),
      requiredOneToOne: _.requiredOneToOne.concat(I)
    }) : a[I].isRef && a[I].isScalar ? Object.assign(_, {
      all: _.all.concat(I),
      oneToOne: _.oneToOne.concat(I),
      optionalOneToOne: _.optionalOneToOne.concat(I)
    }) : a[I].isRef ? Object.assign(_, {
      all: _.all.concat(I),
      oneToMany: _.oneToMany.concat(I)
    }) : _,
    {
      all: [],
      oneToOne: [],
      requiredOneToOne: [],
      optionalOneToOne: [],
      oneToMany: []
    }
  );
  return {
    get schema() {
      return s;
    },
    get relations() {
      return N;
    },
    parse: O,
    validateAttr: c.validateAttr,
    validate: c.validate,
    findMany: (_) => y(u(null, _)).then((I) => I.map(O)),
    findById: (_, I) => y(u(_, I)).then(O),
    create: b,
    update: A,
    upsert: (_) => _.where[o] ? A({ where: _.where, data: _.update }) : b({ data: _.create }),
    delete: (_) => y(u(_), { method: "DELETE" }),
    stats: () => y(u("_stats")),
    search: (_, I = {}) => {
      var d;
      const { searchProps: k } = s, U = _.split(" ").reduce(
        (w, E) => [
          ...w,
          {
            OR: k.reduce(
              (S, R) => {
                const h = R.split(".");
                return [
                  ...S,
                  h.reduceRight(
                    (f, p) => ({ [p]: f }),
                    { contains: E, mode: "insensitive" }
                  )
                ];
              },
              []
            )
          }
        ],
        []
      ), D = { ...I.select, ...I.include }, l = (d = s.defaultProps) != null && d.length ? Object.assign(...s.defaultProps.map((w) => ({ [w]: !0 }))) : null, m = Object.keys(D).length ? D : l;
      return y(u(null, {
        where: {
          ...I.where,
          AND: U
        },
        ...!!m && { select: m },
        ...I.orderBy && { orderBy: I.orderBy },
        take: I.take || 100
      }));
    }
  };
}, Yo = (n, e, t) => Object.keys(t.properties).reduce(
  (r, i) => {
    const s = t.properties[i].$ref.split("/").pop();
    return Object.assign(r, {
      [i]: Ko(
        n,
        e,
        t.definitions[s].plural || `${i}s`,
        t.definitions[s],
        r
      )
    });
  },
  {}
), Qo = (n, e) => Object.keys(n.definitions).reduce(
  (t, r) => ({
    ...t,
    [r]: e[r] ? {
      ...n.definitions[r],
      ...e[r],
      properties: Object.keys(n.definitions[r].properties).reduce(
        (i, s) => ({
          ...i,
          [s]: {
            ...n.definitions[r].properties[s],
            ...(e[r].properties || {})[s]
          }
        }),
        e[r].properties || {}
      )
    } : n.definitions[r]
  }),
  {}
), Xo = "http://json-schema.org/draft-07/schema#", Zo = {
  Country: {
    type: "object",
    properties: {
      code: {
        type: "string"
      },
      name: {
        type: "string"
      },
      incomeFilter: {
        type: [
          "integer",
          "null"
        ]
      },
      canApply: {
        type: "boolean",
        default: !1
      },
      capital: {
        type: "array",
        items: {
          type: "string"
        }
      },
      timeZone: {
        type: [
          "string",
          "null"
        ]
      },
      flag: {
        type: [
          "string",
          "null"
        ]
      },
      currency: {
        anyOf: [
          {
            $ref: "#/definitions/Currency"
          },
          {
            type: "null"
          }
        ]
      },
      contracts: {
        type: "array",
        items: {
          $ref: "#/definitions/Contract"
        }
      },
      users: {
        type: "array",
        items: {
          $ref: "#/definitions/User"
        }
      },
      applications: {
        type: "array",
        items: {
          $ref: "#/definitions/Application"
        }
      },
      applicationNationalities: {
        type: "array",
        items: {
          $ref: "#/definitions/Application"
        }
      },
      educationLevels: {
        type: "array",
        items: {
          $ref: "#/definitions/EducationLevel"
        }
      },
      universities: {
        type: "array",
        items: {
          $ref: "#/definitions/University"
        }
      },
      companies: {
        type: "array",
        items: {
          $ref: "#/definitions/Company"
        }
      },
      jobs: {
        type: "array",
        items: {
          $ref: "#/definitions/Job"
        }
      },
      jobReviews: {
        type: "array",
        items: {
          $ref: "#/definitions/JobReviewCountry"
        }
      }
    }
  },
  Currency: {
    type: "object",
    properties: {
      code: {
        type: "string"
      },
      name: {
        type: "string"
      },
      symbol: {
        type: "string"
      },
      countries: {
        type: "array",
        items: {
          $ref: "#/definitions/Country"
        }
      }
    }
  },
  User: {
    type: "object",
    properties: {
      uid: {
        type: "string"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      email: {
        type: "string"
      },
      firstName: {
        type: "string"
      },
      lastName: {
        type: [
          "string",
          "null"
        ]
      },
      role: {
        type: [
          "string",
          "null"
        ],
        enum: [
          "staff",
          "manager",
          "finance",
          "admin"
        ]
      },
      disabled: {
        type: "boolean",
        default: !1
      },
      lang: {
        type: [
          "string",
          "null"
        ],
        enum: [
          "en",
          "es",
          "pt"
        ]
      },
      referralSource: {
        type: [
          "string",
          "null"
        ],
        enum: [
          "word_of_mouth",
          "codigo_m",
          "social",
          "google",
          "print",
          "tv",
          "radio",
          "other"
        ]
      },
      identifiesAsFemale: {
        type: [
          "boolean",
          "null"
        ]
      },
      dateOfBirth: {
        type: [
          "string",
          "null"
        ],
        format: "date-time"
      },
      identificationNumber: {
        type: [
          "string",
          "null"
        ]
      },
      mobileNumber: {
        type: [
          "string",
          "null"
        ]
      },
      github: {
        type: [
          "string",
          "null"
        ]
      },
      linkedin: {
        type: [
          "string",
          "null"
        ]
      },
      bio: {
        type: [
          "string",
          "null"
        ]
      },
      country: {
        anyOf: [
          {
            $ref: "#/definitions/Country"
          },
          {
            type: "null"
          }
        ]
      },
      signupCohort: {
        anyOf: [
          {
            $ref: "#/definitions/Cohort"
          },
          {
            type: "null"
          }
        ]
      },
      applications: {
        type: "array",
        items: {
          $ref: "#/definitions/Application"
        }
      },
      contractsAsCheckPilot: {
        type: "array",
        items: {
          $ref: "#/definitions/Contract"
        }
      },
      contracts: {
        type: "array",
        items: {
          $ref: "#/definitions/Contract"
        }
      },
      dropouts: {
        type: "array",
        items: {
          $ref: "#/definitions/Dropout"
        }
      },
      gigs: {
        type: "array",
        items: {
          $ref: "#/definitions/Gig"
        }
      },
      messages: {
        type: "array",
        items: {
          $ref: "#/definitions/Message"
        }
      },
      students: {
        type: "array",
        items: {
          $ref: "#/definitions/Student"
        }
      },
      activityLog: {
        type: "array",
        items: {
          $ref: "#/definitions/ActivityLogEntry"
        }
      },
      authoredActivityLog: {
        type: "array",
        items: {
          $ref: "#/definitions/ActivityLogEntry"
        }
      },
      jobReviews: {
        type: "array",
        items: {
          $ref: "#/definitions/JobReview"
        }
      },
      jobApplications: {
        type: "array",
        items: {
          $ref: "#/definitions/JobApplication"
        }
      }
    }
  },
  Track: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      name: {
        type: "string"
      },
      programs: {
        type: "array",
        items: {
          $ref: "#/definitions/Program"
        }
      },
      crawlerQueries: {
        type: "array",
        items: {
          $ref: "#/definitions/CrawlerQuery"
        }
      },
      jobProfileTypes: {
        type: "array",
        items: {
          $ref: "#/definitions/JobProfileType"
        }
      },
      jobReviews: {
        type: "array",
        items: {
          $ref: "#/definitions/JobReviewTrack"
        }
      },
      applicationChallenges: {
        type: "array",
        items: {
          $ref: "#/definitions/ApplicationChallengeTrack"
        }
      }
    }
  },
  Program: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      name: {
        type: "string"
      },
      description: {
        type: [
          "string",
          "null"
        ]
      },
      langs: {
        type: "array",
        enum: [
          "en",
          "es",
          "pt"
        ]
      },
      hidden: {
        type: "boolean",
        default: !1
      },
      track: {
        $ref: "#/definitions/Track"
      },
      cohorts: {
        type: "array",
        items: {
          $ref: "#/definitions/Cohort"
        }
      },
      stages: {
        type: "array",
        items: {
          $ref: "#/definitions/Stage"
        }
      }
    }
  },
  Stage: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      name: {
        type: "string"
      },
      order: {
        type: "integer"
      },
      program: {
        $ref: "#/definitions/Program"
      },
      cohorts: {
        type: "array",
        items: {
          $ref: "#/definitions/Cohort"
        }
      }
    }
  },
  Cohort: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      name: {
        type: "string"
      },
      lang: {
        type: [
          "string",
          "null"
        ],
        enum: [
          "en",
          "es",
          "pt"
        ]
      },
      start: {
        type: "string",
        format: "date-time"
      },
      end: {
        type: "string",
        format: "date-time"
      },
      timeZone: {
        type: [
          "string",
          "null"
        ]
      },
      startTime: {
        type: [
          "string",
          "null"
        ]
      },
      endTime: {
        type: [
          "string",
          "null"
        ]
      },
      legacySlug: {
        type: "string"
      },
      vacancies: {
        type: [
          "integer",
          "null"
        ]
      },
      admissionStart: {
        type: [
          "string",
          "null"
        ],
        format: "date-time"
      },
      admissionEnd: {
        type: [
          "string",
          "null"
        ],
        format: "date-time"
      },
      admissionCountries: {
        type: "array",
        items: {
          type: "string"
        }
      },
      placementStart: {
        type: [
          "string",
          "null"
        ],
        format: "date-time"
      },
      placementDuration: {
        type: [
          "integer",
          "null"
        ]
      },
      program: {
        $ref: "#/definitions/Program"
      },
      stage: {
        $ref: "#/definitions/Stage"
      },
      applications: {
        type: "array",
        items: {
          $ref: "#/definitions/Application"
        }
      },
      links: {
        type: "array",
        items: {
          $ref: "#/definitions/CohortLink"
        }
      },
      dropouts: {
        type: "array",
        items: {
          $ref: "#/definitions/Dropout"
        }
      },
      gigs: {
        type: "array",
        items: {
          $ref: "#/definitions/Gig"
        }
      },
      students: {
        type: "array",
        items: {
          $ref: "#/definitions/Student"
        }
      },
      signupUsers: {
        type: "array",
        items: {
          $ref: "#/definitions/User"
        }
      },
      activityLog: {
        type: "array",
        items: {
          $ref: "#/definitions/ActivityLogEntry"
        }
      },
      jobApplications: {
        type: "array",
        items: {
          $ref: "#/definitions/JobApplication"
        }
      }
    }
  },
  Student: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      legacyStudentCode: {
        type: [
          "string",
          "null"
        ]
      },
      cohort: {
        $ref: "#/definitions/Cohort"
      },
      user: {
        $ref: "#/definitions/User"
      },
      projecTeamMembers: {
        type: "array",
        items: {
          $ref: "#/definitions/StudentProjecTeamMember"
        }
      }
    }
  },
  CohortLink: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      url: {
        type: "string"
      },
      visibility: {
        type: "string",
        enum: [
          "public",
          "members",
          "staff",
          "team",
          "admin"
        ]
      },
      cohort: {
        $ref: "#/definitions/Cohort"
      }
    }
  },
  Dropout: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      date: {
        type: "string",
        format: "date-time"
      },
      reasonDetail: {
        type: [
          "string",
          "null"
        ]
      },
      notes: {
        type: [
          "string",
          "null"
        ]
      },
      staffSad: {
        type: "boolean"
      },
      covidRelated: {
        type: [
          "boolean",
          "null"
        ]
      },
      reason: {
        type: "string",
        enum: [
          "dropout",
          "noShow",
          "invitedToLeave",
          "changeCohort"
        ]
      },
      completedProjects: {
        type: "integer"
      },
      lastProject: {
        type: [
          "string",
          "null"
        ]
      },
      cohort: {
        $ref: "#/definitions/Cohort"
      },
      user: {
        $ref: "#/definitions/User"
      }
    }
  },
  IscedLevel: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      label: {
        type: "string"
      },
      educationLevels: {
        type: "array",
        items: {
          $ref: "#/definitions/EducationLevel"
        }
      }
    }
  },
  EducationLevel: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      lang: {
        type: "string",
        enum: [
          "en",
          "es",
          "pt"
        ]
      },
      label: {
        type: "string"
      },
      country: {
        $ref: "#/definitions/Country"
      },
      iscedLevel: {
        $ref: "#/definitions/IscedLevel"
      },
      applications: {
        type: "array",
        items: {
          $ref: "#/definitions/Application"
        }
      }
    }
  },
  University: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      lang: {
        type: "string",
        enum: [
          "en",
          "es",
          "pt"
        ]
      },
      name: {
        type: "string"
      },
      filter: {
        type: "boolean"
      },
      country: {
        $ref: "#/definitions/Country"
      },
      applications: {
        type: "array",
        items: {
          $ref: "#/definitions/Application"
        }
      }
    }
  },
  Application: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      dateOfBirth: {
        type: "string",
        format: "date-time"
      },
      isAllowedToWork: {
        type: "boolean"
      },
      hasValidIdDocument: {
        type: "boolean"
      },
      locality: {
        type: [
          "number",
          "string",
          "boolean",
          "object",
          "array",
          "null"
        ]
      },
      householdSize: {
        type: "integer"
      },
      children: {
        type: "integer"
      },
      householdIncome: {
        type: "integer"
      },
      racialIdentity: {
        type: [
          "string",
          "null"
        ]
      },
      schoolType: {
        type: [
          "string",
          "null"
        ],
        enum: [
          "private",
          "public",
          "other",
          "subsidized",
          "mixed"
        ]
      },
      educationSubject: {
        type: [
          "string",
          "null"
        ],
        enum: [
          "design_and_media",
          "software_engineering",
          "engineering",
          "management_and_business",
          "languages",
          "science",
          "health",
          "social_sciences",
          "arts",
          "comms_and_advertising",
          "education",
          "cooking",
          "tourism",
          "economics_and_accounting",
          "law",
          "other"
        ]
      },
      isStudying: {
        type: "boolean"
      },
      englishLevel: {
        type: [
          "string",
          "null"
        ],
        enum: [
          "NO",
          "A1",
          "A2",
          "B1",
          "B2",
          "C1",
          "C2"
        ]
      },
      workStatus: {
        type: "string",
        enum: [
          "never",
          "not_now",
          "yes"
        ]
      },
      isLookingForWork: {
        type: [
          "boolean",
          "null"
        ]
      },
      monthsLookingForWork: {
        type: [
          "integer",
          "null"
        ]
      },
      monthsUnemployed: {
        type: [
          "integer",
          "null"
        ]
      },
      workRole: {
        type: [
          "string",
          "null"
        ],
        enum: [
          "waitress",
          "promoter",
          "manager",
          "cashier",
          "intern",
          "operative",
          "call_center",
          "receptionist",
          "sales_agent",
          "assistant",
          "professional",
          "technical",
          "consultant",
          "other"
        ]
      },
      freelance: {
        type: [
          "boolean",
          "null"
        ]
      },
      workFormal: {
        type: [
          "boolean",
          "null"
        ]
      },
      workIncome: {
        type: [
          "integer",
          "null"
        ]
      },
      failedFilters: {
        type: "array",
        items: {
          type: "string"
        }
      },
      bypassFilters: {
        type: "boolean",
        default: !1
      },
      isReady: {
        type: "boolean",
        default: !1
      },
      isReturningApplicant: {
        type: [
          "boolean",
          "null"
        ]
      },
      legacyAdmissionCohortSlug: {
        type: [
          "string",
          "null"
        ]
      },
      cohort: {
        $ref: "#/definitions/Cohort"
      },
      user: {
        $ref: "#/definitions/User"
      },
      country: {
        $ref: "#/definitions/Country"
      },
      nationality: {
        $ref: "#/definitions/Country"
      },
      educationLevel: {
        $ref: "#/definitions/EducationLevel"
      },
      university: {
        anyOf: [
          {
            $ref: "#/definitions/University"
          },
          {
            type: "null"
          }
        ]
      },
      challengeAssignments: {
        type: "array",
        items: {
          $ref: "#/definitions/ApplicationChallengeAssignment"
        }
      }
    },
    config: {
      maxAge: 120
    }
  },
  ApplicationChallenge: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      slug: {
        type: "string"
      },
      version: {
        type: "string"
      },
      trackId: {
        type: "integer"
      },
      tracks: {
        type: "array",
        items: {
          $ref: "#/definitions/ApplicationChallengeTrack"
        }
      },
      langs: {
        type: "array",
        enum: [
          "en",
          "es",
          "pt"
        ]
      },
      json: {
        type: "string"
      },
      archived: {
        type: "boolean",
        default: !1
      },
      assignments: {
        type: "array",
        items: {
          $ref: "#/definitions/ApplicationChallengeAssignment"
        }
      }
    }
  },
  ApplicationChallengeAssignment: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      application: {
        $ref: "#/definitions/Application"
      },
      challenge: {
        $ref: "#/definitions/ApplicationChallenge"
      }
    }
  },
  ApplicationChallengeTrack: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      applicationChallenge: {
        $ref: "#/definitions/ApplicationChallenge"
      },
      track: {
        $ref: "#/definitions/Track"
      }
    }
  },
  ActivityLogEntry: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      type: {
        type: "string",
        enum: [
          "challenge",
          "application_filter",
          "application_filter_bypass",
          "application_cohort_change",
          "project_assessment",
          "project_assessment_request",
          "project_assessment_assignment",
          "project_assessment_bypass"
        ]
      },
      data: {
        type: [
          "number",
          "string",
          "boolean",
          "object",
          "array",
          "null"
        ]
      },
      path: {
        type: "string"
      },
      author: {
        $ref: "#/definitions/User"
      },
      user: {
        $ref: "#/definitions/User"
      },
      cohort: {
        $ref: "#/definitions/Cohort"
      }
    }
  },
  StudentProject: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: "string"
      },
      projectSlug: {
        type: "string"
      },
      projectVersion: {
        type: "string"
      },
      projectVariant: {
        type: [
          "string",
          "null"
        ]
      },
      links: {
        type: "array",
        items: {
          $ref: "#/definitions/StudentProjectLink"
        }
      },
      team: {
        type: "array",
        items: {
          $ref: "#/definitions/StudentProjecTeamMember"
        }
      }
    }
  },
  StudentProjecTeamMember: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: "string"
      },
      studentProject: {
        $ref: "#/definitions/StudentProject"
      },
      student: {
        $ref: "#/definitions/Student"
      }
    }
  },
  StudentProjectLink: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: "string"
      },
      url: {
        type: "string"
      },
      studentProject: {
        $ref: "#/definitions/StudentProject"
      }
    }
  },
  Contract: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: "string"
      },
      isEmployment: {
        type: "boolean"
      },
      feeAmount: {
        type: "integer"
      },
      hoursPerWeek: {
        type: "integer"
      },
      start: {
        type: "string",
        format: "date-time"
      },
      end: {
        type: [
          "string",
          "null"
        ],
        format: "date-time"
      },
      isTrial: {
        type: "boolean",
        default: !1
      },
      source: {
        type: [
          "string",
          "null"
        ],
        enum: [
          "graduate",
          "referral",
          "jazzhr",
          "web",
          "linkedin",
          "other"
        ]
      },
      checkPilot: {
        anyOf: [
          {
            $ref: "#/definitions/User"
          },
          {
            type: "null"
          }
        ]
      },
      country: {
        $ref: "#/definitions/Country"
      },
      user: {
        $ref: "#/definitions/User"
      },
      gigs: {
        type: "array",
        items: {
          $ref: "#/definitions/Gig"
        }
      }
    }
  },
  Gig: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: "string"
      },
      role: {
        type: "string",
        enum: [
          "bm",
          "pdc",
          "js",
          "ux"
        ]
      },
      hoursPerWeek: {
        type: "integer"
      },
      start: {
        type: "string",
        format: "date-time"
      },
      end: {
        type: [
          "string",
          "null"
        ],
        format: "date-time"
      },
      cohort: {
        $ref: "#/definitions/Cohort"
      },
      contract: {
        $ref: "#/definitions/Contract"
      },
      user: {
        $ref: "#/definitions/User"
      }
    }
  },
  Message: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      key: {
        type: "string"
      },
      from: {
        type: "string"
      },
      to: {
        type: "string"
      },
      transport: {
        type: "string",
        enum: [
          "mandrill",
          "slack"
        ]
      },
      status: {
        type: "string",
        default: "PENDING",
        enum: [
          "PENDING",
          "QUEUED",
          "ERROR",
          "SENT"
        ]
      },
      data: {
        type: [
          "number",
          "string",
          "boolean",
          "object",
          "array",
          "null"
        ]
      },
      taskInfo: {
        type: [
          "number",
          "string",
          "boolean",
          "object",
          "array",
          "null"
        ]
      },
      user: {
        anyOf: [
          {
            $ref: "#/definitions/User"
          },
          {
            type: "null"
          }
        ]
      },
      logs: {
        type: "array",
        items: {
          $ref: "#/definitions/MessageLog"
        }
      }
    }
  },
  MessageLog: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      statusText: {
        type: [
          "string",
          "null"
        ]
      },
      message: {
        $ref: "#/definitions/Message"
      }
    }
  },
  Industry: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      name: {
        type: "string"
      },
      companies: {
        type: "array",
        items: {
          $ref: "#/definitions/Company"
        }
      }
    }
  },
  Company: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      source: {
        type: "string"
      },
      sourceId: {
        type: "string"
      },
      name: {
        type: "string"
      },
      size: {
        type: [
          "string",
          "null"
        ],
        enum: [
          "A_2_10",
          "B_11_50",
          "C_51_200",
          "D_201_500",
          "E_501_1000",
          "F_1001_5000",
          "G_5001_10000",
          "H_10001_plus"
        ]
      },
      data: {
        type: [
          "number",
          "string",
          "boolean",
          "object",
          "array",
          "null"
        ]
      },
      web: {
        type: [
          "string",
          "null"
        ]
      },
      twitter: {
        type: [
          "string",
          "null"
        ]
      },
      github: {
        type: [
          "string",
          "null"
        ]
      },
      facebook: {
        type: [
          "string",
          "null"
        ]
      },
      country: {
        anyOf: [
          {
            $ref: "#/definitions/Country"
          },
          {
            type: "null"
          }
        ]
      },
      industry: {
        anyOf: [
          {
            $ref: "#/definitions/Industry"
          },
          {
            type: "null"
          }
        ]
      },
      jobs: {
        type: "array",
        items: {
          $ref: "#/definitions/Job"
        }
      },
      categories: {
        type: "array",
        enum: [
          "Tech_Consultancy",
          "Digital_Transformation",
          "Agency",
          "Startups",
          "High_tech",
          "Traditional_Consulting"
        ]
      }
    }
  },
  Job: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      source: {
        type: "string"
      },
      sourceId: {
        type: "string"
      },
      title: {
        type: "string"
      },
      publishedAt: {
        type: "string",
        format: "date-time"
      },
      modality: {
        type: "string"
      },
      publicUrl: {
        type: [
          "string",
          "null"
        ]
      },
      location: {
        type: [
          "string",
          "null"
        ]
      },
      data: {
        type: [
          "number",
          "string",
          "boolean",
          "object",
          "array",
          "null"
        ]
      },
      description: {
        type: [
          "string",
          "null"
        ]
      },
      descriptionHTML: {
        type: [
          "string",
          "null"
        ]
      },
      functions: {
        type: [
          "string",
          "null"
        ]
      },
      functionsHTML: {
        type: [
          "string",
          "null"
        ]
      },
      seniority: {
        type: [
          "string",
          "null"
        ]
      },
      remote: {
        type: [
          "boolean",
          "null"
        ]
      },
      remoteOption: {
        type: [
          "string",
          "null"
        ],
        enum: [
          "remote_for_now",
          "locally_remote",
          "fully_remote",
          "no_remote",
          "mixed"
        ]
      },
      lang: {
        type: [
          "string",
          "null"
        ],
        enum: [
          "en",
          "es",
          "pt"
        ]
      },
      maxSalary: {
        type: [
          "integer",
          "null"
        ]
      },
      minSalary: {
        type: [
          "integer",
          "null"
        ]
      },
      minExperience: {
        type: [
          "integer",
          "null"
        ]
      },
      maxExperience: {
        type: [
          "integer",
          "null"
        ]
      },
      tags: {
        type: "array",
        items: {
          type: "string"
        }
      },
      company: {
        $ref: "#/definitions/Company"
      },
      country: {
        anyOf: [
          {
            $ref: "#/definitions/Country"
          },
          {
            type: "null"
          }
        ]
      },
      reviews: {
        type: "array",
        items: {
          $ref: "#/definitions/JobReview"
        }
      },
      applications: {
        type: "array",
        items: {
          $ref: "#/definitions/JobApplication"
        }
      },
      crawlerQueries: {
        type: "array",
        items: {
          $ref: "#/definitions/JobCrawlerQuery"
        }
      },
      crawlerLocations: {
        type: "array",
        items: {
          $ref: "#/definitions/JobCrawlerLocation"
        }
      }
    }
  },
  JobProfileType: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      name: {
        type: "string"
      },
      learningObjectives: {
        type: [
          "number",
          "string",
          "boolean",
          "object",
          "array",
          "null"
        ]
      },
      track: {
        anyOf: [
          {
            $ref: "#/definitions/Track"
          },
          {
            type: "null"
          }
        ]
      },
      reviews: {
        type: "array",
        items: {
          $ref: "#/definitions/JobReviewProfileType"
        }
      }
    }
  },
  JobReview: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      isValid: {
        type: "boolean"
      },
      invalidReason: {
        type: [
          "string",
          "null"
        ],
        enum: [
          "unrelated",
          "experience",
          "qualifications",
          "other"
        ]
      },
      comment: {
        type: [
          "string",
          "null"
        ]
      },
      author: {
        $ref: "#/definitions/User"
      },
      job: {
        $ref: "#/definitions/Job"
      },
      profileTypes: {
        type: "array",
        items: {
          $ref: "#/definitions/JobReviewProfileType"
        }
      },
      validCountries: {
        type: "array",
        items: {
          $ref: "#/definitions/JobReviewCountry"
        }
      },
      validTracks: {
        type: "array",
        items: {
          $ref: "#/definitions/JobReviewTrack"
        }
      }
    }
  },
  JobReviewProfileType: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      review: {
        $ref: "#/definitions/JobReview"
      },
      profileType: {
        $ref: "#/definitions/JobProfileType"
      }
    }
  },
  JobApplication: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      status: {
        type: "string",
        default: "pending",
        enum: [
          "pending",
          "applied",
          "interview",
          "challenge",
          "followup",
          "hired",
          "not_hired"
        ]
      },
      hireDate: {
        type: [
          "string",
          "null"
        ],
        format: "date-time"
      },
      jobStartDate: {
        type: [
          "string",
          "null"
        ],
        format: "date-time"
      },
      netSalary: {
        type: [
          "integer",
          "null"
        ]
      },
      grossSalary: {
        type: [
          "integer",
          "null"
        ]
      },
      currency: {
        type: [
          "string",
          "null"
        ]
      },
      job: {
        $ref: "#/definitions/Job"
      },
      user: {
        $ref: "#/definitions/User"
      },
      cohort: {
        anyOf: [
          {
            $ref: "#/definitions/Cohort"
          },
          {
            type: "null"
          }
        ]
      }
    }
  },
  CrawlerQuery: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      query: {
        type: "string"
      },
      enabled: {
        type: "boolean",
        default: !0
      },
      track: {
        $ref: "#/definitions/Track"
      },
      jobs: {
        type: "array",
        items: {
          $ref: "#/definitions/JobCrawlerQuery"
        }
      }
    }
  },
  JobCrawlerQuery: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      job: {
        $ref: "#/definitions/Job"
      },
      query: {
        $ref: "#/definitions/CrawlerQuery"
      }
    }
  },
  CrawlerLocation: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      name: {
        type: "string"
      },
      enabled: {
        type: "boolean",
        default: !0
      },
      jobs: {
        type: "array",
        items: {
          $ref: "#/definitions/JobCrawlerLocation"
        }
      }
    }
  },
  JobCrawlerLocation: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      job: {
        $ref: "#/definitions/Job"
      },
      location: {
        $ref: "#/definitions/CrawlerLocation"
      }
    }
  },
  JobReviewCountry: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      review: {
        $ref: "#/definitions/JobReview"
      },
      country: {
        $ref: "#/definitions/Country"
      }
    }
  },
  JobReviewTrack: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      review: {
        $ref: "#/definitions/JobReview"
      },
      track: {
        $ref: "#/definitions/Track"
      }
    }
  },
  JobSeenLocation: {
    type: "object",
    properties: {
      id: {
        type: "integer"
      },
      createdAt: {
        type: "string",
        format: "date-time"
      },
      updatedAt: {
        type: "string",
        format: "date-time"
      },
      createdBy: {
        type: [
          "string",
          "null"
        ]
      },
      location: {
        type: "string"
      },
      seenTimes: {
        type: "integer",
        default: 1
      }
    }
  }
}, ea = "object", ta = {
  country: {
    $ref: "#/definitions/Country"
  },
  currency: {
    $ref: "#/definitions/Currency"
  },
  user: {
    $ref: "#/definitions/User"
  },
  track: {
    $ref: "#/definitions/Track"
  },
  program: {
    $ref: "#/definitions/Program"
  },
  stage: {
    $ref: "#/definitions/Stage"
  },
  cohort: {
    $ref: "#/definitions/Cohort"
  },
  student: {
    $ref: "#/definitions/Student"
  },
  cohortLink: {
    $ref: "#/definitions/CohortLink"
  },
  dropout: {
    $ref: "#/definitions/Dropout"
  },
  iscedLevel: {
    $ref: "#/definitions/IscedLevel"
  },
  educationLevel: {
    $ref: "#/definitions/EducationLevel"
  },
  university: {
    $ref: "#/definitions/University"
  },
  application: {
    $ref: "#/definitions/Application"
  },
  applicationChallenge: {
    $ref: "#/definitions/ApplicationChallenge"
  },
  applicationChallengeAssignment: {
    $ref: "#/definitions/ApplicationChallengeAssignment"
  },
  applicationChallengeTrack: {
    $ref: "#/definitions/ApplicationChallengeTrack"
  },
  activityLogEntry: {
    $ref: "#/definitions/ActivityLogEntry"
  },
  studentProject: {
    $ref: "#/definitions/StudentProject"
  },
  studentProjecTeamMember: {
    $ref: "#/definitions/StudentProjecTeamMember"
  },
  studentProjectLink: {
    $ref: "#/definitions/StudentProjectLink"
  },
  contract: {
    $ref: "#/definitions/Contract"
  },
  gig: {
    $ref: "#/definitions/Gig"
  },
  message: {
    $ref: "#/definitions/Message"
  },
  messageLog: {
    $ref: "#/definitions/MessageLog"
  },
  industry: {
    $ref: "#/definitions/Industry"
  },
  company: {
    $ref: "#/definitions/Company"
  },
  job: {
    $ref: "#/definitions/Job"
  },
  jobProfileType: {
    $ref: "#/definitions/JobProfileType"
  },
  jobReview: {
    $ref: "#/definitions/JobReview"
  },
  jobReviewProfileType: {
    $ref: "#/definitions/JobReviewProfileType"
  },
  jobApplication: {
    $ref: "#/definitions/JobApplication"
  },
  crawlerQuery: {
    $ref: "#/definitions/CrawlerQuery"
  },
  jobCrawlerQuery: {
    $ref: "#/definitions/JobCrawlerQuery"
  },
  crawlerLocation: {
    $ref: "#/definitions/CrawlerLocation"
  },
  jobCrawlerLocation: {
    $ref: "#/definitions/JobCrawlerLocation"
  },
  jobReviewCountry: {
    $ref: "#/definitions/JobReviewCountry"
  },
  jobReviewTrack: {
    $ref: "#/definitions/JobReviewTrack"
  },
  jobSeenLocation: {
    $ref: "#/definitions/JobSeenLocation"
  }
}, ot = {
  $schema: Xo,
  definitions: Zo,
  type: ea,
  properties: ta
}, na = 60 * 60 * 1e3, Gt = 24 * na, ra = {
  Country: {
    primaryKey: "code",
    plural: "countries",
    inputProps: [
      "name",
      "incomeFilter",
      "currency",
      "canApply",
      "flag"
    ],
    searchProps: ["code", "name", "timeZone"],
    defaultProps: ["code", "name", "timeZone", "currency"],
    getOptionLabel: ({ code: n, name: e }) => `${n} / ${e}`
  },
  Currency: {
    primaryKey: "code",
    plural: "currencies",
    searchProps: ["code", "name"],
    defaultProps: ["code", "name", "symbol"]
  },
  ActivityLogEntry: {
    plural: "activityLog"
  },
  User: {
    primaryKey: "uid",
    inputProps: [
      "firstName",
      "lastName",
      "email",
      "password",
      "lang",
      "identifiesAsFemale",
      "dateOfBirth",
      "country",
      "identificationNumber",
      "mobileNumber",
      "github",
      "linkedin",
      "bio",
      "role",
      "signupCohort",
      "disabled",
      "referralSource"
    ],
    searchProps: ["firstName", "lastName", "email"],
    getOptionLabel: ({ firstName: n, lastName: e, email: t }) => `${n} ${e} (${t})`,
    properties: {
      email: {
        inputType: "email"
      },
      lastName: {
        isRequired: !0
      },
      mobileNumber: {
        inputType: "phone"
      },
      bio: {
        inputType: "textarea"
      }
    },
    parse: (n) => {
      const e = n.github ? `https://github.com/${n.github}.png?size=` : `https://www.gravatar.com/avatar/${Ho(n.email)}?s=`;
      return {
        ...n,
        fullName: `${n.firstName || ""}${n.lastName ? ` ${n.lastName}` : ""}`,
        avatar: (t) => `${e}${t}`,
        isStaff: ["staff", "manager", "finance", "admin"].includes(n.role),
        isManager: ["manager", "finance", "admin"].includes(n.role),
        isFinance: ["finance", "admin"].includes(n.role),
        isAdmin: n.role === "admin"
      };
    }
  },
  Track: {
    inputProps: ["name"],
    searchProps: ["name"]
  },
  Program: {
    inputProps: [
      "track",
      "name",
      "description",
      "langs",
      "hidden"
    ],
    searchProps: ["name"]
  },
  Stage: {
    searchProps: ["name"]
  },
  Cohort: {
    inputProps: [
      "program",
      "stage",
      "lang",
      "name",
      "start",
      "end",
      "timeZone",
      "startTime",
      "endTime",
      "vacancies",
      "admissionStart",
      "admissionEnd",
      "placementStart",
      "admissionCountries",
      "links"
    ],
    searchProps: ["name"],
    getOptionLabel: ({ id: n, name: e, stage: t }) => `${e}${t ? ` - ${t.name}` : ""} (id: ${n})`,
    properties: {},
    // Status:
    // - `draft`: El cohort todavía no tiene fecha de inicio o fin de admisión.
    // - `planned`: El cohort ya tiene fechas de inicio y fin de admisión, pero el
    //   período de admisiones todavía no ha comenzado.
    // - `admission_started`: El periodo de admisión está abierto.
    // - `admission_ended`: El período de admisión ya terminó, pero todavía no
    //   comienza el bootcamp.
    // - `started`: El cohort está en período de bootcamp.
    // - `ended`: El cohort ya terminó su bootcamp.
    // - `placement_started`: El cohort se encuentra en período de placement (aka
    //   _placement_season_).
    // - `placement_ended`: El período de placement ya terminó.
    parse: (n) => {
      var s, o;
      const e = Date.now();
      let t;
      if (n.placementStart) {
        const a = n.placementDuration || 270;
        new Date(
          +n.placementStart + a * 24 * 60 * 60 * 1e3
        ) < e ? t = "placement_ended" : n.placementStart < e && (t = "placement_started");
      }
      !t && n.end < e && (t = "ended"), !t && n.start < e && (t = "started");
      const r = n.admissionEnd ? +n.admissionEnd + Gt : !1;
      !t && r && r < e && (t = "admission_ended"), !t && n.admissionStart && n.admissionStart < e && (t = "admission_started"), !t && n.admissionStart && n.admissionEnd && (t = "planned"), t || (t = "draft");
      const i = n.start > e && n.vacancies ? n.vacancies : ((s = n._count) == null ? void 0 : s.students) || ((o = n.students) == null ? void 0 : o.length) || 0;
      return {
        ...n,
        status: t,
        size: i
      };
    }
  },
  Student: {
    inputProps: [
      "cohort",
      "user"
    ],
    searchProps: [
      "user.firstName",
      "user.lastName",
      "user.email"
    ],
    defaultProps: [
      "id",
      "cohort",
      "user"
    ],
    getOptionLabel: ({ user: n, cohort: e }) => `${n == null ? void 0 : n.firstName} ${(n == null ? void 0 : n.lastName) || ""} (${e == null ? void 0 : e.name})`
  },
  Dropout: {
    inputProps: [
      "cohort",
      "user",
      "date",
      "reason",
      "reasonDetail",
      "lastProject",
      "completedProjects",
      "notes",
      "staffSad",
      "covidRelated"
    ],
    searchProps: [
      "user.uid",
      "user.firstName",
      "user.lastName",
      "user.email",
      "cohort.name"
    ]
  },
  Contract: {
    inputProps: [
      "user",
      "country",
      "isEmployment",
      "feeAmount",
      "hoursPerWeek",
      "start",
      "end",
      "isTrial",
      "checkPilot",
      "source"
    ],
    searchProps: [
      "user.firstName",
      "user.lastName",
      "user.email"
    ],
    getOptionLabel: ({ id: n, user: e }) => `${e == null ? void 0 : e.firstName} (id: ${n})`
  },
  Gig: {
    inputProps: [
      "cohort",
      "user",
      "contract",
      "role",
      "hoursPerWeek",
      "start",
      "end"
    ]
  },
  Application: {
    inputProps: [
      "user",
      "cohort",
      "dateOfBirth",
      "country",
      "locality",
      "nationality",
      "isAllowedToWork",
      "hasValidIdDocument",
      "householdSize",
      "children",
      "householdIncome",
      "racialIdentity",
      "educationLevel",
      "schoolType",
      "educationSubject",
      "university",
      "isStudying",
      "englishLevel",
      "workStatus",
      "isLookingForWork",
      "monthsLookingForWork",
      "monthsUnemployed",
      "workRole",
      "freelance",
      "workFormal",
      "workIncome",
      "isReady",
      "bypassFilters"
    ],
    properties: {
      locality: {
        isRequired: !0
      },
      englishLevel: {
        isRequired: !0
      },
      isReady: {
        isRequired: !1
      },
      bypassFilters: {
        isRequired: !1
      }
    },
    // Status:
    // - `active`: Postulación en progreso.
    // - `rejected`: Postulación rechazada por filtros (ingresos y/o educación).
    // - `ready`: Retos completados y postulación _enviada_ (confirmada).
    //   Llegado a este estado se considera que la postulación está lista para
    //   el siguiente paso, por ejemplo entrevista.
    // - `admission_ended`: Período de admisión del cohort seleccionado ya ha
    //   terminado, pero la postulación todavía no ha expirado, así que la
    //   postulante todavía puede continuar cambiando de cohort, siempre y
    //   cuando haya uno abierto dentro del período de validez de
    //   Application.config.maxAge días desde la creación de la postulación.
    // - `expired`: Se pasaron los Application.config.maxAge días. La
    //   postulación ya no puede ser
    //   completada.
    // - `cancelled`: La postulante canceló su propia postulación. (Todavía no
    //   implementado).
    parse: (n) => {
      var s, o, a;
      const e = typeof n.hasFailedFilters == "boolean" ? n.hasFailedFilters : typeof ((s = n.failedFilters) == null ? void 0 : s.length) == "number" ? n.failedFilters.length > 0 : void 0;
      if (!((o = n.cohort) != null && o.admissionEnd) || typeof e > "u")
        return n;
      const t = Date.now(), { maxAge: r } = ot.definitions.Application.config;
      let i;
      return n.isReady ? i = "ready" : e && !n.bypassFilters ? i = "rejected" : n.createdAt < t - r * Gt ? i = "expired" : ((a = n.cohort) == null ? void 0 : a.status) !== "admission_started" ? i = "admission_ended" : i = "active", {
        ...n,
        status: i
      };
    }
  },
  IscedLevel: {
    parse: (n) => {
      const e = Math.floor(n.id / 10);
      return {
        ...n,
        level: e,
        completed: e * 10 < n.id
      };
    }
  },
  EducationLevel: {
    searchProps: [
      "label"
    ]
  },
  University: {
    plural: "universities",
    searchProps: ["name"]
  },
  Company: {
    plural: "companies"
  },
  CrawlerQuery: {
    plural: "crawlerQueries"
  },
  JobCrawlerQuery: {
    plural: "jobCrawlerQueries"
  }
}, ia = (n, e) => ({
  ...Yo(n, e, {
    ...ot,
    definitions: Qo(ot, ra)
  }),
  gcpLog: {
    getEntries: async (t) => await _t(n, e.authUser)(`/gcp-logs?q=${JSON.stringify(t)}`)
  }
}), Kt = (n) => typeof n == "string" ? { id: n } : n, Yt = (n) => {
  var t;
  const e = {
    ...n,
    ...!!n.learningObjectives && {
      learningObjectives: n.learningObjectives.map(Kt)
    },
    ...!!((t = n.variants) != null && t.length) && {
      variants: n.variants.map((r) => {
        var i;
        return {
          ...r,
          learningObjectives: (i = r.learningObjectives) == null ? void 0 : i.map(Kt)
        };
      })
    }
  };
  return Object.assign(e, {
    getCombinedLearningObjectives: (r) => {
      var c, u;
      if (!r && !((c = e.variants) != null && c.length))
        return e.learningObjectives || [];
      const i = (u = e.variants) == null ? void 0 : u.find(({ name: y }) => y === r);
      if (!i)
        throw new Error(`Variant ${r} not found`);
      const { include: s, exclude: o } = ((i == null ? void 0 : i.learningObjectives) || []).reduce(
        (y, b) => b.exclude ? { ...y, exclude: [...y.exclude, b.id] } : { ...y, include: [...y.include, b] },
        { include: [], exclude: [] }
      ), a = (e.learningObjectives || []).filter(
        (y) => !o.includes(y.id)
      );
      return [
        ...s,
        ...a
      ];
    }
  });
}, sa = (n, e) => {
  const t = _t(n, e.authUser);
  return {
    project: {
      findMany: (r = {}) => t(`/projects?q=${JSON.stringify(r)}`).then((i) => i.map(Yt)),
      findBySlug: (r, i = {}) => t(`/projects/${r}?q=${JSON.stringify(i)}`).then(Yt)
    },
    topic: {
      findMany: (r = {}) => t(`/topics?q=${JSON.stringify(r)}`),
      findBySlug: (r, i = {}) => t(`/topics/${r}?q=${JSON.stringify(i)}`)
    },
    learningObjective: {
      findMany: (r = {}) => t(`/learning-objectives?q=${JSON.stringify(r)}`)
    }
  };
}, je = (n) => n > 9 ? `${n}` : `0${n}`, oa = (n) => `${je(n.getUTCDate())}/${je(n.getUTCMonth() + 1)}/${n.getUTCFullYear()}`, aa = (n) => `${je(n.getUTCHours())}:${je(n.getUTCMinutes())}:${n.getUTCSeconds()} UTC`, da = (n) => `${oa(n)} ${aa(n)}`, ca = {
  es: "es-ES",
  pt: "pt-BR"
}, ua = (n, e = "es", t = !1) => new Intl.DateTimeFormat(ca[e], {
  ...t && {
    year: "numeric"
  },
  month: "long",
  day: "numeric",
  timeZone: "UTC"
}).format(new Date(n)), ha = (n, e) => {
  let t = e.getFullYear() - n.getFullYear();
  const r = e.getMonth() - n.getMonth();
  return (r < 0 || r === 0 && e.getDate() < n.getDate()) && t--, t;
}, la = (n, e, t) => {
  const r = (i) => new Intl.NumberFormat(
    `${i}-${e}`,
    { currency: t }
  );
  return r(e === "CR" ? "en" : n);
}, fa = (n, e, t, r) => la(
  e,
  t,
  r
).format(n), pa = (n) => parseInt(n.replace(/[,\.]/g, ""), 10), ga = (n) => {
  try {
    return JSON.parse(window.localStorage.getItem(n));
  } catch {
    return null;
  }
}, ma = ({
  firebaseApiKey: n = "AIzaSyAXbaEbpq8NOfn0r8mIrcoHvoGRkJThwdc",
  firebaseProject: e = "laboratoria-la",
  coreApiUrl: t = "https://us-central1-outpost-272720.cloudfunctions.net/core-api"
} = {}) => {
  const r = cn({
    apiKey: n,
    authDomain: `${e}.firebaseapp.com`,
    databaseURL: `https://${e}.firebaseio.com`,
    projectId: e
  }), i = Uo(r), s = { authUser: void 0, user: void 0 }, o = ia(t, s);
  return {
    ...sa(t, s),
    ...o,
    auth: {
      onChange: (u) => Es(i, (y) => {
        if (!y)
          return Object.assign(s, { authUser: null, user: null }), u(s);
        Object.assign(s, { authUser: y }), o.user.findById(y.uid).then((b) => {
          Object.assign(s, { user: b }), u(s);
        }).catch((b) => {
          console.error(b), Object.assign(s, { authUser: null, user: null }), u(s);
        });
      }),
      signIn: (u, y) => bs(
        i,
        u,
        y
      ),
      signOut: () => Ts(i),
      sendPasswordResetEmail: (u) => vs(i, u)
    },
    firebaseApp: r
  };
};
export {
  ma as createApp,
  fa as formatCurrency,
  oa as formatDate,
  da as formatDateTime,
  ua as formatMonth,
  aa as formatTime,
  ha as getAgeAt,
  ga as loadFromLocalStorage,
  pa as parseCurrency,
  Yt as parseProject
};
